  import { Modal, Group,Image ,Text, Button, Container, Card, Select, MultiSelect, Input, Divider, Space, Table, Flex, Box, Checkbox, ActionIcon, Title, Switch, TextInput, LoadingOverlay, Accordion, Radio, Stack, Tooltip, Popover, Anchor } from '@mantine/core';
import { IconChevronDown, IconChevronRight, IconCheck, IconCaretUpFilled, IconCaretDownFilled, IconCaretRightFilled, IconClockHour4, IconX, IconBrandFacebook, IconBrandGoogle, IconBrandWindows, IconBrandTiktok, IconArrowRight, IconBrandLinkedin, IconClock, IconChartBar, IconInfoCircle, IconBrandOpenai } from '@tabler/icons-react';
import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import { modals } from '@mantine/modals';
import { useNavigate, useParams } from 'react-router-dom';
import { Chart } from "react-google-charts";
import { useDocumentTitle } from '@mantine/hooks';
import { HeaderMenu } from "../../components/HeaderMenu/HeaderMenu";
import CampaignReport from "../../api/CampaignReport";
import { CampaignSetting } from "../../components/CreateReport/CampaignSetting";
import { BehavioralDimensions } from '../../components/CreateReport/BehavioralDimensions';
import { ReportVelocityDrawer } from '../../components/CreateReport/ReportVelocityDrawer';
import { ReportKeywordDrawer } from '../../components/CreateReport/ReportKeywordDrawer';
import { AdKeywordDrawer } from '../../components/CreateReport/AdKeywordDrawer';
import { AdPreviewDrawer } from '../../components/CreateReport/AdPreviewDrawer';
import { ResetStats } from "../../components/CreateReport/ResetStats";
import { CustomerJourney } from "../../components/CreateReport/CustomerJourney";
import { VariationAdsModal } from "../../components/CreateReport/VariationAdsModal";
import { SelectMetrics } from "../../components/CreateReport/SelectMetrics";
import { Benchmarks } from "../../components/CreateReport/Benchmarks";
import { LifecycleAnalysisReport } from "../../components/CreateReport/LifecycleAnalysisReport";
import { VisiLoader, SelectTimePicker, useColorScheme, ReportChartStyle, HelpTip } from "../../components/GeneralComponent/GeneralComponent";
import { notifications } from '@mantine/notifications';
import './CreateReport.css';
import { useAuth } from "../../AuthContext";
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';

export function CreateReport() {
  useDocumentTitle("Visiopt - Report");
  const { Permissions, hasPermission } = useAuth();
  const navigate = useNavigate();
  let { reportId } = useParams();  /*GET REPORT ID FROM CAMPAIGN REPORT*/
  reportId = reportId === 'new' ? '' : reportId;
  const [updateReportId, setUpdateReportId] = useState('');
  const [isVisiLoaderVisible, setIsVisiLoaderVisible] = useState(false);
  const [selectedMemberWebsite, setSelectedMemberWebsite] = useState('');
  const [selectedVisioptCampaign, setSelectedVisioptCampaign] = useState('');
  const [comparisonVisiCampaign, setComparisonVisiCampaign] = useState([]);
  const [trafficSourceData, setTrafficSourceData] = useState<{ key: string; show: boolean }[]>([]);
  const [showBacktoCampButton, setShowBacktoCampButton] = useState<{ rowIndex: string; show: boolean; trafficName: string }[]>([]);
  const [showBacktoAdsetButton, setShowBacktoAdsetButton] = useState<{ rowIndex: string; show: boolean; trafficName: string }[]>([]);
  const [showUpdateButton, setShowUpdateButton] = useState(false);
  const [campaignColumns, setCampaignColumns] = useState({});
  const [sortConfig, setSortConfig] = useState([]);
  const [trafficSortConfig, setTrafficSortConfig] = useState([]);

  const [saveReportModalOpen, setSaveReportModalOpen] = useState(false);
  const [selectedGraphType, setSelectedGraphType] = useState('1');
  const [SelectedGraphData, setSelectedGraphData] = useState([]);
  const [reportName, setReportName] = useState('');
  const [visioptCampaignOptions, setVisioptCampaignOptions] = useState([]);
  const [compVisioptCampaignOptions, setCompVisioptCampaignOptions] = useState([]);
  const [attributionList, setAttributionList] = useState([]);
  const [selectedDate, setSelectedDate] = useState('');
  const [conversionGoalOptions, setConversionGoalOptions] = useState([]);
  const [selectedCustomerGoal, setSelectedCustomerGoal] = useState([{ campaignid: "", selectedGoal: "" }]);
  const [selectedSourceData, setSelectedSourceData] = useState([{ campaignid: "", sourceValues: [] }]);
  const [selectedTrackingTagData, setSelectedTrackingTagData] = useState([{ campaignid: "", trackingTagKey: "", trackingTagValues: [], arrayId: "" }]);
  const [selectedCustomTagData, setSelectedCustomTagData] = useState([{ campaignid: "", customTagKey: "", customTagValues: [], arrayId:"" }]);
  const [selectedOrganicCustomTag, setSelectedOrganicCustomTag] = useState([{ campaignid: "", selectedValues: [] }]);
  const [selectedOrganicTrackingTag, setSelectedOrganicTrackingTag] = useState([{ campaignid: "", selectedValues: [] }]);
  const [selectedFacebookDropdownData, setSelectedFacebookDropdownData] = useState([{ campaignid: "", selectedValue: "" }]);
  const [allCampaignTableData, setAllCampaignTableData] = useState([]);
  const [campaignCombineDataTable, setCampaignCombineDataTable] = useState([]);
  const [allTrafficSourceData, setAllTrafficSourceData] = useState([]);
  const [showGoalTable, setShowGoalTable] = useState<{ campaignid: string; show: boolean }[]>([]);
  const [showTestVariation, setShowTestVariation] = useState<{ campaignid: string; show: boolean }[]>([]);
  const [showAdsetTable, setShowAdsetTable] = useState<{ show: boolean; trafficName: string }[]>([]);
  const [showAdsTable, setShowAdsTable] = useState<{ show: boolean; trafficName: string }[]>([]);
  const [showTrafficSourceTable, setShowTrafficSourceTable] = useState<{ show: boolean; trafficName: string }[]>([]);
  const [showTrafficTables, setShowTrafficTables] = useState(false);

  const [sourceDataTable, setSourceDataTable] = useState([]);
  const [customTagDataTable, setCustomTagDataTable] = useState([]);
  const [trackingTagDataTable, setTrackingTagDataTable] = useState([]);
  const [organicTrafficDataTable, setOrganicTrafficDataTable] = useState([]);
  const [filterByValue, setFilterByValue] = useState('');
  const [filterFromValue, setFilterFromValue] = useState('');
  const [filterToValue, setFilterToValue] = useState('');

  const [selectedTimePicker, setSelectedTimePicker] = useState<number>();
  const [selectedTimePickerToDate, setSelectedTimePickerToDate] = useState('');
  const [selectedTimePickerFromDate, setSelectedTimePickerFromDate] = useState('');
  const [reportLoader, setReportLoader] = useState(false);
  const [reportchartLoader, setReportchartLoader] = useState(false);
  const [showColumnColor, setShowColumnColor] = useState<{ campaignid: string; tableName: string; columnName: string; show: boolean }[]>([]);
  const [showTrafficColumnsColor, setShowTrafficColumnsColor] = useState<{ tableName: string; columnName: string; show: boolean }[]>([]);
  const [storeMetricKeys, setStoreMetricKeys] = useState<string[]>([]);
  /*COLUMNS FOR MAIN CAMPAIGN TABLE*/
  const generalMetricsColumns = [
    { key: 'visi_campagn', value: 'Visiopt Campaign', show: true },
    { key: 'unique', value: 'Uniques', show: true },
    { key: 'visit', value: 'Visits', show: true },
    { key: 'ad_spent', value: 'Ad Spent', show: true },
    { key: 'revenue', value: 'Revenue', show: true },
    { key: 'sub_revenue', value: 'Visiopt Subscription Revenue', show: false },
    { key: 'roas', value: 'ROAS', show: true },
    { key: 'roi', value: 'ROI', show: true },
    { key: 'aov', value: 'AOV', show: true },
    { key: 'acv', value: 'ACV', show: false },
    { key: 'epc', value: 'EPC', show: true },
    { key: 'uep', value: 'Unique EPC', show: true },
    { key: 'profit', value: 'Profit', show: true },
    { key: 'arpu', value: 'Avg. Revenue per Unique', show: true },
  ];

  /*COLUMNS FOR GOAL TABLE WHICH IS INCLUDED IN MAIN CAMPAIGN TABLE*/
  const goalMetricsColumns = [
      { key: 'visi_goal_name', value: 'GoalName', show: true },
      { key: 'goal_ucr', value: 'UCR', show: true },
      { key: 'goal_gcr', value: 'CR', show: true },
      { key: 'goal_cpg', value: 'CPA', show: true },
      { key: 'goal_epg', value: 'EPG', show: true },
      { key: 'goal_arpu', value: 'Avg. Revenue per Unique', show: false },
      { key: 'goal_acv', value: 'ACV', show: false },
  ];

  useEffect(() => {
    if (!Array.isArray(Permissions)) return;
    if (Permissions.length === 0) return;
    const reportAccess = hasPermission("campaign_tab_access");
    if (!reportAccess) {
      navigate("/dashboard");
    }
  }, [Permissions]);

  /*COLUMNS FOR TRAFFIC SOURCE TABLE*/
  const trafficSourceMetricsColumns = [
      { key: 'traffic_source', value: 'Traffic Source', show: true },
      { key: 'campaign_name', value: 'Campaign Name', show: true },
      { key: 'device_name', value: 'Device Type', show: false },
      { key: 'uniques', value: 'Uniques', show: true },
      { key: 'visits', value: 'Visits', show: true },
      { key: 'ad_spend', value: 'Ad Spend', show: true },
      { key: 'network_conversions', value: 'Network Conversion', show: false },
      { key: 'impressions', value: 'Impressions', show: false },
      { key: 'ctr', value: 'CTR', show: false },
      { key: 'cpc', value: 'CPC', show: false },
      { key: 'cpm', value: 'CPM', show: false },
  ];

  /*COLUMNS FOR ORGANIC TRAFFIC TABLE*/
  const [organicTrafficMetricsColumns] = useState([
      { key: 'goalname', value: 'Traffic', show: true },
      { key: 'uniques', value: 'Uniques', show: true },
      { key: 'visits', value: 'Visits', show: true }
  ]);

  /*COLUMNS FOR SOURCE TABLE*/
  const [sourceMetricsColumns, setSourceMetricsColumns] = useState([
      { key: 'c_r_source_name', value: 'Source name', show: true },
      { key: 'c_r_uniques', value: 'Uniques', show: true },
      { key: 'c_r_visits', value: 'Visits', show: true },
  ]);

  /*COLUMNS FOR TEST VARIATION TABLE*/
  const testVariationMetricsColumns = [
      { key: 'variation', value: 'Variation', show: true },
      { key: 'Conversion', value: 'Conversion', show: true },
      { key: 'goal_ucr', value: 'UCR', show: true },
      { key: 'goal_gcr', value: 'CR', show: true },
      { key: 'goal_cpg', value: 'Estimated CPA', show: true },
      { key: 'goal_epg', value: 'EPG', show: true },
      { key: 'goal_arpu', value: 'Avg. Revenue per Unique', show: false },
      { key: 'goal_acv', value: 'ACV', show: false },
  ];

  const [generalColumns, setGeneralColumns] = useState<{ key: string; value: string; show: boolean }[]>(generalMetricsColumns);
  const [trafficFunnelMetricsColumns, setTrafficFunnelMetricsColumns] = useState([]);
  const [goalColumns, setGoalColumns] = useState<{ key: string; value: string; show: boolean }[]>(goalMetricsColumns);
  const [organicTrafficColumns, setOrganicTrafficColumns] = useState({});
  const [sourceColumns, setSourceColumns] = useState({});
  const [customTagColumns, setCustomTagColumns] = useState({});
  const [trackingTagColumns, setTrackingTagColumns] = useState({});
  const [trafficSourceColumns, setTrafficSourceColumns] = useState<{ key: string; value: string; show: boolean }[]>(trafficSourceMetricsColumns); 
  const [facebookData, setFacebookData] = useState([]);
  const [googleData, setGoogleData] = useState([]);
  const [tiktokData, setTiktokData] = useState([]);
  const [microsoftData, setMicrosoftData] = useState([]);
  const [applovinData, setApplovinData] = useState([]);
  const [outbrainData, setOutbrainData] = useState([]);
  const [linkedinData, setLinkedinData] = useState([]);

  const [facebookAdsetData, setFacebookAdsetData] = useState([]);
  const [googleAdsetData, setGoogleAdsetData] = useState([]);
  const [tiktokAdsetData, setTiktokAdsetData] = useState([]);
  const [microsoftAdsetData, setMicrosoftAdsetData] = useState([]);
  const [linkedinAdsetData, setLinkedinAdsetData] = useState([]);

  const [facebookAdsData, setFacebookAdsData] = useState([]);
  const [googleAdsData, setGoogleAdsData] = useState([]);
  const [tiktokAdsData, setTiktokAdsData] = useState([]);
  const [applovinAdsetData, setApplovinAdsetData] = useState([]);
  const [linkedinAdsData, setLinkedinAdsData] = useState([]);

  const [facebookTrafficChecked, setFacebookTrafficChecked] = useState(false);
  const [googleTrafficChecked, setGoogleTrafficChecked] = useState(false);
  const [tiktokTrafficChecked, setTiktokTrafficChecked] = useState(false);
  const [microsoftTrafficChecked, setMicrosoftTrafficChecked] = useState(false);
  const [applovinTrafficChecked, setApplovinTrafficChecked] = useState(false);
  const [outbrainTrafficChecked, setOutbrainTrafficChecked] = useState(false);
  const [linkedinTrafficChecked, setLinkedinTrafficChecked] = useState(false);

  const [facebookAdsetTrafficChecked, setFacebookAdsetTrafficChecked] = useState(false);
  const [googleAdsetTrafficChecked, setGoogleAdsetTrafficChecked] = useState(false);
  const [tiktokAdsetTrafficChecked, setTiktokAdsetTrafficChecked] = useState(false);
  const [microsoftAdsetTrafficChecked, setMicrosoftAdsetTrafficChecked] = useState(false);
  const [linkedinAdsetTrafficChecked, setLinkedinAdsetTrafficChecked] = useState(false);
  const [testVariationColumns, setTestVariationColumns] = useState<{ key: string; value: string; show: boolean }[]>(testVariationMetricsColumns);

  const [pieChartSourceData, setPieChartSourceData] = useState([]);
  const [pieChartSourceColors, setPieChartSourceColors] = useState([]);

  const [showTableByIcons, setShowTableByIcons] = useState<{ campaign_id: string; tableName: string; show: boolean }[]>();
  const [showAllAdCosts, setShowAllAdCosts] = useState(false);
  const [campaignSearchValue, setCampaignSearchValue] = useState<{ value: string; trafficName: string; tableName: string }[]>([]);
  const [adsetSearchValue, setAdsetSearchValue] = useState<{ value: string; trafficName: string; tableName: string }[]>([]);
  const [adsSearchValue, setAdsSearchValue] = useState<{ value: string; trafficName: string; tableName: string }[]>([]);
  const [placement, setPlacement] = useState<{ value: string; trafficName: string; tableName: string }[]>([]);
  const [filteredData, setFilteredData] = useState([]);
  const [adsetAdsData, setAdsetAdsData] = useState([]);
  const [selectedCampaigns, setSelectedCampaigns] = useState([]);
  const [graphCampaignList, setGraphCampaignList] = useState([]);
  const [selectedGraphCampaign, setSelectedGraphCampaign] = useState('');
  const [showGraphCampaignDropdown, setShowGraphCampaignDropdown] = useState(false);
  const [lastTrafficSourceData, setLastTrafficSourceData] = useState<{ table: string; data: any }[]>([]);
  const [trafficAdsetData, setTrafficAdsetData] = useState([]);
  let apiCallCounter = 0;
  const generalColumnsLength = generalColumns.filter(traffic => traffic.show === true);
  // Breakdown selection drives the campaign-report sub-row rendering AND the SQL shape on the
  // backend. Three states: 'none' (default — no GROUPING SETS, original query), 'device' (device
  // sub-rows), 'hour' (time-of-day sub-rows). Persisted per saved report in custom_campagin_report.
  // pendingBreakdown is what the radio shows live; breakdownSelection is the committed value
  // (only changes when the Save button inside the popover is clicked, mirroring Select Metrics).
  const [breakdownSelection, setBreakdownSelection] = useState<'none' | 'device' | 'hour' | 'cust_type'>('none');
  const [pendingBreakdown, setPendingBreakdown] = useState<'none' | 'device' | 'hour' | 'cust_type'>('none');
  const [breakdownPopoverOpen, setBreakdownPopoverOpen] = useState(false);
  /* Campaign Goal Customer Type is lazy: the report load fetches none of it. A goal's rows are
     requested the first time its link is opened and then cached under that goal's key, so
     reopening never asks again. Cache holds {rows, variations, available, error}. */
  const [campaignGoalCt, setCampaignGoalCt] = useState<Record<string, any>>({});
  const [campaignGoalCtOpen, setCampaignGoalCtOpen] = useState<string[]>([]);
  const [campaignGoalCtLoading, setCampaignGoalCtLoading] = useState<string | null>(null);

  /* openKey identifies the ONE row being expanded; cacheKey identifies the goal whose data is
     fetched. They differ under test variations, where every variation row shares a goal's single
     request but must open and close on its own. Where there is only one row per goal the caller
     omits cacheKey and the two are the same. */
  const toggleCampaignGoalCustomerType = (openKey: string, campaignId: string, goalId: string, goalType: string, cacheKey: string = '') => {
    const dataKey = cacheKey !== '' ? cacheKey : openKey;
    if (campaignGoalCtOpen.includes(openKey)) {
      setCampaignGoalCtOpen((prev) => prev.filter((k) => k !== openKey));
      return;
    }
    if (campaignGoalCt[dataKey]) {
      setCampaignGoalCtOpen((prev) => [...prev, openKey]);
      return;
    }
    setCampaignGoalCtLoading(openKey);
    /* Narrow request: this goal only. It deliberately does NOT go through
       get_campaign_report_data, so opening the breakdown never reloads the report. */
    CampaignReport.getcampaigngoalcustomertype({
      campaign_id: campaignId,
      campaign_goal: goalId,
      campaign_goal_type: goalType,
      report_time: reportTimeValue(),
      attribution_name: selectedAttributionModal,
    })
      .then((r: any) => (r && r.ok ? r.json() : null))
      .then((d: any) => {
        setCampaignGoalCt((prev) => ({
          ...prev,
          [dataKey]: {
            rows:       Array.isArray(d?.data?.customer_type_rows) ? d.data.customer_type_rows : [],
            variations: Array.isArray(d?.data?.customer_type_variations) ? d.data.customer_type_variations : [],
            available:  Number(d?.data?.customer_type_available) === 1,
            /* A null body means the request failed; recorded so the row shows a message
               instead of sitting on "Loading..." forever. */
            error:      d === null,
          },
        }));
        setCampaignGoalCtOpen((prev) => [...prev, openKey]);
      })
      .catch(() => {
        setCampaignGoalCt((prev) => ({ ...prev, [dataKey]: { rows: [], variations: [], available: false, error: true } }));
        setCampaignGoalCtOpen((prev) => [...prev, openKey]);
      })
      .finally(() => setCampaignGoalCtLoading(null));
  };

  /* A Customer Type row's metrics are the parent row's, scaled by that segment's share.
     This is exact rather than an approximation: UCR and CR divide the same uniques and visits
     as the parent, so scaling by conversion share reproduces them; cost per acquisition divides
     the same ad spend, so it scales inversely; EPG comes straight from the segment's own
     revenue. Nothing here re-queries or re-derives a figure the report has not already
     computed - it only redistributes it. */
  /* Inside a goal, the variation groups sit alongside bookkeeping keys that are not variations.
     Treating those as variations produces empty phantom tables on screen and junk blocks in the
     export, so both consumers filter through this one predicate. */
  const isVariationGroupKey = (key: string) =>
    key !== 'test_traffic_uniques' && !key.endsWith('_customer_type_rows');

  /* CSV cells: a value containing a comma or a quote has to be quoted or it shifts every
     column after it. The goal rows above are plain numbers, but Customer Type labels are not. */
  const csvCell = (v: any) => {
    const str = v === undefined || v === null ? '' : String(v);
    return /[",\n]/.test(str) ? `"${str.replace(/"/g, '""')}"` : str;
  };

  const ctNum = (v: any) => {
    const n = Number(String(v ?? '').replace(/[^0-9.-]/g, ''));
    return isFinite(n) ? n : 0;
  };
  const ctMetric = (key: string, ct: any, parentConv: number, parent: any) => {
    const segConv = ctNum(ct?.conversions);
    const segRev  = ctNum(ct?.revenue);
    const share   = parentConv > 0 ? segConv / parentConv : 0;
    switch (key) {
      case 'goal_ucr':
      case 'goal_gcr': {
        if (parentConv <= 0) { return '0.00%'; }
        return (ctNum(parent?.[key]) * share).toFixed(2) + '%';
      }
      case 'goal_cpg': {
        /* Inverse: the same ad spend divided by fewer conversions costs more each. */
        const cpg = ctNum(parent?.goal_cpg);
        return (segConv > 0 && cpg > 0) ? (cpg * parentConv / segConv).toFixed(2) : '-';
      }
      case 'goal_epg':
        return (segConv > 0 ? segRev / segConv : 0).toFixed(2);
      case 'goal_acv': {
        /* Average customer value divides revenue by distinct customers, not by conversions -
           a customer who buys twice is still one customer. The request supplies that count. */
        const customers = ctNum(ct?.customers);
        return (customers > 0 ? segRev / customers : 0).toFixed(2);
      }
      case 'goal_arpu': {
        /* Uniques recovered from the parent's own rate, so the denominator matches exactly. */
        const ucr = ctNum(parent?.goal_ucr);
        const uniques = ucr > 0 ? (parentConv / (ucr / 100)) : 0;
        return (uniques > 0 ? segRev / uniques : 0).toFixed(2);
      }
      default:
        return ct?.[key] !== undefined ? ct[key] : '';
    }
  };

  /* Customer Type always has these two segments. When the report sends none for an eligible goal -
     nothing purchased yet, or a backend that predates the zero-filled response - these stand in so
     the block reads zero instead of a "no data" message. Raw shape on purpose: ctMetric() derives
     every displayed figure from these, exactly as it does for a real row. */
  const CT_SEGMENT_LABELS = ['First-time Customers', 'Returning Customers'];
  const customerTypeZeroRows = () =>
    CT_SEGMENT_LABELS.map((name) => ({
      customer_type_name: name, conversions: 0, revenue: 0, sub_revenue: 0, customers: 0,
    }));
  /* Rows actually rendered for a goal: the report's own, or the zero segments above. A failed
     request and a goal that cannot carry a split both show their own message instead, so neither
     is given zero rows - a zero there would claim a measurement that was never taken. */
  const campaignGoalCtRows = (ctKey: string, rows: any[]) => {
    const state = campaignGoalCt[ctKey];
    if (!state || state.error || !state.available) { return []; }
    return (Array.isArray(rows) && rows.length > 0) ? rows : customerTypeZeroRows();
  };

  /* One place decides what a Customer Type block renders, so both goal branches stay in step.
     Only the two states that are NOT a zero result still speak: a failed request, and a goal
     that cannot carry a split at all. */
  const campaignGoalCtBody = (ctKey: string, rows: any[], colCount: number, bg: string) => {
    const state = campaignGoalCt[ctKey];
    if (!state) { return null; }
    if (state.error)      { return <tr style={{ background: bg }}><td colSpan={colCount} style={{ textAlign: 'left', paddingLeft: 18, fontStyle: 'italic', opacity: 0.8 }}>Customer Type could not be loaded.</td></tr>; }
    if (!state.available) { return <tr style={{ background: bg }}><td colSpan={colCount} style={{ textAlign: 'left', paddingLeft: 18, fontStyle: 'italic', opacity: 0.8 }}>Customer Type is not available for this goal.</td></tr>; }
    return null;
  };
  const showDeviceBreakdown = breakdownSelection === 'device';
  const showHourBreakdown   = breakdownSelection === 'hour';
  /* 'cust_type' rather than 'customer_type': the stored column is varchar(10), and the longer
     name truncates silently - the selection would appear to revert to None. */
  const showCustomerTypeBreakdown = breakdownSelection === 'cust_type';
  const [firstCampaignStartDate, setFirstCampaignStartDate] = useState('');
  const colorTheme = useColorScheme();
  const [openedAccordion, setOpenedAccordion] = useState<string | null>(null);
  const [executeConversionGoal, setExecuteConversionGoal] = useState(false);
  const [loaderType, setLoaderType] = useState('');
  const [showOrganicTrafficTable, setShowOrganicTrafficTable] = useState(false);
  const [showVelocityDrawer, setShowVelocityDrawer] = useState(false);
  const [velocityDrawerGoalName, setVelocityDrawerGoalName] = useState([]);
  const [velocityDrawerEncodeTrafficName, setVelocityDrawerEncodeTrafficName] = useState('');
  const [velocityDrawerCampaignName, setVelocityDrawerCampaignName] = useState('');
  const [velocityDrawerAdsetName, setVelocityDrawerAdsetName] = useState('');
  const [velocityDrawerTrafficSourceName, setVelocityDrawerTrafficSourceName] = useState('');
  const [velocityDrawerCampaignId, setVelocityDrawerCampaignId] = useState('');
  const [velocityDrawerTrafficLevel, setVelocityDrawerTrafficLevel] = useState('');
  const [velocityDrawerGoalType, setVelocityDrawerGoalType] = useState('');
  const [velocityDrawerCombinedGoalType, setVelocityDrawerCombinedGoalType] = useState(false);
  const [velocityDrawerDisplayCampaignName, setVelocityDrawerDisplayCampaignName] = useState('');
  const keywordViewButtonStyle = colorTheme === "dark"
    ? { fontSize: 10, padding: '2px 8px', border: '1px solid #91a7ff', borderRadius: 5, background: '#1f3a70', color: '#dbe4ff', cursor: 'pointer', whiteSpace: 'nowrap' }
    : { fontSize: 10, padding: '2px 8px', border: '1px solid #4c6ef5', borderRadius: 5, background: 'transparent', color: '#4c6ef5', cursor: 'pointer', whiteSpace: 'nowrap' };
  const keywordViewHoverInBg = colorTheme === "dark" ? '#2a4f96' : 'transparent';
  const keywordViewHoverOutBg = colorTheme === "dark" ? '#1f3a70' : 'transparent';
  const keywordViewActiveBg = colorTheme === "dark" ? '#19335f' : 'transparent';
  const velocityIconColor = colorTheme === "dark" ? '#c7d2fe' : '#4c6ef5';
  const velocityIconHoverBg = colorTheme === "dark" ? '#30343a' : '#f1f3f5';

  const [trafficSourceBenchmarks, setTrafficSourceBenchmarks] = useState([]);
  const [showLifecycleModal, setShowLifecycleModal] = useState(false);
  const [lifecycleCampaignId, setLifecycleCampaignId] = useState('');
  const [lifecycleTrafficData, setLifecycleTrafficData] = useState({
    facebook: { level: "campaign", data: [] },
    google: { level: "campaign", data: [] },
    microsoft: { level: "campaign", data: [] },
    tikTok: { level: "campaign", data: [] },
    outbrain: { level: "campaign", data: [] },
    applovin: { level: "campaign", data: [] },
    linkedin: { level: "campaign", data: [] },
    taboola: { level: "campaign", data: [] }
  });

  const benchmarksMap = {};
  trafficSourceBenchmarks.forEach(b => {
    const mapKey = `${b.goal_name}_${b.metric_name}`;
    benchmarksMap[mapKey] = {
      direction: b.direction,
      red: Number(b.red_threshold),
      green: Number(b.green_threshold)
    };
  });

  const extractMetricKey = (colKey) => {
    const parts = colKey.split("_");
    if (parts.length >= 5 && parts[0] === "c" && parts[1] === "r") {
      const campaignId = parts[2];
      const goalId = parts[3];
      const metric = parts.slice(4).join("_");
      return `${campaignId}_${goalId}_${metric}`;
    }
    return colKey;
  };

  const getBenchmarkColor = (metricKey, value) => {
    if (!metricKey) return null;
    for (const fullKey in benchmarksMap) {
      if (fullKey.endsWith(`_${metricKey}`)) {
        metricKey = fullKey;
        break;
      }
    }

    const benchData = benchmarksMap[metricKey];
    if (!benchData) return null;
    const { direction, red, green } = benchData;
    const v = parseFloat(value);
    if (isNaN(v)) return null;
    if (direction === "higher") {
      return v >= green ? "green" : v <= red ? "red" : "yellow";
    }
    return v <= green ? "green" : v >= red ? "red" : "yellow";
  };

  const mergedCampaignIds = useMemo(() => {
    return [
      selectedVisioptCampaign,
      ...(comparisonVisiCampaign || [])
    ].filter(Boolean);
  }, [selectedVisioptCampaign, comparisonVisiCampaign]);

  const handleBenchmarksClick = (reportId, mergedCampaignIds) => {
    CampaignReport.getbenchmarksdata({
      report_id: reportId || updateReportId,
      campaign_id: mergedCampaignIds
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate("/logout");
        }
        throw new Error("API error");
      }
    })
    .then(data => {
      if (data.status === 1) {
        setTrafficSourceBenchmarks(data.data.traffic_source_benchmarks);
      } else {
        notifications.show({
          color: 'red',
          icon: <IconX size="1.1rem" />,
          title: 'Error',
          message: data.message,
        });
      }
    })
    .catch(error => {
      console.error("API Error:", error);
    });
  };

  useEffect(() => {
    if (reportId || updateReportId) {
      handleBenchmarksClick(reportId, mergedCampaignIds);
    }
  }, [reportId, mergedCampaignIds]);

  /*STORE TRAFFIC SOURCE WISE FUNNEL BLOCKS*/
  interface FunnelBlock {
    campaign_id: string;
    data: {
      lp_page_unique?: {
        [key: string]: {
          uniques?: number;
          visits?: number;
        }
      };
      goal_blocks?: Array<{
        goal_id: string;
        custom_title: string;
        uniques?: number;
        visits?: number;
        visiopt_conversions?: number;
        ucr?: number;
        gcr?: number;
        thumb?: string;
        unique_percentage?: string;
        visiopt_campaign?: string;
      }>;
    };
  }
  
  const [facebookFunnelBlocks, setFacebookFunnelBlocks] = useState<FunnelBlock[]>([]);
  const [googleFunnelBlocks, setGoogleFunnelBlocks] = useState<FunnelBlock[]>([]);
  const [microsoftFunnelBlocks, setMicrosoftFunnelBlocks] = useState<FunnelBlock[]>([]);
  const [applovinFunnelBlocks, setApplovinFunnelBlocks] = useState<FunnelBlock[]>([]);
  const [tiktokFunnelBlocks, setTiktokFunnelBlocks] = useState<FunnelBlock[]>([]);
  const [outbrainFunnelBlocks, setOutbrainFunnelBlocks] = useState<FunnelBlock[]>([]);
  const [linkedinFunnelBlocks, setLinkedinFunnelBlocks] = useState<FunnelBlock[]>([]);

  /*FUNNEL BLOCK CAMPAIGN DATA COPY*/
  const [facebookFunnelBlocksCampaignCopy, setFacebookFunnelBlocksCampaignCopy] = useState<FunnelBlock[]>([]);
  const [googleFunnelBlocksCamCopy, setGoogleFunnelBlocksCamCopy] = useState<FunnelBlock[]>([]);
  const [microsoftFunnelBlocksCamCopy, setMicrosoftFunnelBlocksCamCopy] = useState<FunnelBlock[]>([]);
  const [applovinFunnelBlocksCamCopy, setApplovinFunnelBlocksCamCopy] = useState<FunnelBlock[]>([]);
  const [tiktokFunnelBlocksCampaignCopy, setTiktokFunnelBlocksCampaignCopy] = useState<FunnelBlock[]>([]);
  const [outbrainFunnelBlocksCampaignCopy, setOutbrainFunnelBlocksCampaignCopy] = useState<FunnelBlock[]>([]);
  const [linkedinFunnelBlocksCampaignCopy, setLinkedinFunnelBlocksCampaignCopy] = useState<FunnelBlock[]>([]);

  /*FUNNEL BLOCK ADSET DATA COPY*/
  const [facebookFunnelBlocksAdsetCopy, setFacebookFunnelBlocksAdsetCopy] = useState<FunnelBlock[]>([]);
  const [googleFunnelBlocksAdsetCopy, setGoogleFunnelBlocksAdsetCopy] = useState<FunnelBlock[]>([]);
  const [tiktokFunnelBlocksAdsetCopy, setTiktokFunnelBlocksAdsetCopy] = useState<FunnelBlock[]>([]);
  const [linkedinFunnelBlocksAdsetCopy, setLinkedinFunnelBlocksAdsetCopy] = useState<FunnelBlock[]>([]);

  /*KEYWORD DRAWER*/
  const [showKeywordDrawer, setShowKeywordDrawer] = useState(false);
  const [selectedAdsetCampaignid, setSelectedAdsetCampaignid] = useState(null);
  const [selectedAdsetName, setSelectedAdsetName] = useState(null);
  const [selectedAdsetId, setSelectedAdsetId] = useState(null);

  /*AD-LEVEL KEYWORD DRAWER — separate from the ad set one above, which is unchanged.*/
  const [showAdKeywordDrawer, setShowAdKeywordDrawer] = useState(false);
  const [selectedAdKeywordCampaignid, setSelectedAdKeywordCampaignid] = useState(null);
  const [selectedAdKeywordName, setSelectedAdKeywordName] = useState(null);
  const [selectedAdKeywordEncodedId, setSelectedAdKeywordEncodedId] = useState(null);

  /*AD PREVIEW DRAWER*/
  const [showAdPreviewDrawer, setShowAdPreviewDrawer] = useState(false);
  const [selectedAdPreview, setSelectedAdPreview] = useState({
    platform: '',
    adName: '',
    adId: ''
  });

  /*SET TRAFFIC FUNNEL BLOCKS DATA*/
  const setTrafficFunnelBlocksData = (trafficFunnelMetricsData:any, trafficName:any='', type:any='') => {
    const trafficFunnelBlockSetters = {
      facebook: setFacebookFunnelBlocks,
      google: setGoogleFunnelBlocks,
      tiktok: setTiktokFunnelBlocks,
      microsoft: setMicrosoftFunnelBlocks,
      applovin: setApplovinFunnelBlocks,
      outbrain: setOutbrainFunnelBlocks,
      linkedin: setLinkedinFunnelBlocks,
    };

    const trafficFunnelBlockCampaignCopySetters = {
      facebook: setFacebookFunnelBlocksCampaignCopy,
      google: setGoogleFunnelBlocksCamCopy,
      tiktok: setTiktokFunnelBlocksCampaignCopy,
      microsoft: setMicrosoftFunnelBlocksCamCopy,
      applovin: setApplovinFunnelBlocksCamCopy,
      outbrain: setOutbrainFunnelBlocksCampaignCopy,
      linkedin: setLinkedinFunnelBlocksCampaignCopy,
    };

    const trafficFunnelBlockAdsetCopySetters = {
      facebook: setFacebookFunnelBlocksAdsetCopy,
      google: setGoogleFunnelBlocksAdsetCopy,
      tiktok: setTiktokFunnelBlocksAdsetCopy,
      linkedin: setLinkedinFunnelBlocksAdsetCopy,
    };

    if(type === 'adset' || type === 'ads'){
      trafficFunnelBlockSetters[trafficName]([]);
    }

    Object.entries(trafficFunnelMetricsData).forEach(([campaignId, campaignData]) => {
      Object.entries(campaignData).forEach(([trafficName, trafficData]) => {
        const parsed: FunnelBlock = {
          campaign_id: campaignId,
          data: trafficData
        };
  
        trafficFunnelBlockSetters[trafficName]?.((prev) => [...prev, parsed]);
        if(type === 'campaign' && trafficName !== 'outbrain'){
          trafficFunnelBlockCampaignCopySetters[trafficName]?.((prev) => [...prev, parsed]);          
        }else if(type === 'adset' && trafficName !== 'outbrain'){
          trafficFunnelBlockAdsetCopySetters[trafficName]?.((prev) => [...prev, parsed]);
        }
      });
    });
  };

  const setReportNameValue = (value:any) => {
    setReportName(value);
  };

  const handleHeaderMenuComponentChange = (Value:any) => {
    setSelectedMemberWebsite(Value);
  };

  const handleCancelReport = () => {
    setUpdateReportId('');
    navigate("/campaign-reports");
  };

  const handleSaveReportModalOpenModal = (value:any) => {
    setSaveReportModalOpen(true);
  };

  const handleSaveReportModalCloseModal = () => {
    setSaveReportModalOpen(false);
  };

  const fetchCampaignList = useCallback((report_id, update_report_id) => {
    setComparisonVisiCampaign([]);
    setExecuteConversionGoal(true);
    setConversionGoalOptions([]);    
    if((report_id && report_id !== '' && report_id !== 'new') || updateReportId !== ''){   
      setIsVisiLoaderVisible(true);   
      CampaignReport.getcampaignlistbydomain({
        report_id: report_id
      })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            navigate("/logout");
          }
        }
      })
      .then(data => {
        if(data.status === 1){
          const selectedCampaignId = Object.entries(data.data.campaign_list)
                                    .flatMap(([domain, campaigns]) => 
                                        (campaigns as { campaign_id: string; campaign_name: string; selected: string }[])
                                            .find(campaign => campaign.selected === 'selected')
                                    )
                                    .find(campaign => campaign)?.campaign_id || null;
          setSelectedVisioptCampaign(selectedCampaignId);
          setSelectedDate(data.data.selected_date);
          setReportName(data.data.report_name);
          setAttributionList(data.data.attribution_list);
          setVisioptCampaignOptions(data.data.campaign_list);
          const showUpdate = data.data.update_report_button_display === 1 ? true : false;
          const showAllAd = data.data.show_all_ad && data.data.show_all_ad === '1' ? true : false;
          setShowAllAdCosts(showAllAd);
          setIsVisiLoaderVisible(false);
          setShowUpdateButton(showUpdate);
          if(data.data.time === "-1"){
            setSelectedTimePicker(Number(data.data.selected_date));
            setTimeApiCall(false);
          }else{
            setSelectedTimePicker(Number(data.data.time));
            setTimeApiCall(false);
          }
          setFirstCampaignStartDate(data.data.first_campaign_created_date);
          setSelectedGraphType(data.data.selected_graph_type);
          // Hydrate the saved breakdown selection so the popover (and the next report fetch)
          // reflect what the user picked last time.
          const savedBreakdown = data.data.breakdown_type;
          if (savedBreakdown === 'none' || savedBreakdown === 'device' || savedBreakdown === 'hour') {
            setBreakdownSelection(savedBreakdown);
            setPendingBreakdown(savedBreakdown);
          }
        }else{
          setIsVisiLoaderVisible(false);
          notifications.show({
            color: 'red',
            icon: <IconX size="1.1rem" />,
            title: 'Error',
            message: data.message,
          });
        }
      })
      .catch(error => {
        console.error("API Error:", error);
        setIsVisiLoaderVisible(false);
      });
    }else{
      setIsVisiLoaderVisible(true);
      CampaignReport.getcampaignlistbydomain()
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            navigate("/logout");
          }
        }
      })
      .then(data => {
        if(data.status === 1){
          setSelectedDate(data.data.selected_date);
          setAttributionList(data.data.attribution_list);
          setVisioptCampaignOptions(data.data.campaign_list);
          setIsVisiLoaderVisible(false);
          const showUpdate = data.data.update_report_button_display === 1 ? true : false;
          setShowUpdateButton(showUpdate);
          if(data.data.time === "-1"){
            setSelectedTimePicker(Number(data.data.selected_date));
            setTimeApiCall(false);
          }else{
            setSelectedTimePicker(Number(data.data.time));
            setTimeApiCall(false);
          }
        }else{
          setIsVisiLoaderVisible(false);
          notifications.show({
            color: 'red',
            icon: <IconX size="1.1rem" />,
            title: 'Error',
            message: data.message,
          });
        }

      })
      .catch(error => {
        console.error("API Error:", error);
        setIsVisiLoaderVisible(false);
      });
    }
}, [navigate]);

  useEffect(() => {
    if(selectedMemberWebsite !== '') {
      fetchCampaignList(reportId, updateReportId);
    }
  }, [fetchCampaignList, selectedMemberWebsite]);

  /*THIS USEEFFECT IS FOR SET THE COLUMNS AND BLOCKS FOR NEWLY ADDED CAMPAIGN*/
  useEffect(() => {
    if(executeConversionGoal){
      const selectedCampaignIds = conversionGoalOptions.map(group => group.campaign_id);
      setSelectedCampaigns(selectedCampaignIds);
      const visibleTrafficFunnelMetricsColumns = Object.keys(trafficFunnelMetricsColumns).length > 0 ? trafficFunnelMetricsColumns.filter((column) => column.show) : [];
      const visibleSourceColumns = sourceMetricsColumns.filter((column) => column.show);
      if(conversionGoalOptions.length > 0){
        conversionGoalOptions.forEach((currentCampaign, currentCampaignIndex) => {
        if (!campaignColumns[currentCampaign.campaign_id]) {

          const combinedSourceColumns = [...visibleSourceColumns, ...visibleTrafficFunnelMetricsColumns];
          setSourceColumns((prev) => ({
            ...prev,
            [currentCampaign.campaign_id]: combinedSourceColumns,
          }));

          setCustomTagColumns((prev) => ({
            ...prev,
            [currentCampaign.campaign_id]: combinedSourceColumns,
          }));

          setTrackingTagColumns((prev) => ({
            ...prev,
            [currentCampaign.campaign_id]: combinedSourceColumns,
          }));       
          handleSetCampaignColumns(visibleTrafficFunnelMetricsColumns,storeMetricKeys);
        }
      });
      }
    }
  }, [conversionGoalOptions, executeConversionGoal]);

   const handleSetCampaignColumns = (visibleTrafficFunnelMetricsColumns:any,showKey: string[]) => {
    const showKeys = showKey;
    const storedTrafficSourceColumns = trafficSourceColumns.map(column => {
      let matchKey;

      if (column.key === 'traffic_source') {
        matchKey = `show_c_r_${column.value.replace(/\s+/g, '_')}`; 
      } else {
        matchKey = `show_c_r_${column.key}`;
      }

      if (column.key === 'campaign_name') {
        return {
          ...column,
          show: true,
        };
      }

      return {
        ...column,
        show: showKeys.length > 0 ? showKeys.includes(matchKey) : column.show,
      };
    });
    const visibleTrafficSourceColumns = storedTrafficSourceColumns.filter((column) => column.show);
    const trafficSourceNames = ['facebook', 'google', 'microsoft', 'tiktok', 'applovin', 'outbrain', 'linkedin', 'chatgpt'];
    const trafficSourceAdsetNames = ['facebookAdset', 'googleAdset', 'microsoftAdset', 'tiktokAdset', 'applovinAdset', 'linkedinAdset'];
    const trafficSourceAdsNames = ['facebookAds', 'googleAds', 'microsoftAds', 'tiktokAds', 'linkedinAds'];        
    setCampaignColumns((prev) => {
      const updatedCampaigns = {};

      trafficSourceNames.forEach((traffic) => {
        updatedCampaigns[traffic] = [];
        let trafficSourceFound = false;
        visibleTrafficSourceColumns.flatMap((col) => {
          if (col.key === 'device_name') { return; }
          if (col.key === 'traffic_source') {
            trafficSourceFound = true;
          }
          if((traffic === 'outbrain' || traffic === 'tiktok') && col.key === 'campaign_name'){
            updatedCampaigns[traffic].push(['campaignid', 'Campaign Id']);
          }else if(traffic === 'linkedin' && col.key === 'campaign_name'){
            updatedCampaigns[traffic].push(['campaign_name', 'Campaign Group Name']);
          }else{
            updatedCampaigns[traffic].push([col.key, col.value]);
          }
          if (traffic === 'google' && col.key === 'campaign_name') {
            updatedCampaigns[traffic].push(['placement', 'Placement']);
          }
        });
        if (!trafficSourceFound) {
          updatedCampaigns[traffic].unshift(['checkbox', false]);
        } else {
          const trafficSourceIndex = updatedCampaigns[traffic].findIndex(col => col[0] === 'traffic_source');
          updatedCampaigns[traffic].splice(trafficSourceIndex + 1, 0, ['checkbox', false]);
        }
        visibleTrafficFunnelMetricsColumns.forEach((data) => {
              updatedCampaigns[traffic] = (updatedCampaigns[traffic] || []).concat(
                [[data.key, data.value]]
              );
          });
      });

      trafficSourceAdsetNames.forEach((traffic) => {
        updatedCampaigns[traffic] = [];
        let trafficSourceFound = false;
        visibleTrafficSourceColumns.flatMap((col) => {
          if (col.key === 'device_name') { return; }
          if (col.key === 'traffic_source') {
            trafficSourceFound = true;
          }
          if(col.key === 'campaign_name'){
            if(traffic === 'tiktokAdset'){
              updatedCampaigns[traffic].push(['campaignid', 'Campaign Id']);
              updatedCampaigns[traffic].push(['adset_name', 'Ad Set / Group Name']);
            }
            if(traffic === 'linkedinAdset'){
              updatedCampaigns[traffic].push(['campaign_name', 'Campaign Group Name']);
              updatedCampaigns[traffic].push(['adset_name', 'Campaign Name']);
            }
            if(traffic !== 'applovinAdset' && traffic !== 'tiktokAdset' && traffic !== 'linkedinAdset'){
              updatedCampaigns[traffic].push([col.key, col.value]);
              updatedCampaigns[traffic].push(['adset_name', 'Ad Set / Group Name']);
            }
            if(traffic === 'applovinAdset'){
              updatedCampaigns[traffic].push([col.key, col.value]);
              updatedCampaigns[traffic].push(['adset_name', 'Ad']);
            }
            if(traffic === 'googleAdset'){
              updatedCampaigns[traffic].push(['placement', 'Placement']);
            }
          }
          else {
            updatedCampaigns[traffic].push([col.key, col.value]);
          }
        });
        if (trafficSourceFound) {
          const index = updatedCampaigns[traffic].findIndex((c) => c[0] === 'traffic_source');
          updatedCampaigns[traffic].splice(index + 1, 0, ['checkbox', false]);
        } else {
          updatedCampaigns[traffic].unshift(['checkbox', false]);
        }
        visibleTrafficFunnelMetricsColumns.forEach((data) => {
              updatedCampaigns[traffic] = (updatedCampaigns[traffic] || []).concat(
                [[data.key, data.value]]
              );
          });
      });

      trafficSourceAdsNames.forEach((traffic) => {
        updatedCampaigns[traffic] = [];
        let trafficSourceFound = false;
        visibleTrafficSourceColumns.flatMap((col) => {
          if (col.key === 'device_name') { return; }
          if (col.key === 'traffic_source') {
            trafficSourceFound = true;
          }
          if (col.key === 'campaign_name') {
            if (traffic !== 'tiktokAds' && traffic !== 'linkedinAds') {
              updatedCampaigns[traffic].push([col.key, col.value]);
              updatedCampaigns[traffic].push(['adset_name', 'Ad Set / Group Name']);
              updatedCampaigns[traffic].push(['ad_name', 'Ad']);
              if(traffic === 'googleAds'){
                updatedCampaigns[traffic].push(['placement', 'Placement']);
              }
            } else if(traffic === 'tiktokAds'){
              updatedCampaigns[traffic].push(['campaignid', 'Campaign Id']);
              updatedCampaigns[traffic].push(['adset_name', 'Ad Set / Group Name']);
              updatedCampaigns[traffic].push(['ad_name', 'Ad']);
            } else if(traffic === 'linkedinAds'){
              updatedCampaigns[traffic].push(['campaign_name', 'Campaign Group Name']);
              updatedCampaigns[traffic].push(['adset_name', 'Campaign Name']);
              updatedCampaigns[traffic].push(['ad_name', 'Ad']);
            }
          } else {
            updatedCampaigns[traffic].push([col.key, col.value]);
          }
        });

        if (trafficSourceFound) {
          const index = updatedCampaigns[traffic].findIndex((c) => c[0] === 'traffic_source');
          updatedCampaigns[traffic].splice(index + 1, 0, ['checkbox', false]);
        } else {
          updatedCampaigns[traffic].unshift(['checkbox', false]);
        }
        visibleTrafficFunnelMetricsColumns.forEach((data) => {
              updatedCampaigns[traffic] = (updatedCampaigns[traffic] || []).concat(
                [[data.key, data.value]]
              );
          });
      });

      return {
        ...prev,
        ...updatedCampaigns,
      };
    });
};

  const handleSelectedVisioptCampaign = (value:any) => {
    setSelectedVisioptCampaign(value);
    setComparisonVisiCampaign([]);
    setConversionGoalOptions([]);
    setExecuteConversionGoal(true);
  };

  const multiSelectRef = useRef<HTMLInputElement>(null);
  const handleComparisonVisiCampaign = (selectedValue) => {
    multiSelectRef.current?.blur();
    modals.open({
      trapFocus: false,
      title: 'Message',
      children: (
      <>
        <Text size="sm" style={{ whiteSpace: "pre-line" }}>
          Note: Only goals common to all selected funnels (matched by consistent naming) will be available for aggregation in the combined traffic report. Individual goals will always remain visible separately. Please verify goal naming consistency.
        </Text>
        <Group position="right" mt="sm">
          <Button onClick={() => modals.closeAll()}>OK</Button>
        </Group>
      </>
      ),
    });
    const removedValues = comparisonVisiCampaign.filter(
      (value) => !selectedValue.includes(value)
    );
    if (removedValues.length > 0) {
      setSelectedCustomerGoal((prev) =>
        prev.filter((goal) => !removedValues.includes(goal.campaignid))
      );
      setSelectedFacebookDropdownData((prev) =>
        prev.filter((data) => !removedValues.includes(data.campaignid))
      );
      setSelectedTrackingTagData((prev) =>
        prev.filter((data) => !removedValues.includes(data.campaignid))
      );
      setSelectedCustomTagData((prev) =>
        prev.filter((data) => !removedValues.includes(data.campaignid))
      );
      setSelectedSourceData((prev) =>
        prev.filter((data) => !removedValues.includes(data.campaignid))
      );
      setSelectedOrganicCustomTag((prev) =>
        prev.filter((data) => !removedValues.includes(data.campaignid))
      );
      setSelectedOrganicTrackingTag((prev) =>
        prev.filter((data) => !removedValues.includes(data.campaignid))
      );
    }
    setComparisonVisiCampaign(selectedValue);
    if(selectedValue.length > 0){
      getVisioptCampaignGoalDropDown(selectedValue, 'comparison_campaign', 'campaign');
    }    
    const visibleCampaignNames = [...selectedValue, selectedVisioptCampaign];
    const filteredCampaigns = conversionGoalOptions.filter(option => visibleCampaignNames.includes(option.campaign_id));
    setConversionGoalOptions(filteredCampaigns);
    setExecuteConversionGoal(true);
  };

  const handleChangeAttributionModel = (value:any) => {
    setSelectedAttributionModal(value);
    handleReportData('save', value);
  }

  /*START HANDLING DRAG & DROP AND SORTING*/
  const handleDragStart = (e, index, table, campaignID='') => {
    e.dataTransfer.setData('campaignID', campaignID);
    e.dataTransfer.setData('columnIndex', index);
    e.dataTransfer.setData('table', table);
  };

  const handleDrop = (e, dropIndex, customTagName='') => {
    const dragIndex = e.dataTransfer.getData('columnIndex');
    const table = e.dataTransfer.getData('table');
    const campaignID = e.dataTransfer.getData('campaignID');

    if(table === 'organicTraffic') {
      let updatedCampaignColumns = { ...organicTrafficColumns};
      if (updatedCampaignColumns[campaignID]) {
        const updatedColumns = [...updatedCampaignColumns[campaignID]];
        const [draggedColumn] = updatedColumns.splice(dragIndex, 1);
        updatedColumns.splice(dropIndex, 0, draggedColumn);

        updatedCampaignColumns[campaignID] = updatedColumns;
        setOrganicTrafficColumns(updatedCampaignColumns);
      }
    } else if(table === 'tracking_tag') {
      let updatedCampaignColumns = { ...trackingTagColumns};
      if (updatedCampaignColumns[campaignID]) {
        const trackingColumns = updatedCampaignColumns[campaignID].filter((column) => column.key !== 'c_r_source_name');
        const updatedColumns = [...trackingColumns];
        const [draggedColumn] = updatedColumns.splice(dragIndex, 1);
        updatedColumns.splice(dropIndex, 0, draggedColumn);
        
        updatedCampaignColumns[campaignID] = updatedColumns;
        setTrackingTagColumns(updatedCampaignColumns);
      }
    }else if(table === 'custom_tag') {
      let updatedCampaignColumns = { ...customTagColumns};
      if (updatedCampaignColumns[campaignID]) {
        const customTagColumns = updatedCampaignColumns[campaignID][customTagName];
        const updatedColumns = [...customTagColumns];
        const [draggedColumn] = updatedColumns.splice(dragIndex, 1);
        updatedColumns.splice(dropIndex, 0, draggedColumn);
        
        updatedCampaignColumns[campaignID][customTagName] = updatedColumns;
        setCustomTagColumns(updatedCampaignColumns);
      }
    }else if(table === 'source') {
      let updatedCampaignColumns = { ...sourceColumns};
      if (updatedCampaignColumns[campaignID]) {
        const showUpdatedColumns = updatedCampaignColumns[campaignID];
        const updatedColumns = [...showUpdatedColumns];
        const [draggedColumn] = updatedColumns.splice(dragIndex, 1);
        updatedColumns.splice(dropIndex, 0, draggedColumn);
        
        updatedCampaignColumns[campaignID] = updatedColumns;
        setSourceColumns(updatedCampaignColumns);
      }
    }else {
      let updatedCampaignColumns = { ...campaignColumns };
      if (updatedCampaignColumns) {
        const updatedColumns = [...updatedCampaignColumns[table]];
        const [draggedColumn] = updatedColumns.splice(dragIndex, 1);
        updatedColumns.splice(dropIndex, 0, draggedColumn);
        
        updatedCampaignColumns[table] = updatedColumns;
        setCampaignColumns(updatedCampaignColumns);
      }
    }
  };

  const handleSorting = (key, table, campaignID, totalKeyName='') => {
    setShowColumnColor((prev) =>
      prev.some((column) => column.campaignid === campaignID && column.tableName === table && column.columnName === key)
        ? prev.map((column) =>
            column.campaignid === campaignID && column.tableName === table && column.columnName === key
              ? { ...column, show: !column.show }
              : column
          )
        : [...prev, { campaignid: campaignID, tableName: table, columnName: key, show: true }]
    );
    const campaignSortConfig = sortConfig[campaignID] || [];
    const existingSortIndex = campaignSortConfig.findIndex(config => config.key === key && config.table === table);

    let newCampaignSortConfig = [...campaignSortConfig];
    let direction = 'ascending';

    if (existingSortIndex !== -1) {
        const existingSort = newCampaignSortConfig[existingSortIndex];
        if (existingSort.direction === 'ascending') {
            direction = 'descending';
        } else if (existingSort.direction === 'descending') {
            direction = null;
        }

        if (direction === null) {
            newCampaignSortConfig.splice(existingSortIndex, 1);
        } else {
            newCampaignSortConfig[existingSortIndex] = { key, direction, table, totalKeyName };
        }
    } else {
        newCampaignSortConfig.push({ key, direction, table, totalKeyName });
    }

    setSortConfig(prev => ({
        ...prev,
        [campaignID]: newCampaignSortConfig
    })); 

    const trafficSourceMapData = {
      organicTraffic: organicTrafficDataTable,  
      tracking_tag: trackingTagDataTable,    
      source: sourceDataTable,
    };

    const trafficSourceMapSetData = {
      organicTraffic: setOrganicTrafficDataTable,
      tracking_tag: setTrackingTagDataTable,
      source: setSourceDataTable,      
    };

    if (table === 'custom_tag') {
      const trafficSortConfig = newCampaignSortConfig.filter(config => config.table === table);
      const customData = [...customTagDataTable[campaignID][totalKeyName]];
      if(customData.length > 1){
        let lastRow = [] as any;
        const matchedTagKey = Object.keys(customData[customData.length - 1]).find((key) => key.toLowerCase().includes(totalKeyName.toLowerCase()));
        if (customData[customData.length - 1][matchedTagKey] === "Total") {
          lastRow = customData.pop();
        }
        const rowsToSort = customData;

        const sortedTrafficData = rowsToSort.sort((a, b) => {
          for (const { key, direction } of trafficSortConfig) {
            let valueA: string | number = '';
            let valueB: string | number = '';
            if(key === totalKeyName){
              valueA = a[key].toString();
              valueB = b[key].toString();
            }else {
              valueA = parseFloat(a[key].toString().replace(/,/g, ""));
              valueB = parseFloat(b[key].toString().replace(/,/g, ""));
            }                
            if (valueA < valueB) return direction === 'ascending' ? -1 : 1;
            if (valueA > valueB) return direction === 'ascending' ? 1 : -1;
          }
          return 0;
        });

      if (lastRow && lastRow[matchedTagKey] === "Total") {
        sortedTrafficData.push(lastRow);
      }

      setCustomTagDataTable(prev => ({
        ...prev,
        [campaignID]: {
          ...prev[campaignID],
          [totalKeyName]: sortedTrafficData
        }
      }));

        return;
      }
    }

    if(trafficSourceMapData[table]) {
      const trafficSortConfig = newCampaignSortConfig.filter(config => config.table === table);
      const data = [...trafficSourceMapData[table][campaignID].data];
      if(data.length > 1) {
        let lastRow = [] as any;
        if (data[data.length - 1].c_r_traffic_source === 'Total' || data[data.length - 1].goalname === 'Total' || data[data.length - 1].c_r_source_name === 'Total') {
          lastRow = data.pop();
        }else if(table === 'tracking_tag'){
          if(Object.values(data[data.length - 1]).includes("Total")){
            lastRow = data.pop();
          }
        }
        const rowsToSort = data;
        const sortedTrafficData = rowsToSort.sort((a, b) => {
            for (const { key, direction } of trafficSortConfig) {
                const keysName = ['c_r_source_name', 'goalname', 'c_r_traffic_source', 'campaign_name', 'adset_name', 'ad_name'];
                let valueA: string | number = a[key];
                let valueB: string | number = b[key];
                if(keysName.includes(key)){
                  valueA = valueA.toString();
                  valueB = valueB.toString();
                }else if(table === 'tracking_tag' && key === totalKeyName) {
                  valueA = valueA.toString();
                  valueB = valueB.toString();
                }else {
                  valueA = parseFloat(valueA.toString().replace(/,/g, ""));
                  valueB = parseFloat(valueB.toString().replace(/,/g, ""));
                }                
                if (valueA < valueB) return direction === 'ascending' ? -1 : 1;
                if (valueA > valueB) return direction === 'ascending' ? 1 : -1;
            }
            return 0;
        });     
        const tables = ['organicTraffic', 'source', 'tracking_tag', 'custom_tag'];
        if (lastRow && !tables.includes(table) && lastRow.traffic_source === 'Total') {
          sortedTrafficData.push(lastRow);
        }
        if (lastRow && table === 'organicTraffic' && lastRow.goalname === 'Total') {
          sortedTrafficData.push(lastRow);
        }
        if (lastRow && table === 'source' && lastRow.c_r_source_name === 'Total') {
          sortedTrafficData.push(lastRow);
        }      
        if (lastRow && table === 'tracking_tag') {
          if(Object.values(lastRow).includes("Total"))
            sortedTrafficData.push(lastRow);
        }
        trafficSourceMapSetData[table](prev => ({
            ...prev,
            [campaignID]: { ...prev[campaignID], data: sortedTrafficData }
        }));
      }
    }
  };

  const handleTrafficSorting = (key, table) => {
    setShowTrafficColumnsColor((prev) =>
      prev.some((column) => column.tableName === table && column.columnName === key)
        ? prev.map((column) =>
            column.tableName === table && column.columnName === key
              ? { ...column, show: !column.show }
              : column
          )
        : [...prev, { tableName: table, columnName: key, show: true }]
    );
    const existingSortIndex = trafficSortConfig.findIndex(config => config.key === key && config.table === table);

    let newCampaignSortConfig = [...trafficSortConfig];
    let direction = 'ascending';

    if (existingSortIndex !== -1) {
        const existingSort = newCampaignSortConfig[existingSortIndex];
        if (existingSort.direction === 'ascending') {
            direction = 'descending';
        } else if (existingSort.direction === 'descending') {
            direction = null;
        }

        if (direction === null) {
            newCampaignSortConfig.splice(existingSortIndex, 1);
        } else {
            newCampaignSortConfig[existingSortIndex] = { key, direction, table };
        }
    } else {
        newCampaignSortConfig.push({ key, direction, table });
    }
    setTrafficSortConfig(() => [...newCampaignSortConfig]);

    const trafficSourceMapData = {
      facebook: facebookData,
      facebookAdset: facebookAdsetData,
      facebookAds: facebookAdsData,
      google: googleData,
      googleAdset: googleAdsetData,
      googleAds: googleAdsData,
      microsoft: microsoftData,
      microsoftAdset: microsoftAdsetData,
      tiktok: tiktokData,
      tiktokAdset: tiktokAdsetData,
      tiktokAds: tiktokAdsData,
      applovin: applovinData,
      applovinAdset: applovinAdsetData,
      outbrain: outbrainData,
      linkedin: linkedinData,
      linkedinAdset: linkedinAdsetData,
      linkedinAds: linkedinAdsData
    };

    const trafficSourceMapSetData = {
      facebook: setFacebookData,
      facebookAdset: setFacebookAdsetData,
      facebookAds: setFacebookAdsData,
      google: setGoogleData,
      googleAdset: setGoogleAdsetData,
      googleAds: setGoogleAdsData,
      microsoft: setMicrosoftData,
      microsoftAdset: setMicrosoftAdsetData,
      tiktok: setTiktokData,
      tiktokAdset: setTiktokAdsetData,
      tiktokAds: setTiktokAdsData, 
      applovin: setApplovinData,
      applovinAdset: setApplovinAdsetData,
      outbrain: setOutbrainData,
      linkedin: setLinkedinData,
      linkedinAdset: setLinkedinAdsetData,
      linkedinAds: setLinkedinAdsData
    };

    if(trafficSourceMapData[table]) {
      const trafficSortConfig = newCampaignSortConfig.filter(config => config.table === table);
      const data = [...trafficSourceMapData[table]];
      if(data.length > 1) {
        let lastRow = [] as any;
        if (data[data.length - 1].c_r_traffic_source === "Total") {
          lastRow = data.pop();
        }
        const rowsToSort = data;
        const sortedTrafficData = rowsToSort.sort((a, b) => {
            for (const { key, direction } of trafficSortConfig) {
                // Column keys arrive UNPREFIXED (e.g. 'campaign_name'); the data rows are
                // 'c_r_'-prefixed. Match the unprefixed keys so the name columns compare as
                // strings instead of falling through to parseFloat() -> NaN, which never sorted.
                const keysName = ['traffic_source', 'campaign_name', 'adset_name', 'ad_name'];
                const actualKeyA = Object.keys(a).find(k => k.endsWith(`_${key}`)) || key;
                const actualKeyB = Object.keys(b).find(k => k.endsWith(`_${key}`)) || key;
                let valueA: string | number = a[actualKeyA];
                let valueB: string | number = b[actualKeyB];
                if(keysName.includes(key)){
                  valueA = valueA.toString();
                  valueB = valueB.toString();
                }else {
                  valueA = parseFloat(valueA.toString().replace(/,/g, ""));
                  valueB = parseFloat(valueB.toString().replace(/,/g, ""));
                }                
                if (valueA < valueB) return direction === 'ascending' ? -1 : 1;
                if (valueA > valueB) return direction === 'ascending' ? 1 : -1;
            }
            return 0;
        });
        if (lastRow && lastRow.c_r_traffic_source === 'Total') {
          sortedTrafficData.push(lastRow);
        }
        trafficSourceMapSetData[table](() => [...sortedTrafficData]);
      }
    }
  };
  /*END HANDLING DRAG & DROP AND SORTING*/

  /*START HANDLING TRAFFIC SOURCE CHECKBOX*/
  const getLifecycleLevel = (traffic) => {
    if (traffic.toLowerCase().includes("adset")) return "adset";
    if (traffic.toLowerCase().includes("ads")) return "ads";
    return "campaign";
  }
  
  const handleTrafficSourceColumnChecked = (trafficName:any) => {
    const checkedTrafficSourcesMap = {
      facebook: facebookTrafficChecked,
      facebookAdset: facebookAdsetTrafficChecked,
      google: googleTrafficChecked,
      googleAdset: googleAdsetTrafficChecked,
      microsoft: microsoftTrafficChecked,
      microsoftAdset: microsoftAdsetTrafficChecked,
      tiktok: tiktokTrafficChecked,
      tiktokAdset: tiktokAdsetTrafficChecked,
      applovin: applovinTrafficChecked,
      outbrain: outbrainTrafficChecked,
      linkedin: linkedinTrafficChecked,
      linkedinAdset: linkedinAdsetTrafficChecked
    };

    const setTrafficSourceChecked = {
      facebook: setFacebookTrafficChecked,
      facebookAdset: setFacebookAdsetTrafficChecked,
      google: setGoogleTrafficChecked,
      googleAdset: setGoogleAdsetTrafficChecked,
      microsoft: setMicrosoftTrafficChecked,
      microsoftAdset: setMicrosoftAdsetTrafficChecked,
      tiktok: setTiktokTrafficChecked,
      tiktokAdset: setTiktokAdsetTrafficChecked,
      applovin: setApplovinTrafficChecked,
      outbrain: setOutbrainTrafficChecked,
      linkedin: setLinkedinTrafficChecked,
      linkedinAdset: setLinkedinAdsetTrafficChecked,
    };

    const trafficSourceMapSetData = {
      facebook: setFacebookData,
      facebookAdset: setFacebookAdsetData,
      facebookAds: setFacebookAdsData,
      google: setGoogleData,
      googleAdset: setGoogleAdsetData,
      googleAds: setGoogleAdsData,
      microsoft: setMicrosoftData,
      microsoftAdset: setMicrosoftAdsetData,
      tiktok: setTiktokData,
      tiktokAdset: setTiktokAdsetData,
      tiktokAds: setTiktokAdsData,
      applovin: setApplovinData,
      applovinAdset: setApplovinAdsetData,
      outbrain: setOutbrainData,
      linkedin: setLinkedinData,
      linkedinAdset: setLinkedinAdsetData,
      linkedinAds: setLinkedinAdsData,
    };

    const newCheckedValue = checkedTrafficSourcesMap[trafficName];
    setTrafficSourceChecked[trafficName](!newCheckedValue);
    trafficSourceMapSetData[trafficName]((prev) => {
      const updatedData = prev.map((row) => ({
        ...row,
        checkbox: !newCheckedValue,
      }));

      const checkedNames = updatedData
        .filter(data => data['checkbox'] && data['c_r_traffic_source'] !== 'Total')
        .map(data => data['encode_campaign_name']);
      setLifecycleTrafficData(prev => ({
        ...prev,
        [trafficName]: {
          ...prev[trafficName],
          level: getLifecycleLevel(trafficName),
          data: checkedNames
        }
      }));

      const existingTrafficTableData = lastTrafficSourceData.find((traffic) => traffic.table === trafficName);
      if(existingTrafficTableData){
        setLastTrafficSourceData((prev) => 
          prev.map((traffic) => 
            traffic.table === trafficName
              ? { ...traffic, data: updatedData }
              : traffic
          )
        );
      }else{
        setLastTrafficSourceData((prev) => [
          ...prev,
          {data: updatedData, table: trafficName},
        ]);
      }
      return updatedData;
    });
  };

  const handleTrafficRowChecked = (rowIndex: number, trafficName: string) => {
    const trafficSourceMapSetData = {
      facebook: setFacebookData,
      facebookAdset: setFacebookAdsetData,
      facebookAds: setFacebookAdsData,
      google: setGoogleData,
      googleAdset: setGoogleAdsetData,
      googleAds: setGoogleAdsData,
      microsoft: setMicrosoftData,
      microsoftAdset: setMicrosoftAdsetData,
      tiktok: setTiktokData,
      tiktokAdset: setTiktokAdsetData,
      tiktokAds: setTiktokAdsData,
      applovin: setApplovinData,
      applovinAdset: setApplovinAdsetData,
      outbrain: setOutbrainData,
      linkedin: setLinkedinData,
      linkedinAdset: setLinkedinAdsetData,
      linkedinAds: setLinkedinAdsData
    };  
    
    trafficSourceMapSetData[trafficName]((prevData) => {
      const updatedData = prevData.map((row, index) => {
        if (index === rowIndex) {
          return { ...row, checkbox: !row.checkbox };
        }
        return row;
      });

      const checkedNames = updatedData
        .filter(data => data['checkbox'] && data['c_r_traffic_source'] !== 'Total')
        .map(data => data['encode_campaign_name']);
      setLifecycleTrafficData(prev => ({
        ...prev,
        [trafficName]: {
          ...prev[trafficName],
          level: getLifecycleLevel(trafficName),
          data: checkedNames
        }
      }));
      
      return updatedData;
    });

    const trafficCheckedCheckbox = {
      facebook: facebookTrafficChecked,
      google: googleTrafficChecked,
      microsoft: microsoftTrafficChecked,
      tiktok: tiktokTrafficChecked,
      applovin: applovinTrafficChecked,
      outbrain: outbrainTrafficChecked,
      linkedin: linkedinTrafficChecked,
    };

    const trafficAdsetCheckedCheckbox = {
      facebookAdset: facebookAdsetTrafficChecked,
      googleAdset: googleAdsetTrafficChecked,
      microsoftAdset: microsoftAdsetTrafficChecked,
      tiktokAdset: tiktokAdsetTrafficChecked,
      linkedinAdset: linkedinAdsetTrafficChecked,
    };

    const setTrafficSourceChecked = {
      facebook: setFacebookTrafficChecked,
      google: setGoogleTrafficChecked,
      microsoft: setMicrosoftTrafficChecked,
      tiktok: setTiktokTrafficChecked,
      applovin: setApplovinTrafficChecked,
      outbrain: setOutbrainTrafficChecked,
      linkedin: setLinkedinTrafficChecked,
    };

    const setTrafficAdsetSourceChecked = {
      facebookAdset: setFacebookAdsetTrafficChecked,
      googleAdset: setGoogleAdsetTrafficChecked,
      microsoftAdset: setMicrosoftAdsetTrafficChecked,
      tiktokAdset: setTiktokAdsetTrafficChecked,
      linkedinAdset: setLinkedinAdsetTrafficChecked,
    };

    if(trafficCheckedCheckbox[trafficName]) {
      const isChecked = trafficCheckedCheckbox[trafficName];
      if(isChecked){
        setTrafficSourceChecked[trafficName](false);
      }
    } else if(trafficAdsetCheckedCheckbox[trafficName]) {
      const isChecked = trafficAdsetCheckedCheckbox[trafficName];
      if(isChecked){
        setTrafficAdsetSourceChecked[trafficName](false);
      }
    }
  };
  /*END HANDLING TRAFFIC SOURCE CHECKBOX*/

  const resetFunnelBlocksData = (trafficName:any, type:any='') => {
    const setFunnelBlocksdata = {
      facebook: setFacebookFunnelBlocks,
      google: setGoogleFunnelBlocks,
      microsoft: setMicrosoftFunnelBlocks,
      tiktok: setTiktokFunnelBlocks,
      applovin: setApplovinFunnelBlocks,
      outbrain: setOutbrainFunnelBlocks,
      linkedin: setLinkedinFunnelBlocks,
    };
    const setFunnelBlocksCampaign = {
      facebook: setFacebookFunnelBlocksCampaignCopy,
      google: setGoogleFunnelBlocksCamCopy,
      microsoft: setMicrosoftFunnelBlocksCamCopy,
      tiktok: setTiktokFunnelBlocksCampaignCopy,
      applovin: setApplovinFunnelBlocksCamCopy,
      outbrain: setOutbrainFunnelBlocksCampaignCopy,
      linkedin: setLinkedinFunnelBlocksCampaignCopy,
    };
    const setFunnelBlocksAdsetData = {
      facebook: setFacebookFunnelBlocksAdsetCopy,
      google: setGoogleFunnelBlocksAdsetCopy,
      tiktok: setTiktokFunnelBlocksAdsetCopy,
      linkedin: setLinkedinFunnelBlocksAdsetCopy,
    }
    if(trafficName === '' && type === "campaign"){
      Object.values(setFunnelBlocksdata).forEach(setter => setter([]));
      Object.values(setFunnelBlocksCampaign).forEach(setter => setter([]));
      Object.values(setFunnelBlocksAdsetData).forEach(setter => setter([]));
      setCheckedUniquesVisits([]);
      setCheckedGoalConversion([]);
    }
    if(type === 'adset'){
      setFunnelBlocksdata[trafficName]([]); 
      setFunnelBlocksAdsetData[trafficName]?.([]);
    }
  }

  const handleTrafficDataChecked = (value, index, trafficName, type, cpc, ctr, cpm) => {

    const clickableButtons = ['trafficSource', 'checkbox'];
    if (clickableButtons.includes(value)) {
      return;
    }

    let updatedCheckboxValue;
    let dataObject = {};

    const trafficSourceMap = {
      facebook: facebookData,
      google: googleData,
      microsoft: microsoftData,
      tiktok: tiktokData,
      applovin: applovinData,
      outbrain: outbrainData,
      linkedin: linkedinData,
    };
    const trafficSourceSetMap = {
      facebook: setFacebookData,
      google: setGoogleData,
      microsoft: setMicrosoftData,
      tiktok: setTiktokData,
      applovin: setApplovinData,
      outbrain: setOutbrainData,
      linkedin: setLinkedinData,
    };

    const campaignData = trafficSourceMap[trafficName];
    if (campaignData) {
      const updatedData = campaignData.map((row, rowIndex) => {
        if (index === rowIndex) {
          updatedCheckboxValue = true;
          return { ...row, checkbox: updatedCheckboxValue };
        }
        return row;
      });
      let test_variations_data = '';
      const testVariationCampaigns = conversionGoalOptions.filter(options => options.test_variation === 'show');
      if(testVariationCampaigns && testVariationCampaigns.length > 0){
        test_variations_data = testVariationCampaigns.reduce((acc, options) => {
          acc[options.campaign_id] = options.test_variation_value;

          return acc;
        }, {})
      }

      const campaign_arr = conversionGoalOptions.map(campaign => campaign.campaign_id);

      let selected_facebook_accounts = '' as any;
      if (selectedFacebookDropdownData && selectedFacebookDropdownData.length > 0) {
        selected_facebook_accounts = selectedFacebookDropdownData.reduce((acc, options) => {
          acc[options.campaignid] = options.selectedValue;
          return acc;
        }, {});
      }

      let selected_customer_goals = '' as any;
      if (selectedCustomerGoal && selectedCustomerGoal.length > 0) {
        selected_customer_goals = selectedCustomerGoal.reduce((acc, options) => {
          acc[options.campaignid] = options.selectedGoal;
          return acc;
        }, {});
      }
      const checkedEncodeCampaignNamesArray = updatedData
        .filter(data => data['checkbox'] && data['c_r_traffic_source'] !== 'Total')
        .map(data => data['encode_campaign_name']);

      let timeValue: string | number = '';
      if(selectedTimePicker === -2 && selectedTimePickerFromDate === '' && selectedTimePickerToDate === '' && selectedDate){
        timeValue = selectedDate;
      }else if(selectedTimePicker === -2 && selectedTimePickerFromDate !== '' && selectedTimePickerToDate !== ''){
        const [fromMonth, fromDay, fromYear] = selectedTimePickerFromDate.split("-");
        const [endMonth, endDay, endYear] = selectedTimePickerToDate.split("-");
        const fromDate = `${fromMonth}/${fromDay}/${fromYear}`;
        const endDate = `${endMonth}/${endDay}/${endYear}`;
        timeValue = `${fromDate}#${endDate}`;
      }else{
        timeValue = selectedTimePicker;
      }
      if (checkedEncodeCampaignNamesArray.length > 1) {
        dataObject = {
          traffic_source: trafficName,
          type: type,
          campaign_name: checkedEncodeCampaignNamesArray,
          attribution_name: selectedAttributionModal,
          time: timeValue,
          campaign_arr: campaign_arr,
          test_variations_data: test_variations_data,
          show_all_ad: showAllAdCosts === true ? 1 : 0,
          report_id: reportId || updateReportId,
          ads_network_account_id: selected_facebook_accounts,
          tracking_goal: selected_customer_goals,
          breakdown_type: breakdownSelection,
        };
      } else {
        dataObject = {
          traffic_source: trafficName,
          type: type,
          campaign_name: checkedEncodeCampaignNamesArray,
          attribution_name: selectedAttributionModal,
          total_CPC: cpc,
          total_CTR: ctr,
          total_CPM: cpm,
          time: timeValue,
          campaign_arr: campaign_arr,
          test_variations_data: test_variations_data,
          show_all_ad: showAllAdCosts === true ? 1 : 0,
          report_id: reportId || updateReportId,
          ads_network_account_id: selected_facebook_accounts,
          tracking_goal: selected_customer_goals,
          breakdown_type: breakdownSelection,
        };
      }
      trafficSourceSetMap[trafficName](() => [...updatedData]);
    }
    if(type && type !== '') {
      setIsVisiLoaderVisible(true);
      CampaignReport.getadsetadsdata(dataObject)
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            navigate("/logout");
          }
        }
      })
      .then(data => {
        if(data.status === 1){
          setFilterByValue('');
          setFilterFromValue('');
          setFilterToValue('');
          setCheckedUniquesVisits(prev => prev.filter(item => item.trafficName !== trafficName));
          setCheckedGoalConversion(prev => prev.filter(item => item.trafficName !== trafficName));
          resetFunnelBlocksData(trafficName, 'adset');
          const existingAdsetTable = showAdsetTable.find((adset) => adset.trafficName === trafficName);
          if(existingAdsetTable){
            setShowAdsetTable((prev) => 
              prev.map((adset) => 
                adset.trafficName === trafficName
                  ? { ...adset, show: !adset.show }
                  : adset
              )
            );
          }else{
            setShowAdsetTable((prev) => [
                ...prev,
                { show: true, trafficName: trafficName },
            ]);
          }
          const existingTrafficTable = showTrafficSourceTable.find((traffic) => traffic.trafficName === trafficName);
          if(existingTrafficTable){
            setShowTrafficSourceTable((prev) => 
              prev.map((traffic) => 
                traffic.trafficName === trafficName
                  ? { ...traffic, show: !traffic.show }
                  : traffic
              )
            );
          }

          setTrafficAdsetData(data.data.traffic_source);
          const trafficSourceMap = {
            facebook: setFacebookAdsetData,
            google: setGoogleAdsetData,
            tiktok: setTiktokAdsetData,
            microsoft: setMicrosoftAdsetData,
            applovin: setApplovinAdsetData,
            linkedin: setLinkedinAdsetData
          };

          if (trafficSourceMap[trafficName]) {
            const tableData = (data.data.traffic_source[trafficName] as { td: any[] }).td;
            trafficSourceMap[trafficName](() => {
              const dataArray = Array.isArray(tableData) ? tableData : Object.values(tableData);
              //CHECK ALL CHECKBOXES ARE TRUE
              const updatedArray = dataArray.map(row => ({
                ...row,
                checkbox: true
              }));
              return [...updatedArray];
            });
          }
          setTimeout(() => {
            const campaignWidth = columnRefs.campaign_name.current?.offsetWidth || 0;
            const adsetWidth = columnRefs.adset_name.current?.offsetWidth || 0;

            setLeftOffsets({
              campaign_name: 135,
              adset_name: 135 + campaignWidth,
              ad_name: 135 + campaignWidth + adsetWidth,
            });
          }, 0);
          /*SET FUNNEL BLOCKS ADSET DATA*/
          setTrafficFunnelBlocksData(data.data.traffic_funnel_metrics_blocks, trafficName, 'adset');
          setIsVisiLoaderVisible(false);
        }else{
          setIsVisiLoaderVisible(false);
          notifications.show({
            color: 'red',
            icon: <IconX size="1.1rem" />,
            title: 'Error',
            message: data.message,
          });
        }
      })
      .catch(error => {
        console.error("API Error:", error);
        setIsVisiLoaderVisible(false);
      });

      const existingShow = showBacktoCampButton.find((config) => config.rowIndex === index && config.show === true && config.trafficName === trafficName);
      if (!existingShow) {
        const newSource = { rowIndex: index, show: true, trafficName: trafficName };
        setShowBacktoCampButton((prevData) => [...prevData, newSource]);
      }
    }
  };

  const handleTrafficAdsetDataClick = (value, index, trafficAdset, trafficName, trafficCampNames, type, cpc, ctr, cpm) => {
    const clickableButtons = ['trafficSource', 'checkbox'];
    if (clickableButtons.includes(value)) {
      return;
    }

    let updatedCheckboxValue;
    let dataObject = {};

    const trafficSourceMap = {
      facebook: facebookAdsetData,
      google: googleAdsetData,
      microsoft: microsoftAdsetData,
      tiktok: tiktokAdsetData,
      linkedin: linkedinAdsetData,
    };
    const trafficSourceSetMap = {
      facebook: setFacebookAdsetData,
      google: setGoogleAdsetData,
      microsoft: setMicrosoftAdsetData,
      tiktok: setTiktokAdsetData,
      linkedin: setLinkedinAdsetData,
    };

    const campaignData = trafficSourceMap[trafficName];

    if (campaignData) {
      const updatedData = campaignData.map((row, rowIndex) => {
        if (index === rowIndex) {
          updatedCheckboxValue = true;
          return { ...row, checkbox: updatedCheckboxValue };
        }
        return row;
      });
      let test_variations_data = '';
      const testVariationCampaigns = conversionGoalOptions.filter(options => options.test_variation === 'show');
      if(testVariationCampaigns && testVariationCampaigns.length > 0){
        test_variations_data = testVariationCampaigns.reduce((acc, options) => {
          acc[options.campaign_id] = options.test_variation_value;

          return acc;
        }, {})
      }

      const campaign_arr = conversionGoalOptions.map(campaign => campaign.campaign_id);

      let selected_facebook_accounts = '' as any;
      if (selectedFacebookDropdownData && selectedFacebookDropdownData.length > 0) {
        selected_facebook_accounts = selectedFacebookDropdownData.reduce((acc, options) => {
          acc[options.campaignid] = options.selectedValue;
          return acc;
        }, {});
      }

      let selected_customer_goals = '' as any;
      if (selectedCustomerGoal && selectedCustomerGoal.length > 0) {
        selected_customer_goals = selectedCustomerGoal.reduce((acc, options) => {
          acc[options.campaignid] = options.selectedGoal;
          return acc;
        }, {});
      }

      const checkedEncodeCampaignNamesArray = updatedData
        .filter(data => data['checkbox'] && data['c_r_traffic_source'] !== 'Total')
        .map(data => data['encode_campaign_name']);

      const checkedTrafficCampName = updatedData
        .slice(0, -1)
        .filter(data => data['checkbox'])
        .map(data => data['traffic_camp_name']);

      let timeValue: string | number = '';
      if(selectedTimePicker === -2 && selectedTimePickerFromDate === '' && selectedTimePickerToDate === '' && selectedDate){
        timeValue = selectedDate;
      }else if(selectedTimePicker === -2 && selectedTimePickerFromDate !== '' && selectedTimePickerToDate !== ''){
        const [fromMonth, fromDay, fromYear] = selectedTimePickerFromDate.split("-");
        const [endMonth, endDay, endYear] = selectedTimePickerToDate.split("-");
        const fromDate = `${fromMonth}/${fromDay}/${fromYear}`;
        const endDate = `${endMonth}/${endDay}/${endYear}`;
        timeValue = `${fromDate}#${endDate}`;
      }else{
        timeValue = selectedTimePicker;
      }

      if (checkedEncodeCampaignNamesArray.length > 1) {
        dataObject = {
          traffic_source: trafficName,
          type: type,
          campaign_name: checkedEncodeCampaignNamesArray,
          attribution_name: selectedAttributionModal,
          time: timeValue,
          test_variations_data: test_variations_data,
          campaign_arr: campaign_arr,
          traffic_camp_name: checkedTrafficCampName,
          show_all_ad: showAllAdCosts === true ? 1 : 0,
          report_id: reportId || updateReportId,
          ads_network_account_id: selected_facebook_accounts,
          tracking_goal: selected_customer_goals,
          breakdown_type: breakdownSelection,
        };
      } else {
        dataObject = {
          traffic_source: trafficName,
          type: type,
          campaign_name: checkedEncodeCampaignNamesArray,
          attribution_name: selectedAttributionModal,
          total_CPC: cpc,
          total_CTR: ctr,
          total_CPM: cpm,
          time: timeValue,
          test_variations_data: test_variations_data,
          campaign_arr: campaign_arr,
          traffic_camp_name: checkedTrafficCampName,
          show_all_ad: showAllAdCosts === true ? 1 : 0,
          report_id: reportId || updateReportId,
          ads_network_account_id: selected_facebook_accounts,
          tracking_goal: selected_customer_goals,
          breakdown_type: breakdownSelection,
        };
      }

      trafficSourceSetMap[trafficName](() => [...updatedData]);
    }

    if(type && type !== '') {
      setIsVisiLoaderVisible(true);

      CampaignReport.getadsetadsdata(dataObject)
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            navigate("/logout");
          }
        }
      })
      .then(data => {
        if(data.status === 1){
          setFilterByValue('');
          setFilterFromValue('');
          setFilterToValue('');
          setCheckedUniquesVisits(prev => prev.filter(item => item.trafficName !== trafficAdset));
          setCheckedGoalConversion(prev => prev.filter(item => item.trafficName !== trafficAdset));
          const existingAdsTable = showAdsTable.find((ads) => ads.trafficName === trafficName);
          if(existingAdsTable){
            setShowAdsTable((prev) => 
              prev.map((ads) => 
                ads.trafficName === trafficName
                  ? { ...ads, show: !ads.show }
                  : ads
              )
            );
          }else{
            setShowAdsTable((prev) => [
                ...prev,
                { show: true, trafficName: trafficName },
            ]);
          }

          const existingAdsetTable = showAdsetTable.find((traffic) => traffic.trafficName === trafficName);
          if(existingAdsetTable){
            setShowAdsetTable((prev) => 
              prev.map((traffic) => 
                traffic.trafficName === trafficName
                  ? { ...traffic, show: !traffic.show }
                  : traffic
              )
            );
          }

          setAdsetAdsData(data.data.traffic_source);
          const trafficSourceMap = {
            facebook: setFacebookAdsData,
            google: setGoogleAdsData,
            tiktok: setTiktokAdsData,
            linkedin: setLinkedinAdsData,
          };

          if (trafficSourceMap[trafficName]) {
            const tableData = (data.data.traffic_source[trafficName] as { td: any[] }).td;
            trafficSourceMap[trafficName](() => {
              const dataArray = Array.isArray(tableData) ? tableData : Object.values(tableData);
              return [...dataArray];
            });
          }
          const campaignWidth = columnRefs.campaign_name.current?.offsetWidth || 0;
          const adsetWidth = columnRefs.adset_name.current?.offsetWidth || 0;

          setLeftOffsets({
            campaign_name: 135,
            adset_name: 135 + campaignWidth,
            ad_name: 135 + campaignWidth + adsetWidth,
          });
          /*SET FUNNEL BLOCKS ADS DATA*/
          setTrafficFunnelBlocksData(data.data.traffic_funnel_metrics_blocks, trafficName, 'ads');
          setIsVisiLoaderVisible(false);
        }else{
          setIsVisiLoaderVisible(false);
          notifications.show({
            color: 'red',
            icon: <IconX size="1.1rem" />,
            title: 'Error',
            message: data.message,
          });
        }
      })
      .catch(error => {
        console.error("API Error:", error);
        setIsVisiLoaderVisible(false);
      })

      const existingShowAdset = showBacktoAdsetButton.find((config) => config.rowIndex === index && config.show === true && config.trafficName === trafficName);
      if (!existingShowAdset) {
        const newSource = { rowIndex: index, show: true, trafficName: trafficName };
        setShowBacktoAdsetButton((prevData) => [...prevData, newSource]);
      }
    }
  };

  /*START GET SELECTED CAMPAIGN*/
  const getVisioptCampaignGoalDropDown = async (campaignId:any, campaignType:any, apiType:any="") => {
    apiCallCounter++;
    setIsVisiLoaderVisible(true);
    let isSuccessApiCall = false;
    try {
        const requestData = {
              campaign_id: campaignId,
              campaign_type: campaignType,
              ...(reportId ? { report_id: reportId } : updateReportId ? { report_id: updateReportId } : {})
          };

        const response = await CampaignReport.getcampaigngoaldropdownbycampaignid(requestData);
        if (response.ok) {
          const data = await response.json();
          if (data.status === 1) {
              isSuccessApiCall = true;
              const behavioralDetails = data.data.behavioralDetails;
              const allConversionGoals = [];
              for (const key in behavioralDetails) {
                  if (behavioralDetails.hasOwnProperty(key)) {
                      const conversionGoals = behavioralDetails[key].conversion_goal_details;
                      const campaignData = {
                          campaign_id: key,
                          goals: conversionGoals,
                          campaign_name: behavioralDetails[key].first_campaign,
                          site_id: behavioralDetails[key].site_id,
                          test_variation: behavioralDetails[key].test_variations_display,
                          test_variation_value: behavioralDetails[key].test_variations_value,
                          behavioral_dimension_value: behavioralDetails[key].behavioral_filter_button,
                          customTagData: behavioralDetails[key].custom_tags,
                          organicTrafficData: behavioralDetails[key].organic_traffic_data,
                          sourceData: behavioralDetails[key].source_data,
                          trackingTagsData: behavioralDetails[key].tracking_tags,
                          customerPathData: behavioralDetails[key].customer_path_drop,
                          facebookDropDownData: behavioralDetails[key].fb_account_id_arr,
                      };
                      allConversionGoals.push(campaignData);
                  }
                  /*SET FIRST GOAL WHEN CREATE NEW REPORT*/
                  setSelectedCustomerGoal(prevData => [
                          ...prevData,
                          { campaignid: key, selectedGoal: allConversionGoals[0]?.customerPathData[0]?.goal_id }
                  ]);
                  /*SET FIRST ACCOUNT VALUE*/
                  const facebookDropDownData = allConversionGoals[0]?.facebookDropDownData;
                  if (facebookDropDownData && facebookDropDownData[1]) {
                    setSelectedFacebookDropdownData((prevData) => {
                      const newEntry = { campaignid: key, selectedValue: facebookDropDownData[1].fb_account_id };
                      const existingIndex = prevData.findIndex(item => item.campaignid === key);

                      if (existingIndex !== -1) {
                        // Update existing
                        const updatedData = [...prevData];
                        updatedData[existingIndex] = newEntry;
                        return updatedData;
                      } else {
                        // Add new
                        return [...prevData, newEntry];
                      }
                    });
                  }
              }
              if(campaignType === 'first_campaign') {
                setCompVisioptCampaignOptions(data.data.campaign_list);
              }
              setConversionGoalOptions(prevOptions => {
                const optionsMap = new Map(prevOptions.map(option => [option.campaign_id, option]));
                allConversionGoals.forEach(campaignData => {
                    optionsMap.set(campaignData.campaign_id, campaignData);
                });
                return Array.from(optionsMap.values());
              });
              setExecuteConversionGoal(true);
              // setIsVisiLoaderVisible(false);
              if((reportId && reportId !== '') || (updateReportId && updateReportId !== '')){
                if(campaignType === 'first_campaign') {
                  const selectedCompCampaignId = Object.entries(data.data.campaign_list).flatMap(([domain, campaigns]) =>
                                        (campaigns as { campaign_id: string; campaign_name: string; selected: string }[])
                                            .filter((campaign: { campaign_id: string; selected: string }) => campaign.selected === 'selected')
                                            .map(campaign => campaign.campaign_id)
                                    );
                  setComparisonVisiCampaign(selectedCompCampaignId);
                  if(selectedCompCampaignId.length > 0){
                    isSuccessApiCall = false;
                    getVisioptCampaignGoalDropDown(selectedCompCampaignId, 'comparison_campaign');
                  }
                }                              
                allConversionGoals.forEach(campaign => {
                      if(campaign.test_variation_value === 0){
                        setShowGoalTable((prev) =>
                          prev.some((goal) => goal.campaignid === campaign.campaign_id)
                            ? prev.map((goal) =>
                                goal.campaignid === campaign.campaign_id
                                  ? { ...goal, show: true }
                                  : goal
                              )
                            : [...prev, { campaignid: campaign.campaign_id, show: true }]
                        );

                        setShowTestVariation((prev) =>
                          prev.some((variation) => variation.campaignid === campaign.campaign_id)
                            ? prev.map((variation) =>
                                variation.campaignid === campaign.campaign_id
                                  ? { ...variation, show: false }
                                  : variation
                              )
                            : [...prev, { campaignid: campaign.campaign_id, show: false }]
                        );
                      }else if(campaign.test_variation_value === 1){
                        setShowTestVariation((prev) =>
                          prev.some((variation) => variation.campaignid === campaign.campaign_id)
                            ? prev.map((variation) =>
                                variation.campaignid === campaign.campaign_id
                                  ? { ...variation, show: true }
                                  : variation
                              )
                            : [...prev, { campaignid: campaign.campaign_id, show: true }]
                        );

                        setShowGoalTable((prev) =>
                          prev.some((goal) => goal.campaignid === campaign.campaign_id)
                            ? prev.map((goal) =>
                                goal.campaignid === campaign.campaign_id
                                  ? { ...goal, show: false }
                                  : goal
                              )
                            : [...prev, { campaignid: campaign.campaign_id, show: false }]
                        );   
                      }

                      /*SET SELECTED CUSTOMER GOAL*/
                      if (campaign.customerPathData && Object.entries(campaign.customerPathData).length > 0) {
                        const selectedCustomerGoal = Object.values(campaign.customerPathData).find(
                          (dataValue: { goal_id: string; selected: string }) => dataValue.selected === "selected"
                        );                      
                        const selectedCustomerGoalId = selectedCustomerGoal ? (selectedCustomerGoal as { goal_id: string }).goal_id : null;
                        if(selectedCustomerGoalId) {
                          setSelectedCustomerGoal(prevData => {
                            const customerGoalExists = prevData.some(entry => entry.campaignid === campaign.campaign_id);
                            if (customerGoalExists) {
                              return prevData.map(entry => 
                                  entry.campaignid === campaign.campaign_id
                                      ? { ...entry, selectedGoal: selectedCustomerGoalId } 
                                      : entry 
                              );
                            }else {
                              const updatedData = [
                                  ...prevData,
                                  { campaignid: campaign.campaign_id, selectedGoal: selectedCustomerGoalId }
                              ];
                              return updatedData;
                            }
                          });
                        }else{
                          setSelectedCustomerGoal(prevData => [
                                  ...prevData,
                                  { campaignid: campaign.campaign_id, selectedGoal: allConversionGoals[0]?.customerPathData[0]?.goal_id }
                          ]);
                        }
                      }

                      /*SET SELECTED FACEBOOK ACCOUNT*/
                      if (campaign.facebookDropDownData && Object.entries(campaign.facebookDropDownData).length > 0) {
                        const selectedFacebookAccount = Object.values(campaign.facebookDropDownData).find(
                          (dataValue: { fb_account_id: string; selected: string }) => dataValue.selected === "selected"
                        );
                        const selectedFacebookAccountId = selectedFacebookAccount ? (selectedFacebookAccount as { fb_account_id: string }).fb_account_id : null;
                        setSelectedFacebookDropdownData((prevData) => {
                          const newEntry = {
                            campaignid: campaign.campaign_id,
                            selectedValue: selectedFacebookAccountId
                          };

                          const existingIndex = prevData.findIndex(item => item.campaignid === campaign.campaign_id);

                          if (existingIndex !== -1) {
                            // Update existing
                            const updatedData = [...prevData];
                            updatedData[existingIndex] = newEntry;
                            return updatedData;
                          } else {
                            // Add new
                            return [...prevData, newEntry];
                          }
                        });
                      }

                      /*SET SELECTED SOURCE VALUES*/
                      if (campaign.sourceData && Array.isArray(campaign.sourceData.dropdown_data)) {
                        const selectedSourceValues = campaign.sourceData.dropdown_data.filter(data => data.selected === "selected").map(data => data.key);
                        setSelectedSourceData(prevData => [
                            ...prevData,
                            { campaignid: campaign.campaign_id, sourceValues: selectedSourceValues }
                        ]);
                      }

                      /*SET SELECTED TRACKING TAG VALUES*/
                      if (campaign.trackingTagsData && Object.entries(campaign.trackingTagsData).length > 0) {
                        Object.entries(campaign.trackingTagsData).forEach((trackingData) => {
                          const trackingTagarrayId = (trackingData[1] as any).array_id;
                          const trackingTagValues = (trackingData[1] as { dropdown_data: Array<any> }).dropdown_data;
                          if (Array.isArray(trackingTagValues)) {
                              const selectedTrackingData = trackingTagValues.filter(data => data.selected === "selected").map(data => data.key);                        
                              setSelectedTrackingTagData(prevData => [
                                  ...prevData,
                                  { campaignid: campaign.campaign_id, trackingTagKey: trackingData[0], trackingTagValues: selectedTrackingData, arrayId: trackingTagarrayId }
                              ]);
                          }
                        })
                      }

                      /*SET SELECTED CUSTOM TAG VALUES*/ 
                      if (campaign.customTagData && Object.entries(campaign.customTagData).length > 0) {
                        Object.entries(campaign.customTagData).forEach((customTagData) => {
                            const customTagarrayId = (customTagData[1] as any).array_id;
                            const customTagValues = (customTagData[1] as { dropdown_data: Array<any> }).dropdown_data;                            
                            if (Array.isArray(customTagValues) && customTagValues.length > 0) {
                                const selectedCustomData = customTagValues.filter(data => data.selected === "selected").map(data => data.key);
                                setSelectedCustomTagData(prevData => [
                                    ...prevData,
                                    { campaignid: campaign.campaign_id, customTagKey: customTagData[0], customTagValues: selectedCustomData, arrayId: customTagarrayId}
                                ]);
                            }
                        });
                      }

                      /*SET SELECTED ORGANIC TRAFFIC CUSTOM TAG VALUES*/
                      if (campaign.organicTrafficData.exclude_organic_custom_tag && Array.isArray(campaign.organicTrafficData.exclude_organic_custom_tag.dropdown_data)) {
                        const selectedValues = campaign.organicTrafficData.exclude_organic_custom_tag.dropdown_data.filter(data => data.selected === "selected").map(data => data.key);
                        setSelectedOrganicCustomTag(prevData => [
                            ...prevData,
                            { campaignid: campaign.campaign_id, selectedValues: selectedValues }
                        ]);
                      }

                      /*SET SELECTED ORGANIC TRAFFIC TRACKING TAG VALUES*/
                      if (campaign.organicTrafficData.exclude_organic_tracking_tag && Array.isArray(campaign.organicTrafficData.exclude_organic_tracking_tag.dropdown_data)) {
                        const selectedValues = campaign.organicTrafficData.exclude_organic_tracking_tag.dropdown_data.filter(data => data.selected === "selected").map(data => data.key);
                        setSelectedOrganicTrackingTag(prevData => [
                            ...prevData,
                            { campaignid: campaign.campaign_id, selectedValues: selectedValues }
                        ]);
                      }
                  });
                  if(isSuccessApiCall && apiType !== 'campaign'){
                    fetchTrafficTableData({ report_id: reportId || updateReportId, breakdown_type: breakdownSelection });
                  }
              }
          }else{
            // setIsVisiLoaderVisible(false);
            notifications.show({
              color: 'red',
              icon: <IconX size="1.1rem" />,
              title: 'Error',
              message: data.message,
            });
          }
        } else {
            if (response.status === 401 || response.status === 400) {
                navigate("/logout");
            }
        }
      } catch (error) {
          console.error("API Error:", error);
      }
      finally {
        apiCallCounter--;
        if (apiCallCounter === 0) {
          setIsVisiLoaderVisible(false);
        }
      }      
  };
  /*END GET SELECTED CAMPAIGN*/

  const handleToggleTrafficSource = () => {
    setShowTrafficTables(!showTrafficTables);
    handleLocalStorageData(reportId, '', '', false, 'traffic_source', '', !showTrafficTables);
  }

  const handleaccordianChange = (event) => {
    setOpenedAccordion(event);
    handleLocalStorageData(reportId, '', event, false, 'traffic_source', '', showTrafficTables);
  };

  const handleLocalStorageData = (report_id: any, campaign_id: any='', table_name: any, show:any, type:any, updatedTrafficData:any = '', trafficSourceOpen:any = '') => {
    let existingData = {};
    const storedData = localStorage.getItem("visiTrafficTables");
    if (storedData) {
      try {
        existingData = JSON.parse(atob(storedData));
      } catch (error) {
        console.error("Failed to parse localStorage data", error);
      }
    }
    if (!existingData[report_id]) {
      existingData[report_id] = {};
    }
    if(type === 'campaign'){
      const campaignTableShow = updatedTrafficData.filter((config) => config.show === true).map((config) => config.key);
      if (campaignTableShow.includes(campaign_id)) {
        if (!existingData[report_id][campaign_id]) {
          existingData[report_id][campaign_id] = [];
        }

        if (table_name !== '') {
          if (!existingData[report_id][campaign_id].includes(table_name) && show) {
            existingData[report_id][campaign_id].push(table_name);
          } else {
            existingData[report_id][campaign_id] = existingData[report_id][campaign_id].filter(
              (item) => item !== table_name
            );
          }
        }
      } else {
        delete existingData[report_id][campaign_id];
      }
      Object.keys(existingData[report_id]).forEach((campId) => {
        if (!campaignTableShow.includes(campId)) {
          delete existingData[report_id][campId];
        }
      });      
    }else if(type === 'traffic_source'){
      if(trafficSourceOpen){
        if(!existingData[report_id]['traffic_table']){
          existingData[report_id]['traffic_table'] = '';
        }
        if(table_name !== null && table_name !== ''){
          existingData[report_id]['traffic_table'] = table_name;
        }else{
          existingData[report_id]['traffic_table'] = '';
        }
      }else if(!trafficSourceOpen){
        delete existingData[report_id]['traffic_table'];
      }
    }else if(type === 'organicTraffic'){
      if(show){
        if(!existingData[report_id]['organic_traffic']){
          existingData[report_id]['organic_traffic'] = true;
        }
      }else if(!show){
        delete existingData[report_id]['organic_traffic'];
      }
    }
    const encodedData = btoa(JSON.stringify(existingData));
    localStorage.setItem("visiTrafficTables", encodedData);
  };

  const handleCampaignClick = (campaignID) => {   
    const existingShow = trafficSourceData.find((config) => config.key === campaignID && config.show === true);
    let filterTrafficData;
    if (existingShow) {
      filterTrafficData = trafficSourceData.filter((config) => config.key !== campaignID);
    } else {
      const newSource = { key: campaignID, show: true };
      const exists = trafficSourceData.some(config => config.key === campaignID);
      if (exists) {
        filterTrafficData = trafficSourceData.map(config => config.key === campaignID ? { ...config, show: true } : config);
      } else {
        filterTrafficData = [...trafficSourceData, newSource];
      }
    }
    setTrafficSourceData(filterTrafficData);
    handleLocalStorageData(reportId, campaignID, '', false, 'campaign', filterTrafficData);
  };

  useEffect(() => {
    const fetchGoals = async () => {
      if (selectedVisioptCampaign !== '') {
          await getVisioptCampaignGoalDropDown(selectedVisioptCampaign, 'first_campaign');
      }
    };
    fetchGoals();
  }, [selectedVisioptCampaign]);

  /*START GRAPH*/
  const [chartGoalDrop, setChartGoalDrop] = useState([]);
  const [firstFromValue, setFirstFromValue] = useState('');
  const [firstToValue, setFirstToValue] = useState('');
  const [secondFromValue, setSecondFromValue] = useState('');
  const [secondToValue, setSecondToValue] = useState('');
  const [chart_5_Data, setChart_5_Data] = useState([]);
  const [chartTime, setChartTime] = useState("");
  const [goalApiCall, setGoalApiCall] = useState(false);
  const [cpaRange, setCpaRange] = useState({ min: 0, max: 1 });
  const [roasRange, setRoasRange] = useState({ min: 0, max: 1 });
  const [allTimeRoasTitle, setAllTimeRoasTitle] = useState("");
  const [graphMetric, setGraphMetric] = useState('cpm');
  const [velocityFromValue, setVelocityFromValue] = useState('');
  const [velocityToValue, setVelocityToValue] = useState('');
  const velocityLoadedPair = useRef('');
  const velocityFromLabel = chartGoalDrop.find(goal => goal.goal_page_id === velocityFromValue)?.goal_name || '';
  const velocityToLabel = chartGoalDrop.find(goal => goal.goal_page_id === velocityToValue)?.goal_name || '';

  const toSafeDate = (value: string | number | Date): Date => {
    if (value instanceof Date) {
      return value; 
    }
    if (typeof value === "number") {
      return new Date(value);
    }
    if (typeof value === "string") {
      const iso = value.trim();
      if (!iso.includes("/")) {
        return new Date(iso);
      }
      const [mm, dd, yyyy] = iso.split("/");
      return new Date(Number(yyyy), Number(mm) - 1, Number(dd));
    }
    return new Date();
  };

  const handleGraphGoalChange = (value:any, type:any) => {
    if(type === 'firstFrom'){
      setFirstFromValue(value);
    }else if(type === 'firstTo'){
      setFirstToValue(value);
    }else if(type === 'secondFrom'){
      setSecondFromValue(value);
    }else if(type === 'secondTo'){
      setSecondToValue(value);
    }
    setGoalApiCall(true);
  };

  useEffect(() => {
    if(selectedGraphType === '6' && goalApiCall){
      const hasFirstPair = firstFromValue !== '' && firstToValue !== '';
      const hasSecondPair = secondFromValue !== '' && secondToValue !== '';
      if (hasFirstPair || hasSecondPair) {
        handleGraphChange(selectedGraphType, selectedGraphCampaign, firstFromValue, firstToValue, secondFromValue, secondToValue, allCampaignTableData, velocityFromValue, velocityToValue);
      } else {
        setSelectedGraphData([]);
      }
    }
  }, [firstFromValue, firstToValue, secondFromValue, secondToValue, goalApiCall]);

  useEffect(() => {
    if(selectedGraphType === '7' && velocityFromValue !== '' && velocityToValue !== ''){
      // Skip when the pair is the one the API just returned, it avoids a duplicate chart query
      const velocitySelectedPair = velocityFromValue + '#' + velocityToValue;
      if(velocityLoadedPair.current === velocitySelectedPair){
        return;
      }
      velocityLoadedPair.current = velocitySelectedPair;
      handleGraphChange(selectedGraphType, selectedGraphCampaign, firstFromValue, firstToValue, secondFromValue, secondToValue, allCampaignTableData, velocityFromValue, velocityToValue);
    }
  }, [velocityFromValue, velocityToValue]);

  const handleGraphChange = (value:any, campaign:any, first_from:any, first_to:any, second_from:any, second_to:any, campaignTableData:any, velocityFrom:any, velocityTo:any) => {
    setSelectedGraphType(value);
    if (value !== selectedGraphType) {
      resetChartState(selectedGraphType);
      setChartReady(false);
    }
    if((reportId && reportId !== '') || updateReportId !== ''){
      let selectedcampaignId = '';
      const dataObject = {
        report_id: reportId || updateReportId,
        chart_type: value,
        // Spend charts follow Show All Ad Costs, the same as the report tables.
        show_all_ad: showAllAdCosts === true ? 1 : 0
      } as any;
      if(campaign !== '' && campaign !== selectedVisioptCampaign){
        dataObject.chart_campaign_id = campaign;
        selectedcampaignId = campaign;
      }else{
        selectedcampaignId = selectedVisioptCampaign;
      }
      if(value === '6'){
        let dataArray = {};
        dataObject.firstPair = [first_from, first_to];
        dataObject.secondPair = [second_from, second_to];
        campaignTableData.forEach((campaignData) => {
          if(campaignData.campaign_id === selectedcampaignId){
            campaignData.campaignGoalBlocksTableData.forEach((goalBlock) => {
              if ("campaign_goal_id" in goalBlock) {
                const goalId = goalBlock.goal_type+"#"+goalBlock.campaign_goal_id;
                const conversion = goalBlock.visiopt_conversions;
                dataArray[goalId] = conversion;
              }
              if("uniques" in goalBlock){
                dataArray['lp'] = goalBlock.uniques;
              }
            })
          }
        });
        dataObject.dataArray = dataArray;
      }
      if(value === '7'){
        if(velocityFrom !== "" && velocityTo !== ""){
          dataObject.from_value = velocityFrom;
          dataObject.to_value = velocityTo;
        }
      }
      setReportchartLoader(true);
      CampaignReport.getreportchartdata(dataObject)
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            navigate("/logout");
          }
        }
      })
      .then(data => {
        if(data.status === 1){
          setPieChartSourceData(data.data.pie_chart_source_data);
          setPieChartSourceColors(data.data.pie_chart_source_color);
          setSelectedGraphData(data.data.chart_data);
          setSelectedGraphType(data.data.selected_graph_type);
          setAllTimeRoasTitle(data.data.all_time_roas_title);
          setChartTime(data.data.time);
          if (value === '5') {
            const chartData: (string | Date | number | null)[][] = [
              ["Date", "CPA (daily)", "ROAS (daily)", "CPA (7-day MA, weighted)", "ROAS (7-day MA, weighted)"],
            ];
            for (let i = 1; i < data.data.chart_data.length; i++) {
              const [dateStr, cpa, roas, cpa7, roas7] = data.data.chart_data[i];
              const parsedDate = toSafeDate(dateStr);

              if (i === 1) {
              chartData.push([
                parsedDate,
                  cpa || 0,
                  roas || 0,
                  cpa7 || 0,
                  roas7 || 0,
                ]);
              } else {
                chartData.push([
                  parsedDate,
                  cpa === null ? null : cpa,
                  roas === null ? null : roas,
                  cpa7 === null ? null : cpa7,
                  roas7 === null ? null : roas7,
                ]);
              }
            }
            setChart_5_Data(chartData);
            const cpaVals = chartData.slice(1).flatMap(r => [r[1], r[3]]).filter((v): v is number => typeof v === "number" && Number.isFinite(v));
            const roasVals = chartData.slice(1).flatMap(r => [r[2], r[4]]).filter((v): v is number => typeof v === "number" && Number.isFinite(v));
            const padRange = (vals: number[], clampMinZero = false) => {
              if (!vals.length) return null;
              let min = Math.min(...vals);
              let max = Math.max(...vals);
              if (clampMinZero) min = 0;
              if (min === max) {
                const pad = max * 0.05 || 0.05;
                return { min: clampMinZero ? 0 : min - pad, max: max + pad };
              }

              const pad = (max - min) * 0.05;
              return { min: clampMinZero ? 0 : min - pad, max: max + pad };
            };
            setCpaRange(padRange(cpaVals, true));
            setRoasRange(padRange(roasVals, false));
          }
          if(value === '6'){
            setFirstFromValue(data.data.first_from_goal);
            setFirstToValue(data.data.first_to_goal);
            setSecondFromValue(data.data.second_from_goal);
            setSecondToValue(data.data.second_to_goal);
            setGoalApiCall(false);
          }
          if(value === '3'){
            const chartData: (string | Date | number | null)[][] = [
              ["Date", "Cumulative Spend", "Cumulative Conversions", "ROAS"],
            ];
            for (let i = 1; i < data.data.chart_data.length; i++) {
              const [dateStr, cumSpend, cumConv, roas] = data.data.chart_data[i];
              const parsedDate = new Date(dateStr);

              if (i === 1) {
              chartData.push([
                parsedDate,
                  cumSpend || 0,
                  cumConv || 0,
                  roas || 0,
                ]);
              } else {
                chartData.push([
                  parsedDate,
                  cumSpend === null ? null : cumSpend,
                  cumConv === null ? null : cumConv,
                  roas === null ? null : roas,
                ]);
              }
            }
            setSelectedGraphData(chartData);
          }
          if(value === '7'){
            velocityLoadedPair.current = data.data.from_value + '#' + data.data.to_value;
            setVelocityFromValue(data.data.from_value);
            setVelocityToValue(data.data.to_value);
          }
          setChartGoalDrop(data.data.campaign_goals_dropdwon);
          setReportchartLoader(false);
        }else{
          setReportchartLoader(false);
          notifications.show({
            color: 'red',
            icon: <IconX size="1.1rem" />,
            title: 'Error',
            message: data.message,
          });
        }
      })
      .catch(error => {
        console.error("API Error:", error);
        setReportchartLoader(false);
      })
    }
  };

  const chartRefs = {
    '1': useRef(null),
    '2': useRef(null),
    '3': useRef(null),
    '4': useRef(null),
    '5': useRef(null),
    '6': useRef(null),
    '7': useRef(null),
  };
  const [chartReady, setChartReady] = useState(false);

  const handleWrapperLoad = (wrapper, type) => {
    if (!wrapper) return;
    chartRefs[type].current = wrapper;
    setChartReady(true);
  };

  const resetChartState = (type) => {
    chartRefs[type].current = null;
    setChartReady(false);
  };

  const downloadChart = () => {
    const ref = chartRefs[selectedGraphType];
    if (!chartReady || !ref?.current) return;
    const chartObject = ref.current.getChart();
    if (!chartObject) return;
    const fileNames = {
      '1': "roas_all_time_vs_selected_range.png",
      '2': "total_revenue_vs_ad_spend.png",
      '3': "parallel_growth_cumulative_spend_conversions.png",
      '4': "cpc_cpm_cr_over_time.png",
      '5': "daily_efficiency_roas_cpa.png",
      '6': "goal_to_goal_conversion_uniques.png",
      '7': "velocity_report.png",
    };
    const imageURI = chartObject.getImageURI();
    const link = document.createElement("a");
    link.href = imageURI;
    link.download = fileNames[selectedGraphType] || "report_chart.png";
    link.click();
  };

  const pieChartSourceDataArray = [...pieChartSourceData];
  const pieChartSourceColorsArray = [...pieChartSourceColors];

  const pieChartOptions = {
    title: "Sources",
    pieSliceText: 'none',
    colors: pieChartSourceColorsArray,
    titleTextStyle: {
      color: colorTheme === "light" ? "#4D4D4D" : "white",
      fontSize: 18,
    },
    backgroundColor: colorTheme === "light" ? "#ffffff" : "",
    legend: {
      textStyle: {
        color: colorTheme === "light" ? "black" : "white"
      }
    }
  };
  /*END GRAPH*/

  /*START HANDLING DROPDOWN VALUE CHANGE*/
  const handleSourceDataChange = (campaignId:any, selectedValue:any) => {
    const existingSourceData = selectedSourceData.find((data) => data.campaignid === campaignId);
    setSelectedSourceData(prevData => {
      if (existingSourceData) {
        return prevData.map((data) =>
          data.campaignid === campaignId
            ? { ...data, sourceValues: selectedValue }
            : data
        );
      } else {
        return [...prevData, { campaignid: campaignId, sourceValues: selectedValue }];
      }
    });
    const dataObject = {
      ads_source: selectedValue,
      campaign_id: campaignId,
      site_id: selectedMemberWebsite,
      report_time: reportTimeValue()
    };
    setIsVisiLoaderVisible(true);
    CampaignReport.sourcenetworkdd(dataObject)
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate("/logout");
        }
      }
    })
    .then(data => {
      if(data.status === 1){
        setConversionGoalOptions((prev) => {
          const updatedOptions = prev.map((campaign) => 
            campaign.campaign_id === campaignId 
              ? { ...campaign, sourceData: data.data } 
              : campaign
          );
          return updatedOptions;
        });
        setExecuteConversionGoal(false);
        setIsVisiLoaderVisible(false);
      }else{
        setIsVisiLoaderVisible(false);
        notifications.show({
          color: 'red',
          icon: <IconX size="1.1rem" />,
          title: 'Error',
          message: data.message,
        });
      }
    })
    .catch(error => {
      console.error("API Error:", error);
      setIsVisiLoaderVisible(false);
    })
  };

  const handleOrganicCustomTagData = (campaignId:any, selectedValue:any) => {
    const existingOrganicCustomData = selectedOrganicCustomTag.find((data) => data.campaignid === campaignId);
    setSelectedOrganicCustomTag(prevData => {
      if (existingOrganicCustomData) {
        return prevData.map((data) =>
          data.campaignid === campaignId
            ? { ...data, selectedValues: selectedValue }
            : data
        );
      } else {
        return [...prevData, { campaignid: campaignId, selectedValues: selectedValue }];
      }
    });
  };

  const handleOrganicTrackingTagData = (campaignId:any, selectedValue:any) => {
    const existingOrganicTrackingData = selectedOrganicTrackingTag.find((data) => data.campaignid === campaignId);
    setSelectedOrganicTrackingTag(prevData => {
      if (existingOrganicTrackingData) {
        return prevData.map((data) =>
          data.campaignid === campaignId
            ? { ...data, selectedValues: selectedValue }
            : data
        );
      } else {
        return [...prevData, { campaignid: campaignId, selectedValues: selectedValue }];
      }
    });
  };

  const handleFacebookAccountChange = (campaignId:any, selectedId:any) => {
    const existingFacebookAccount = selectedFacebookDropdownData.find((data) => data.campaignid === campaignId);
    setSelectedFacebookDropdownData(prevData => {
      if (existingFacebookAccount) {
        return prevData.map((data) =>
          data.campaignid === campaignId
            ? { ...data, selectedValue: selectedId }
            : data
        );
      } else {
        return [...prevData, { campaignid: campaignId, selectedValue: selectedId }];
      }
    });
  };

  const handleCustomerGoalChange = (campaignId:any, selectedValue:any) => {
    const existingCustomerGoalData = selectedCustomerGoal.find((data) => data.campaignid === campaignId);
    setSelectedCustomerGoal(prevData => {
      if (existingCustomerGoalData) {
        return prevData.map((data) =>
          data.campaignid === campaignId
            ? { ...data, selectedGoal: selectedValue }
            : data
        );
      } else {
        return [...prevData, { campaignid: campaignId, selectedGoal: selectedValue }];
      }
    });
  };

  const handleTrackingTagValues = (selectedValue:any, campaignId:any, trackingKey:any, arrayId:any) => {
    const existingTackingTagData = selectedTrackingTagData.find((data) => data.campaignid === campaignId && data.trackingTagKey === trackingKey);
    const updatedData = existingTackingTagData
      ? selectedTrackingTagData.map((data) =>
          data.campaignid === campaignId && data.trackingTagKey === trackingKey
            ? { ...data, trackingTagValues: selectedValue, arrayId: arrayId }
            : data
        )
      : [...selectedTrackingTagData, { campaignid: campaignId, trackingTagKey: trackingKey, trackingTagValues: selectedValue, arrayId: arrayId }];
    const dataObject = {
        ...Object.fromEntries(
          updatedData
          .filter(data => data.arrayId && data.campaignid === campaignId)
          .map((data) => {
            return [`ads_tracking_${data.arrayId}`, data.trackingTagValues];
          })
        ),
        type: 'custom_report',
        campaign_id: campaignId,
        report_id: reportId || updateReportId,
      };
    setSelectedTrackingTagData(updatedData);
    setIsVisiLoaderVisible(true);
    CampaignReport.trackingnetworkheraricaldd(dataObject)
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate("/logout");
        }
      }
    })
    .then(data => {
      if(data.status === 1){
        setConversionGoalOptions((prev) => {
          const updatedOptions = prev.map((campaign) => 
            campaign.campaign_id === campaignId 
              ? { ...campaign, trackingTagsData: data.data } 
              : campaign
          );
          return updatedOptions;
        });
        setExecuteConversionGoal(false);
        setIsVisiLoaderVisible(false);
      }else{
        setIsVisiLoaderVisible(false);
        notifications.show({
          color: 'red',
          icon: <IconX size="1.1rem" />,
          title: 'Error',
          message: data.message,
        });
      }
    })
    .catch(error => {
      console.error("API Error:", error);
      setIsVisiLoaderVisible(false);
    })
  };

  const handleCustomTagValues = (selectedValue:any, campaignId:any, customTagKey:any, arrayId:any) => {
    const existingCustomTagData = selectedCustomTagData.find((data) => data.campaignid === campaignId && data.customTagKey === customTagKey);
    const updatedData = existingCustomTagData
      ? selectedCustomTagData.map((data) =>
          data.campaignid === campaignId && data.customTagKey === customTagKey
            ? { ...data, customTagValues: selectedValue, arrayId: arrayId }
            : data
        )
      : [...selectedCustomTagData, { campaignid: campaignId, customTagKey: customTagKey, customTagValues: selectedValue, arrayId: arrayId }];
    const selctedValues = Object.fromEntries(
      updatedData
      .filter(data => data.arrayId)
      .map((data) => {
        return [data.arrayId, data.customTagValues];
      })
    );
    const dataObject = {
        ads_custom_array: selctedValues,
        type: 'custom_report',
        campaign_id: campaignId
      };
    setSelectedCustomTagData(updatedData);
    setIsVisiLoaderVisible(true);
    CampaignReport.customnetworkheraricaldd(dataObject)
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate("/logout");
        }
      }
    })
    .then(data => {
      if(data.status === 1){
        Object.entries(data.data).forEach(([customTagName, customTagData], customTagIndex) => {
          setConversionGoalOptions((prev) => {
            const updatedOptions = prev.map((campaign) =>
              campaign.campaign_id === campaignId
                ? {
                    ...campaign,
                    customTagData: {
                      ...campaign.customTagData,
                      [customTagName]: customTagData
                    }
                  }
                : campaign
            );
            return updatedOptions;
          });
        });
        setExecuteConversionGoal(false);
        setIsVisiLoaderVisible(false);
      }else{
        setIsVisiLoaderVisible(false);
        notifications.show({
          color: 'red',
          icon: <IconX size="1.1rem" />,
          title: 'Error',
          message: data.message,
        });
      }
    })
    .catch(error => {
      console.error("API Error:", error);
      setIsVisiLoaderVisible(false);
    })
  };
  /*END HANDLING DROPDOWN VALUE CHANGE*/

  /*START FETCH ALL TRAFFIC DATA*/
  const fetchTrafficTableData = (dataObject:any) => {
    setShowAdsetTable([]);
    setShowAdsTable([]);
    setShowBacktoCampButton([]);
    setShowBacktoAdsetButton([]);
    setReportLoader(true);   
    setLoaderType("report");
    const allTrafficData = [];
    CampaignReport.getcampaignreportdata(dataObject)
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate("/logout");
        }
      }
    })
    .then(data => {
      if(data.status === 1){        
        const allCampaignData = data.data.campaign;
        const campaignCombineDataTable = data.data.combine_data_table;
        const showKeys = data.data.store_metric_selection;
        setStoreMetricKeys(data.data.store_metric_selection);
        
        if(Object.keys(showKeys).length > 0){
          const updatedGeneralColumns = generalMetricsColumns.map(column => ({
            ...column,
            show: showKeys.includes(`show_${column.key}`), 
          }));
          setGeneralColumns(updatedGeneralColumns);

          const updatedGoalColumns = goalMetricsColumns.map(column => ({
            ...column,
            show: showKeys.includes(`show_${column.key}`),
          }));
          setGoalColumns(updatedGoalColumns);

          const updatedTestVariationGoalColumns = testVariationColumns.map(column => {
            if (column.key === 'variation' || column.key === 'Conversion') {
              return {
                ...column,
                show: true,
              };
            }
            return {
              ...column,
              show: showKeys.includes(`show_${column.key}`),
            };
          });
          setTestVariationColumns(updatedTestVariationGoalColumns);

          const updatedTrafficSourceColumns = trafficSourceColumns.map(column => {
            const matchKey = column.key === 'traffic_source' ? 'show_c_r_Traffic_Source' : `show_c_r_${column.key}`;
            if (column.key === 'campaign_name') {
              return {
                ...column,
                show: true,
              };
            }

            return {
              ...column,
              show: showKeys.includes(matchKey),
            };
          });
          setTrafficSourceColumns(updatedTrafficSourceColumns);
        }

        const traffic_funnel_metrics = data.data.traffic_funnel_metrics;
        if(data.data.traffic_funnel_metrics_blocks){
          resetFunnelBlocksData('', 'campaign');
          setTrafficFunnelBlocksData(data.data.traffic_funnel_metrics_blocks, '', 'campaign');
        }
        /*START IF THERE IS NULL IN DB FOR SELECT METRICS THEN SHOW ALL VISIOPT CONVERSIONS COLUMNS*/
        const transformedMetrics = Object.entries(traffic_funnel_metrics).map(([key, value]) => {
          const show = showKeys.includes(`show_${key}`);
          return { key, value, show };
        });
        const defaultVisioptConversionColumns = Object.entries(traffic_funnel_metrics).map(([key, value]) => ({
            key,
            value,
            show: key.includes('_visiopt_conversions') ? true : false,
          })
        );
        // const hasVisibleTransformed = transformedMetrics.some(column => column.show);
        const finalMetrics = showKeys.length > 0 ? transformedMetrics : defaultVisioptConversionColumns;
        const visibleMetrics = finalMetrics.filter(column => column.show);
        setTrafficFunnelMetricsColumns(finalMetrics);
        handleSetCampaignColumns(visibleMetrics,showKeys);
        /*END IF THERE IS NULL IN DB FOR SELECT METRICS THEN SHOW ALL VISIOPT CONVERSIONS COLUMNS*/
        const storedVisibleTrafficTables = localStorage.getItem("visiTrafficTables") ? JSON.parse(atob(localStorage.getItem("visiTrafficTables"))) : {};
        const matchedEntry = Object.entries(storedVisibleTrafficTables)?.find(([id, data]) => id === reportId);
        const matchReportTables = matchedEntry ? matchedEntry[1] : [];
        if ((matchReportTables as any)?.organic_traffic) {
          setShowOrganicTrafficTable((matchReportTables as any).organic_traffic);
        }
        for (const key in allCampaignData) {
          if (allCampaignData.hasOwnProperty(key)) {
              const campaignData = {
                  campaign_name: key,
                  campaign_id: allCampaignData[key].campaign_id,
                  campaignTableData: allCampaignData[key].campaign_data,
                  campaignGoalTableData: allCampaignData[key].campaign_goal,
                  campaignGoalBlocksTableData: allCampaignData[key].campaign_goal_blocks,
                  trafficTableData: allCampaignData[key].traffic_table,
              };
              allTrafficData.push(campaignData);
          } 
          setAllCampaignTableData(allTrafficData);
          setCampaignCombineDataTable(campaignCombineDataTable);
            setAllTrafficSourceData(data.data.network_traffic_table.traffic_source);
          const tableNames = ['goals', 'variation', 'source', 'customTag', 'trackingTag', 'trafficSource', 'organicTraffic'];
          setTrafficSourceData((prevData) => {
            const campaignId = allCampaignData[key].campaign_id;
            const showCampaignTable = Object.keys(matchReportTables).includes(campaignId);
            const exists = prevData.some((item) => item.key === campaignId);

            if (exists) {
              return prevData.map((item) =>
                item.key === campaignId ? { ...item, show: showCampaignTable } : item
              );
            } else {
              return [...prevData, { key: campaignId, show: showCampaignTable }];
            }
          });
          tableNames.forEach((table) => {
            let showTable = false;
            Object.entries(matchReportTables).forEach((data, index) => {
              if(data[0] === allCampaignData[key].campaign_id && data[1].includes(table)){
                showTable = true;
              }
            });
            setShowTableByIcons((prev) =>
              prev ? prev.some((column) => column.campaign_id === allCampaignData[key].campaign_id && column.tableName === table )
                  ? prev.map((column) => column.campaign_id === allCampaignData[key].campaign_id && column.tableName === table
                        ? { ...column, show: showTable }
                        : column
                    )
                  : [...prev, { campaign_id: allCampaignData[key].campaign_id, tableName: table, show: showTable }]
                : [{ campaign_id: allCampaignData[key].campaign_id, tableName: table, show: showTable }]
            );
          });
          if (allCampaignData[key].traffic_table) {
            const filteredTrafficTable = Object.entries(allCampaignData[key].traffic_table).filter(([trafficKey]) => trafficKey !== 'traffic_source' && trafficKey !== 'custom_tag');

            filteredTrafficTable.forEach(([trafficTableKey, trafficTableData]) => {
              const networkTrafficMap = {
                source: setSourceDataTable,
                tracking_tag: setTrackingTagDataTable,
              };

              if (networkTrafficMap[trafficTableKey]) {
                const tableData = (trafficTableData as { td: any[] }).td;
                const RowTableData = Array.isArray(tableData) ? tableData : [];
                networkTrafficMap[trafficTableKey]((prev) => ({
                  ...prev,
                  [allCampaignData[key].campaign_id]: {
                    data: [...RowTableData],
                  },
                }));
              }
            });
          }
          const store_metric_selection_key = showKeys;
          {allCampaignData[key].traffic_table && Object.entries(allCampaignData[key].traffic_table).forEach((trafficTableData, trafficTableIndex) => {
            if(trafficTableData[0] === 'custom_tag') {
              Object.entries((trafficTableData[1] as { td: any[] }).td).forEach(([customTagName, customTagData]) => {
                setCustomTagDataTable((prev) => ({
                  ...prev,
                  [allCampaignData[key].campaign_id]: {
                    ...prev[allCampaignData[key].campaign_id],
                    [customTagName]: customTagData,
                  },
                }));
                setCustomTagColumns((prev) => {
                  const campaignId = allCampaignData[key].campaign_id; 
                  const combinedFunnelColumns = [...sourceMetricsColumns, ...finalMetrics];
                  const transformedColumns = Object.entries(combinedFunnelColumns).map(([columnKey, column]) => {
                    const columnData = column as { key: string; value: string; show: boolean }; 
                    const isHidden = store_metric_selection_key.length > 0 ? store_metric_selection_key.includes(`show_${columnData.key}`) : columnData.show;
                    const updatedColumn = {
                      ...columnData,
                      key: columnData.key === 'c_r_source_name' ? customTagName : columnData.key,
                      value: columnData.key === 'c_r_source_name' ? customTagName : columnData.value,
                      show: columnData.key === 'c_r_source_name' ? true : isHidden,
                    };
                    return updatedColumn;
                  });

                  return {
                    ...prev,
                    [campaignId]: {
                      ...prev[campaignId],
                      [customTagName]: transformedColumns,
                    },
                  };
                });
              });
            } 
            else if(trafficTableData[0] === 'tracking_tag') {
              const thArray = (trafficTableData[1] as { th: any[] }).th;

              Object.entries(thArray).reverse().forEach(([utmNameKey, utmNameValue], index) => {
                setTrackingTagColumns((prev) => {
                  const updatedColumns = prev[allCampaignData[key].campaign_id] ? [...prev[allCampaignData[key].campaign_id]] : [];
                  const existingKeys = new Set(updatedColumns.map(col => col.key));
                  const newFinalMetrics = finalMetrics.filter(metric => !existingKeys.has(metric.key));
                  const combinedTrackingColumns = [...updatedColumns, ...newFinalMetrics].map((col) => {
                    const showKey = `show_${col.key}`;
                    const shouldShow = !col.key.startsWith('c_r_utm_') && store_metric_selection_key.length > 0
                        ? store_metric_selection_key.includes(showKey)
                        : col.show;

                    return {
                      ...col,
                      show: shouldShow,
                    };
                  });
                  const utmColumnsExists = combinedTrackingColumns.some(column => column.key === utmNameKey);
                  if (utmNameKey.startsWith('c_r_utm_') && !utmColumnsExists) {
                    combinedTrackingColumns.unshift({ key: utmNameKey, value: utmNameValue, show: true });
                  }
                  return {
                    ...prev,
                    [allCampaignData[key].campaign_id]: combinedTrackingColumns,
                  };
                });
              });
            }else if(trafficTableData[0] === 'source'){
              const combinedSourceColumns = [...sourceMetricsColumns, ...finalMetrics].map((col) => {
                if (col.key.startsWith('c_r_')) {
                  const showKey = `show_${col.key}`;
                  const shouldShow = store_metric_selection_key.length > 0 ? store_metric_selection_key.includes(showKey) : col.show;
                  return {
                    ...col,
                    show: col.key !== 'c_r_source_name' ? shouldShow : true,
                  };
                }
                return col;
              });
              setSourceColumns((prev) => ({
                ...prev,
                [allCampaignData[key].campaign_id]: combinedSourceColumns,
              }));
            }
            if(store_metric_selection_key.length > 0){
              const updatedSourceMetricsColumns = Object.entries(sourceMetricsColumns).map(
                ([index, data]) => {
                  const column = data as { key: string; value: string; show: boolean };           
                  if (column.key === 'c_r_source_name') {
                    return { ...column, show: true };
                  }
                  const showKey = `show_${column.key}`;
                  const isCRMetric = column.key.startsWith('c_r_');
                  const isShow = isCRMetric ? store_metric_selection_key.includes(showKey) : false;
                  return { ...column, show: isShow };
                }
              );
              setSourceMetricsColumns(updatedSourceMetricsColumns);
            }
          })}          
        }
        if (data.data.network_traffic_table && data.data.network_traffic_table.traffic_source && Object.keys(data.data.network_traffic_table.traffic_source).length > 0) {
          Object.entries(data.data.network_traffic_table.traffic_source).forEach(([trafficName, trafficData]) => {
            const trafficSourceMap = {
              facebook: setFacebookData,
              google: setGoogleData,
              tiktok: setTiktokData,
              microsoft: setMicrosoftData,
              applovin: setApplovinData,
              outbrain: setOutbrainData,
              linkedin: setLinkedinData,
            };

            if (trafficSourceMap[trafficName]) {
              const tableData = (trafficData as { td: any[] }).td;
              trafficSourceMap[trafficName](() => [...tableData]);
            }

            const existingTrafficTable = showTrafficSourceTable.find((traffic) => traffic.trafficName === trafficName);
            if(existingTrafficTable){
              setShowTrafficSourceTable((prev) => 
                prev.map((traffic) => 
                  traffic.trafficName === trafficName
                    ? { ...traffic, show: true }
                    : traffic
                )
              );
            }else{
              setShowTrafficSourceTable((prev) => [
                ...prev,
                {show: true, trafficName: trafficName},
              ]);
            }
          });

          const campaignWidth = columnRefs.campaign_name.current?.offsetWidth || 0;
          const adsetWidth = columnRefs.adset_name.current?.offsetWidth || 0;

          setLeftOffsets({
            campaign_name: 135,
            adset_name: 135 + campaignWidth,
            ad_name: 135 + campaignWidth + adsetWidth,
          });
        }
        if(data.data.campaign_organic_traffic && Object.keys(data.data.campaign_organic_traffic).length > 0){
          setOrganicTrafficDataTable(data.data.campaign_organic_traffic);
          if(Object.keys(data.data.campaign_organic_traffic).length > 0){
            const visibleOrganicTrafficColumns = organicTrafficMetricsColumns.filter((column) => column.show);
            Object.entries(data.data.campaign_organic_traffic).map(([campaign_name, tableData], index) => {
              const organicTh = (tableData as any).organic_traffic?.th;
              const transformedOrganicMetrics = Object.entries(organicTh).map(([key, value]) => {
                const show = showKeys.includes(`show_${key}`);
                return { key, value, show };
              });
              const defaultOrganicVisioptConversionColumns = Object.entries(organicTh).map(([key, value]) => ({
                key: key,
                value: value,
                show: key.includes('_visiopt_conversions') ? true : false,
              }));
              const finalMetrics = showKeys.length > 0 ? transformedOrganicMetrics : defaultOrganicVisioptConversionColumns;
              setOrganicTrafficColumns((prev) => ({
                ...prev,
                [campaign_name]: [
                  ...visibleOrganicTrafficColumns, 
                  ...finalMetrics
                ],
              }));
            });
          }
        } else {
          setOrganicTrafficDataTable([]);
        }
        if(matchReportTables !== null && Object.keys(matchReportTables).includes('traffic_table')){
          setShowTrafficTables(true); 
          const table = (matchReportTables as { traffic_table: any }).traffic_table;
          setOpenedAccordion(table);
        };

        if(filterByValue !== '' && filterFromValue !== '' && filterToValue !== ''){
          handleFilterCampaignTables(filterByValue, filterFromValue, filterToValue);
        }
      } else{
        notifications.show({
          color: 'red',
          icon: <IconX size="1.1rem" />,
          title: 'Error',
          message: data.message,
        });
      }
    })
    .catch(error => {
      console.error("API Error:", error);
    })
    .finally(() => {
      setReportLoader(false);
      setLoaderType("");
      handleGraphChange(selectedGraphType, selectedGraphCampaign, firstFromValue, firstToValue, secondFromValue, secondToValue, allTrafficData, velocityFromValue, velocityToValue);
    });
  };
  /*END FETCHING ALL TRAFFIC DATA*/

  /*START TEST VARIATION*/
  const handleTestVariation = (campaignId:any, testVariationValue:any) => {
    conversionGoalOptions.map((campaign_data) => {
      if(campaignId === campaign_data.campaign_id){
        if(campaign_data.test_variation_value === 0){
          handleLocalStorageData(reportId, campaignId, 'goals', false, 'campaign', trafficSourceData);
        }else{
          handleLocalStorageData(reportId, campaignId, 'variation', false, 'campaign', trafficSourceData);
        }
      }
    });
    const testVariationCampaigns = conversionGoalOptions.filter(options => options.test_variation === 'show');
    const result = {
      report_id: reportId || updateReportId,
      test_variations_data: testVariationCampaigns.reduce((acc, options) => {
        if(options.campaign_id === campaignId){
          acc[options.campaign_id] = options.test_variation_value === 0 ? 1 : 0;
        }else{
          acc[options.campaign_id] = options.test_variation_value;
        }
        return acc;
      }, {})
    };
    apiCallCounter++;
    setIsVisiLoaderVisible(true);
    CampaignReport.savetestvariationreport(result)
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            navigate("/logout");
          }
        }
      })
      .then(data => {
        if(data.status === 1){
          conversionGoalOptions.map((campaign_data) => {
            if(campaignId === campaign_data.campaign_id){
              if(campaign_data.test_variation_value !== 0){
                handleLocalStorageData(reportId, campaignId, 'goals', true, 'campaign', trafficSourceData);
              }else{
                handleLocalStorageData(reportId, campaignId, 'variation', true, 'campaign', trafficSourceData);
              }
            }
          });
          if(selectedVisioptCampaign === campaignId){
            getVisioptCampaignGoalDropDown(campaignId, 'first_campaign');
          }else{
            getVisioptCampaignGoalDropDown(campaignId, 'comparison_campaign')
          }  
        }else{
          notifications.show({
            color: 'red',
            icon: <IconX size="1.1rem" />,
            title: 'Error',
            message: data.message,
          });
        }
      })
      .catch(error => {
        console.error("API Error:", error);
      })
      .finally(() => {
        apiCallCounter--;
        if (apiCallCounter === 0) {
          setIsVisiLoaderVisible(false);
        }
      });
  };
  /*END TEST VARIATION*/

  const [behavioralCampaignId, setBehavioralCampaignId] = useState([]);
  const [behavioralFilterModalOpen, setBehavioralFilterModalOpen] = useState(false);


  const logCampaignId = conversionGoalOptions.map(group => group.campaign_id);
  const [isResetStatsModalOpen, setIsResetStatsModalOpen] = useState(false);
  const [resetStatsCampaignId, setResetStatsCampaignId] = useState('');
  const [resetStatsSiteId, setResetStatsSiteId] = useState('');

  const [isCustomerJourneyModalOpen, setIsCustomerJourneyModalOpen] = useState(false);
  const [customerJourneyCampaignId, setCustomerJourneyCampaignId] = useState('');
  const [customerJourneyCampaignGoalId, setCustomerJourneyCampaignGoalId] = useState([]);
  const [customerJourneyCampaignDataId, setCustomerJourneyCampaignDataId] = useState('');
  const [customerJourneyType, setCustomerJourneyType] = useState('');
  const [customerJourneyAdsNetwork, setCustomerJourneyAdsNetwork] = useState('');
  const [customerJourneyAdsNetworkType, setCustomerJourneyAdsNetworkType] = useState('');
  const [customerJourneyAdsNetworkName, setCustomerJourneyAdsNetworkName] = useState('');

  // Variation Modal States
  const [isVariationModalOpen, setIsVariationModalOpen] = useState(false);
  const [selectedVariationPayload, setSelectedVariationPayload] = useState<any>(null);

  const [selectedAttributionModal, setSelectedAttributionModal] = useState('First Click');

/* ATTRIBUTION MODAL*/
  useEffect(() => {
    const selectedAttribution = attributionList.find((attribution) => attribution.selected === "selected");
    if (selectedAttribution) {
      setSelectedAttributionModal(selectedAttribution.attribution_name);
    }
  }, [attributionList]);
/* END ATTRIBUTION MODAL*/
  
  const handleColumnDataClicked = (campaignId:any='', table:any, columnkey:any) => {
    setShowColumnColor((prev) =>
      prev.some((column) => column.campaignid === campaignId && column.tableName === table && column.columnName === columnkey)
        ? prev.map((column) =>
            column.campaignid === campaignId && column.tableName === table && column.columnName === columnkey
              ? { ...column, show: !column.show }
              : column
          )
        : [...prev, { campaignid: campaignId, tableName: table, columnName: columnkey, show: true }]
    );     

    setShowTrafficColumnsColor((prev) =>
      prev.some((column) => column.tableName === table && column.columnName === columnkey)
        ? prev.map((column) =>
            column.tableName === table && column.columnName === columnkey
              ? { ...column, show: !column.show }
              : column
          )
        : [...prev, { tableName: table, columnName: columnkey, show: true }]
    );
  };

/* BEHAVIORAL DIMENSION*/ 
  const handleBehavioralFilterOpenModal = (value:any) => {
    setBehavioralCampaignId(value);
    setBehavioralFilterModalOpen(true);
  }

  const handleBehavioralFilterCloseModal = () => {
    setBehavioralFilterModalOpen(false);
  };
/* END BEHAVIORAL DIMENSION*/

/* TIME PICKER AND DATE PICKER  */
  const handleselectedTimePickerComponentChange = (Value:any) => {
    setSelectedTimePicker(Value);
    setTimeApiCall(true);
  }

  const handleselectedTimePickerToDateChange = (Value:any) => {
    setSelectedTimePickerToDate(Value);
  }

  const handleselectedTimePickerFromDateChange = (Value:any) => {
    setSelectedTimePickerFromDate(Value);
  }

  const saveTimeReport = (reportId:any, reportTime:any) => {
    CampaignReport.savetimereport({
        report_id: reportId || updateReportId,
        report_time: reportTime,
      })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            navigate("/logout");
          }
        }
      })
      .then(data => {
        if (data.status === 1) {
          if(!reportLoader) {
            // Pass the full in-memory state with type:'update' so any preview-only changes
            // (e.g. a comparison campaign added but not yet Saved) survive a time-range change.
            // Without these, the backend re-reads from the DB and drops the unsaved selections.
            fetchTrafficTableData({
              report_id: reportId || updateReportId,
              type: 'update',
              first_campaign: selectedVisioptCampaign,
              comparision_campaign: comparisonVisiCampaign,
              attribution_name: selectedAttributionModal,
              ads_tracking_network: formattedTrackingNetwork,
              ads_custom_network: formattedCustomTags,
              source: formattedSource,
              exclude_organic_custom_tag: formattedExcludeOrganicCustomTag,
              exclude_organic_tracking_tag: formattedExcludeOrganicTrackingTag,
              ads_networks_id: formattedFacebookAdsNetworksId,
              tracking_goal: formattedTrackingGoal,
              report_time: reportTime,
              test_variations_data: testVariationData,
              show_all_ad: showAllAdCosts === true ? 1 : 0,
              store_metric_selection: getAllMetricsSelection(),
              breakdown_type: breakdownSelection,
            });
          }
        } else {
          notifications.show({
            color: 'red',
            icon: <IconX size="1.1rem" />,
            title: 'Error',
            message: data.message,
          });
        }
      })
      .catch(error => {
        console.error("API Error:", error);
      });
  }

  const isValidDateRangeFormat = (date) => {
    const regex = /^\d{1,2}\/\d{1,2}\/\d{4}#\d{1,2}\/\d{1,2}\/\d{4}$/;
    return regex.test(date);
  };

  const formattedDate = (date) => {
    const [month, day, year] = date.split('-');
    return `${month}/${day}/${year}`;
  };

  const convertFormattedDate = (date) => {
    const [month, day, year] = date.split('/');
    return `${month}-${day}-${year}`;
  };

  const getTodayDate = () => {
    if(isValidDateRangeFormat(selectedDate) && !selectedTimePickerFromDate) {
      const [startDate] = selectedDate.split('#');
      const selectedFromDate = convertFormattedDate(startDate);
      const [month, day, year] = selectedFromDate.split('-');
      return `${year}-${month}-${day}`; 
    }else if(selectedTimePickerFromDate){
      const [month, day, year] = selectedTimePickerFromDate.split('-');
      return `${year}-${month}-${day}`; 
    }else if(firstCampaignStartDate){
      const [month, day, year] = firstCampaignStartDate.split('-');
      return `${year}-${month}-${day}`; 
    }else{
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    }    
  };

  const getEndDate = () => {
    if(isValidDateRangeFormat(selectedDate) && !selectedTimePickerToDate) {
      const [, endDate] = selectedDate.split('#');
      const selectedEndDate = convertFormattedDate(endDate);
      const [month, day, year] = selectedEndDate.split('-');
      return `${year}-${month}-${day}`; 
    }else if(selectedTimePickerToDate){
      const [month, day, year] = selectedTimePickerToDate.split('-');
      return `${year}-${month}-${day}`;
    }else{
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    }    
  };

  const [timeApiCall, setTimeApiCall] = useState(false);
  useEffect(() => {
    if(selectedTimePicker !== undefined && selectedTimePicker !== -2 && selectedDate !== '' && timeApiCall && (reportId || updateReportId)){
      saveTimeReport(reportId, selectedTimePicker);
    }
  }, [selectedTimePicker]);

  useEffect(() => {
    if(selectedTimePicker !== undefined && selectedTimePicker === -2 && selectedTimePickerFromDate !== '' && selectedTimePickerToDate !== '' && (reportId || updateReportId)) {
      const formattedStart = formattedDate(selectedTimePickerFromDate);
      const formattedEnd = formattedDate(selectedTimePickerToDate);
      const finalformattedDate = `${formattedStart}#${formattedEnd}`;
      saveTimeReport(reportId, finalformattedDate);
    }
  }, [selectedTimePickerFromDate, selectedTimePickerToDate]);

/* END TIME PICKER AND DATE PICKER  */
/* RESET STATS */
  const handleResetStatsModalOpen = (campaignId:any,siteId:any) => {
    setResetStatsCampaignId(campaignId);
    setResetStatsSiteId(siteId);
    setIsResetStatsModalOpen(true);
  };

  const handleResetStatsCloseModal = (value:any) => {
    setIsResetStatsModalOpen(false);
  };
/* END RESET STATS */

/* Ad Preview Handler */
  const handleAdNameClick = (rowData: any, platform: string) => {
    const adName = rowData.c_r_ad_name || '';
    const adId = rowData.encode_campaign_name || '';

    setSelectedAdPreview({
      platform,
      adName,
      adId
    });
    setShowAdPreviewDrawer(true);
  };

/* Customer Journey*/
  const [emailValue, setEmailValue] = useState('');
  const [customerJourneyPayloadData, setCustomerJourneyPayloadData] = useState<number | string | object | any[]>(null);
  const [customerJourneyGoalType, setCustomerJourneyGoalType] = useState("");
  const [goalTestId, setGoalTestId] = useState("");
  const [customerJourneyCampaignName, setCustomerJourneyCampaignName] = useState("");
  const [customerJourneyAdsetName, setCustomerJourneyAdsetName] = useState("");
  const handleCustomerJourneyOpenModal = (campaign_id:any='',goalTable:any,value:any,type:any,columnName:any='',adsnetwork:any='',adsnetworkType:any='',adsnetworkName:any='',customTagName:any='') => {
    if(value > 0){
      setCustomerJourneyCampaignId(campaign_id);
      let journey_type = type;
      if(journey_type === 'test_variation'){
        journey_type = 'goal';
      }
      setCustomerJourneyType(journey_type);
      if(type === "goal" || type === "test_variation"){
        setCustomerJourneyCampaignGoalId(goalTable.campaign_goal_id);
        setCustomerJourneyGoalType(goalTable.campaign_goal_type);
        setCustomerJourneyAdsNetwork('');
        setCustomerJourneyAdsNetworkType('');
        setCustomerJourneyAdsNetworkName('');
        setCustomerJourneyPayloadData('');
        setGoalTestId('');
      }
      if(type === "test_variation"){
        setGoalTestId(goalTable.test_id);
      }
      if(type === "organic_traffic" || type === "direct_traffic"){
       const goal_name = columnName.split('_visiopt_conversion')[0];
        const campaignGoalIdKey = goal_name+'_campaign_goal_id';
        const campaignGoalTypeKey = goal_name+'_campaign_goal_type';
        setCustomerJourneyCampaignGoalId(goalTable[campaignGoalIdKey]);
        setCustomerJourneyGoalType(goalTable[campaignGoalTypeKey]);
        setCustomerJourneyAdsNetwork('');
        setCustomerJourneyAdsNetworkType('');
        setCustomerJourneyAdsNetworkName('');
        setCustomerJourneyPayloadData('');
        setGoalTestId('');
      }
      if(type === "source" || type === "tracking_tag" || type === "custom_tag"){
        const [goal_name,] = columnName.split('_visiopt_conversion');
        const campaignGoalIdKey = goal_name+'_campaign_goal_id';
        const campaignGoalTypeKey = goal_name+'_campaign_goal_type';
        setCustomerJourneyCampaignGoalId(goalTable[campaignGoalIdKey]);
        setCustomerJourneyGoalType(goalTable[campaignGoalTypeKey]);
        setCustomerJourneyAdsNetwork('');
        setCustomerJourneyAdsNetworkType('');
        setCustomerJourneyAdsNetworkName('');
        setCustomerJourneyPayloadData('');
        setGoalTestId('');
      }
      /*FOR SOURCE ONLY PASS SOURCE ID OF CLICKABLE SOURCE CONVERSION*/
      if(type === "source"){
        setCustomerJourneyPayloadData(goalTable['c_r_source_id']);
      }
      /*FOR TRACKING TAG PASS, ALL UTM PARAMETERS WITH THEIR VALUES OF SELECTED CONVERSION*/
      if(type === "tracking_tag"){
        const utmFields = Object.entries(goalTable)
        .filter(([key, _]) => key.startsWith("c_r_utm"))
        .reduce((obj, [key, value]) => {
          obj[key] = value;
          return obj;
        }, {});
        setCustomerJourneyPayloadData(utmFields);
      }
      /*FOR CUSTOM TAG PASS, ID OF THAT SELECTED CUSTOM TAG TABLE ID AND SELECTED CUSTOM TAG NAME*/
      if(type === 'custom_tag'){
        const tagIdKey = Object.keys(goalTable).find(
          key => key.toLowerCase() === `c_r_${customTagName.toLowerCase()}_id`
        );
        const customTagId = goalTable[tagIdKey];
        let customTagVal = goalTable[`c_r_${customTagName}`];
        if (customTagVal === undefined) {
          const tagValKey = Object.keys(goalTable).find(
            key => key.toLowerCase() === `c_r_${customTagName.toLowerCase()}`
          );
          if (tagValKey) {
            customTagVal = goalTable[tagValKey];
          }
        }
        const customTagData = {
          [customTagId]: customTagVal
        };
        setCustomerJourneyPayloadData(customTagData);
      }
      /*FOR TRAFFIC SOURCE PASS, TRAFFIC SOURCE NAME, TYPE AND ITS CAMPAIGN OR ADSET OR AD NAME*/
      if(type === "traffic_source"){
        const campaign_name = goalTable.hasOwnProperty('c_r_campaign_id') ? goalTable['c_r_campaign_id'] : '';
        const adset_name = goalTable.hasOwnProperty('c_r_adset_id') ? goalTable['c_r_adset_id'] : '';
        setCustomerJourneyCampaignName(campaign_name);
        setCustomerJourneyAdsetName(adset_name);
        const campaignGoalIdKey = columnName+'_campaign_goal_id';
        const campaignDataIdKey = columnName+'_campaign_data_id';
        const campaignGoalTypeKey = columnName+'_campaign_goal_type';
        setCustomerJourneyCampaignGoalId(goalTable[campaignGoalIdKey][0]);
        setCustomerJourneyCampaignDataId(goalTable[campaignDataIdKey]);
        setCustomerJourneyGoalType(goalTable[campaignGoalTypeKey]);
        setCustomerJourneyAdsNetwork(adsnetwork);
        setCustomerJourneyAdsNetworkType(adsnetworkType);
        setCustomerJourneyAdsNetworkName(adsnetworkName);
        setCustomerJourneyPayloadData('');
        setGoalTestId('');
      }
      setIsCustomerJourneyModalOpen(true);
    }
  };

  const handleCustomerJourneyCloseModal = () => {
    setEmailValue('')
    setIsCustomerJourneyModalOpen(false);
  };
/* END Customer Journey */

  const handleVariationNameClick = (rowData: any, campaignId: any) => {
    const payload = {
      variationId: rowData['variation'] || '',
      variationName: rowData['variation'] || '',
      campaign_goal: rowData['campaign_goal_id'] || '',
      campaign_goal_type: rowData['campaign_goal_type'] || '',
      campaign_id: campaignId || '',
      report_id: reportId || updateReportId || '',
      test_id: rowData['test_id'] || '',
      time_value: reportTimeValue()
    };
    setSelectedVariationPayload(payload);
    setIsVariationModalOpen(true);
  };

  const handleVariationModalClose = () => {
    setIsVariationModalOpen(false);
    setSelectedVariationPayload(null);
  };

  const handleUpdateReport = (value:any) => {
    handleReportData(value, selectedAttributionModal);
  };

  const handleSaveReport = () => {
    if(selectedVisioptCampaign === ''){
      notifications.show({
        color: 'red',
        icon: <IconX size="1.1rem" />,
        title: 'Error',
        message: 'First Campaign is required field',
      });
    }else{
      handleSaveReportModalOpenModal('save');
    }
  };

  const reportTimeValue = () => {
    if(selectedTimePicker === -2 && isValidDateRangeFormat(selectedDate) && !selectedTimePickerFromDate && !selectedTimePickerToDate){
      return selectedDate;
    }else if(selectedTimePicker === -2 && selectedTimePickerFromDate && selectedTimePickerToDate) {
      const formattedStart = formattedDate(selectedTimePickerFromDate);
      const formattedEnd = formattedDate(selectedTimePickerToDate);
      const finalformattedDate = `${formattedStart}#${formattedEnd}`;
      return finalformattedDate;
    }else{
      return selectedTimePicker;
    }
  };
    
    const formattedTrackingGoal = selectedCustomerGoal.reduce((acc, data) => {
      const { campaignid, selectedGoal } = data;
      if (selectedGoal !== null && selectedGoal !== undefined) {
        if (!acc[campaignid]) {
          acc[campaignid] = {};
        }
        acc[campaignid] = selectedGoal;
      }
      return acc;
    }, {});

    const formattedFacebookAdsNetworksId = selectedFacebookDropdownData.reduce((acc, data) => {
      const { campaignid, selectedValue } = data;
      if (!acc[campaignid]) {
        acc[campaignid] = {};
      }
      acc[campaignid]['facebook'] = selectedValue;
      return acc;
    }, {});

    const formattedTrackingNetwork = selectedTrackingTagData.reduce((acc, data) => {
      const { campaignid, arrayId, trackingTagValues } = data;
      if (Array.isArray(trackingTagValues) && trackingTagValues.length > 0) {
        if (!acc[campaignid]) {
          acc[campaignid] = {};
        }
        acc[campaignid][arrayId] = trackingTagValues;
      }
      return acc;
    }, {});

    const formattedCustomTags = selectedCustomTagData.reduce((acc, data) => {
      const { campaignid, arrayId, customTagValues } = data;
      if (Array.isArray(customTagValues) && customTagValues.length > 0) {
        if (!acc[campaignid]) {
          acc[campaignid] = {};
        }
        acc[campaignid][arrayId] = customTagValues;
      }
      return acc;
    }, {});

    const formattedSource = selectedSourceData.reduce((acc, data) => {
      const { campaignid, sourceValues } = data;
      if (Array.isArray(sourceValues) && sourceValues.length > 0) {
        if (!acc[campaignid]) {
          acc[campaignid] = {};
        }
        acc[campaignid] = sourceValues;
      }
      return acc;
    }, {});

    const formattedExcludeOrganicCustomTag = selectedOrganicCustomTag.reduce((acc, data) => {
      const { campaignid, selectedValues } = data;
      if (Array.isArray(selectedValues) && selectedValues.length > 0) {
        if (!acc[campaignid]) {
          acc[campaignid] = {};
        }
        acc[campaignid] = selectedValues;
      }
      return acc;
    }, {});

    const formattedExcludeOrganicTrackingTag = selectedOrganicTrackingTag.reduce((acc, data) => {
      const { campaignid, selectedValues } = data;
      if (Array.isArray(selectedValues) && selectedValues.length > 0) {
        if (!acc[campaignid]) {
          acc[campaignid] = {};
        }
        acc[campaignid] = selectedValues;
      }
      return acc;
    }, {});

    const testVariationCampaigns = conversionGoalOptions.filter(options => options.test_variation === 'show');
    const testVariationData = testVariationCampaigns.reduce((acc, options) => {
      acc[options.campaign_id] = options.test_variation_value;
      return acc;
    }, {});

  const getAllMetricsSelection = () => {
    const storeMetricSelection = [];

    const metricsConfig = [
      { type: 'revenue_summary', columns: generalColumns },
      { type: 'funnel_metrics', columns: goalColumns },
      { type: 'traffic_metrics', prefix: 'c_r_', columns: trafficSourceColumns.filter(col => col.key !== 'campaign_name') },
      { type: 'campaign_goals_metrics', columns: trafficFunnelMetricsColumns },
    ];

      metricsConfig.forEach(({ type, columns, prefix = '' }) => {
        columns.forEach((col) => {
          const visibility = col.show ? 'show' : 'hide';
          let keyName = col.key;
          if (col.key === 'traffic_source') {
            keyName = col.value.replace(/\s+/g, '_');
          }
          storeMetricSelection.push(`${visibility}_${prefix}${keyName}`);
        });
      });
      
    return storeMetricSelection;
  };
  const handleReportData = (value:any,attributionValue:any) => {
    setShowAdsetTable([]);
    setShowAdsTable([]);
    setShowBacktoCampButton([]);
    setShowBacktoAdsetButton([]);
    setShowColumnColor([]);
    resetFunnelBlocksData('', 'campaign');
    /* The Customer Type breakdown is fetched lazily and cached per goal, and the toggle
       short-circuits on a cache hit - so without this it keeps serving figures from the
       PREVIOUS date range and filters after Update Report. Clearing it here, beside the other
       view resets, makes the next open re-request with the current selection. The open list
       goes too: a row left expanded would otherwise still be showing the stale numbers. */
    setCampaignGoalCt({});
    setCampaignGoalCtOpen([]);
    const storeMetricSelection = getAllMetricsSelection();
    if(value === 'save'){
      CampaignReport.savereportdata({
        report_id: reportId || updateReportId,
        first_campaign: selectedVisioptCampaign,
        comparision_campaign: comparisonVisiCampaign,
        attribution_name: attributionValue,
        ads_tracking_network: formattedTrackingNetwork,
        ads_custom_network: formattedCustomTags,
        source: formattedSource,
        exclude_organic_custom_tag: formattedExcludeOrganicCustomTag,
        exclude_organic_tracking_tag: formattedExcludeOrganicTrackingTag,
        ads_networks_id: formattedFacebookAdsNetworksId,
        tracking_goal: formattedTrackingGoal,
        report_name: reportName,
        report_time: reportTimeValue(),
        show_all_ad: showAllAdCosts === true ? 1 : 0,
        store_metric_selection : storeMetricSelection,
        breakdown_type: breakdownSelection
      })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            navigate("/logout");
          }
        }
      })
      .then(data => {
        if (data.status === 1) {
          handleSaveReportModalCloseModal();
          if(reportId) {
            getVisioptCampaignGoalDropDown(selectedVisioptCampaign, 'first_campaign');
          }else{
            reportId = data.data.report_id;
            setUpdateReportId(data.data.report_id);
            setShowUpdateButton(true);
            fetchCampaignList(reportId, data.data.report_id);
            getVisioptCampaignGoalDropDown(selectedVisioptCampaign, 'first_campaign');
          }         
          notifications.show({
            color: 'green',
            icon: <IconCheck size="1.1rem" />,
            title: 'Success',
            message: data.message,
          });
        } else {
          notifications.show({
            color: 'red',
            icon: <IconX size="1.1rem" />,
            title: 'Error',
            message: data.message,
          });
        }
      })
      .catch(error => {
        console.error("API Error:", error);
      });
    };

    if(value === 'update'){
      const dataObject = {
        report_id: reportId || updateReportId,
        type: 'update',
        first_campaign: selectedVisioptCampaign,
        comparision_campaign: comparisonVisiCampaign,
        attribution_name: attributionValue,
        ads_tracking_network: formattedTrackingNetwork,
        ads_custom_network: formattedCustomTags,
        source: formattedSource,
        exclude_organic_custom_tag: formattedExcludeOrganicCustomTag,
        exclude_organic_tracking_tag: formattedExcludeOrganicTrackingTag,
        ads_networks_id: formattedFacebookAdsNetworksId,
        tracking_goal: formattedTrackingGoal,
        report_time: reportTimeValue(),
        test_variations_data: testVariationData,
        show_all_ad: showAllAdCosts === true ? 1 : 0,
        store_metric_selection: storeMetricSelection,
        breakdown_type: breakdownSelection
      };
      fetchTrafficTableData(dataObject);
    };
  };

  /*THIS FUNCTION IS TO GET COLUMNS WHICH ARE IN ROW*/
  const getSelectedColumns = (columns:any, columnData:any) => {
    const selectedColumns: any[] = [];
    const addedKeys = new Set();
    columns?.forEach((col) => {
      columnData.forEach((rowdata) => {
        const matchingKey = Object.keys(rowdata).find((key) => key.includes(col.key));
        if (matchingKey && !addedKeys.has(col.key)) {
          selectedColumns.push({ key: col.key, value: col.value });
          addedKeys.add(col.key);
        }
      });
    });
    return selectedColumns;
  };

  function formatKey(key: string): string {
    return key
      .replace(/^c_r_/, '')
      .replace(/_/g, ' ')
      .replace(/\w\S*/g, (w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase());
  }

  const handleExportData = () => {
    if((reportId && reportId !== '') || updateReportId !== ''){
      const csvRows = [];
      setIsVisiLoaderVisible(true);
      CampaignReport.getcampaignreportdata({
        report_id: reportId || updateReportId,
        export: 1,
        first_campaign: selectedVisioptCampaign,
        comparision_campaign: comparisonVisiCampaign,
        attribution_name: selectedAttributionModal,
        ads_tracking_network: formattedTrackingNetwork,
        ads_custom_network: formattedCustomTags,
        source: formattedSource,
        exclude_organic_custom_tag: formattedExcludeOrganicCustomTag,
        exclude_organic_tracking_tag: formattedExcludeOrganicTrackingTag,
        ads_networks_id: formattedFacebookAdsNetworksId,
        tracking_goal: formattedTrackingGoal,
        report_time: reportTimeValue(),
        test_variations_data: testVariationData,
        show_all_ad: showAllAdCosts === true ? 1 : 0,
        breakdown_type: breakdownSelection
      })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            navigate("/logout");
            setIsVisiLoaderVisible(false);
          }
        }
      })
      .then(data => {
        if (data.status === 1) {        
          const allCampaignData = data.data.campaign;
          const campaignCombineDataTable = data.data.combine_data_table;

          const allTrafficData = [];
          for (const key in allCampaignData) {
            if (allCampaignData.hasOwnProperty(key)) {
                const campaignData = {
                    campaign_name: key,
                    campaign_id: allCampaignData[key].campaign_id,
                    campaignTableData: allCampaignData[key].campaign_data,
                    campaignGoalTableData: allCampaignData[key].campaign_goal,
                    trafficTableData: allCampaignData[key].traffic_table,
                };
                allTrafficData.push(campaignData);
            }
          }
          allTrafficData.forEach((campaignData, campaignIndex) => {
            const campaignDataKeys = Object.values(generalColumns);
            csvRows.push(campaignDataKeys.map(header => header.value).join(','));
            csvRows.push(campaignDataKeys.map(header => campaignData.campaignTableData[header.key] || '').join(','));
            csvRows.push('');

            if(showGoalTable) {
              showGoalTable.forEach((goals) => {
                if(goals.campaignid === campaignData.campaign_id && goals.show === true) {
                  const goalTableKeys = Object.values(goalColumns.slice(1));
                  campaignData.campaignGoalTableData.forEach((goalTable, goalIndex) => {              
                    const firstKey = Object.keys(goalTable)[0];
                    const goalTableHeaders = goalTableKeys.map(header => header.value).join(',');
                    csvRows.push(`${firstKey},${goalTableHeaders}`);
                    const firstValue = goalTable[firstKey];
                    const goalTableValue = goalTableKeys.map(header => goalTable[header.key] || '').join(',');
                    csvRows.push(`${firstValue},${goalTableValue}`);
                    /* Customer Type sits directly under the goal it splits. The rows arrive with
                       the export response, so no extra request is made per goal. Only eligible
                       goals carry them, so nothing is written for the rest. */
                    if (Array.isArray(goalTable['customer_type_rows'])) {
                      goalTable['customer_type_rows'].forEach((ct: any) => {
                        const ctCells = goalTableKeys.map((header) => {
                          /* Same derivation the screen uses, from the goal row already exported. */
                          const v = ctMetric(header.key, ct, ctNum(goalTable[firstKey]), goalTable);
                          return csvCell(v);
                        }).join(',');
                        csvRows.push(`${csvCell(`  ${ct.customer_type_name} - ${ct.conversions}`)},${ctCells}`);
                      });
                    }
                    csvRows.push('');
                  });
                }
              })
            }

            if (showTestVariation) {
              showTestVariation.forEach((variations) => {
                if (variations.campaignid === campaignData.campaign_id && variations.show === true) {
                  const testVariationKeys = Object.values(testVariationColumns);
                  Object.entries(campaignData.campaignGoalTableData).forEach(([goalName, goalData]) => {
                    Object.entries(goalData).forEach(([variationName, variationData]) => {
                      /* Bookkeeping keys are not variations - writing them produced a header
                         block with no rows under it. */
                      if (!isVariationGroupKey(variationName)) { return; }
                      csvRows.push(csvCell(variationName));
                      csvRows.push(testVariationKeys.map(header => header.value).join(','));
                      if (Array.isArray(variationData) && variationData.length > 0) {
                        variationData.forEach((rowData: any) => {
                          csvRows.push(testVariationKeys.map(header => csvCell(rowData[header.key] ?? '')).join(','));
                          /* Each variation's own split, written directly beneath that variation -
                             its first-time + returning equals THAT row's Conversion, not the
                             goal's total. Only eligible variations carry rows. */
                          const ctRows = rowData['customer_type_rows'];
                          if (Array.isArray(ctRows) && ctRows.length > 0) {
                            const parentConv = ctNum(rowData['Conversion']);
                            ctRows.forEach((ct: any) => {
                              csvRows.push(testVariationKeys.map((header) => {
                                if (header.key === 'variation') { return csvCell(`    ${ct.customer_type_name}`); }
                                if (header.key === 'Conversion') { return csvCell(ct.conversions); }
                                return csvCell(ctMetric(header.key, ct, parentConv, rowData));
                              }).join(','));
                            });
                          }
                        });
                      }
                      csvRows.push('');
                    });
                  });
                }
              });
            }

            if(campaignData.trafficTableData !== null && campaignData.trafficTableData.source && Object.entries(campaignData.trafficTableData.source).length > 0) {
              const sourceSelectedColumns: any[] = campaignData.trafficTableData.source?.th;
              const sourceColumnValues = Object.values(sourceSelectedColumns);
              const sourceKeys = Object.keys(sourceSelectedColumns);
              csvRows.push(sourceColumnValues.map(header => header).join(','));
              sourceDataTable[campaignData.campaign_id]?.data.forEach((rowData, rowIndex) => {
                csvRows.push(sourceKeys.map(header => rowData[header] || '').join(','));
              });
              csvRows.push('');
            }

            if(campaignData.trafficTableData !== null && campaignData.trafficTableData.tracking_tag && Object.entries(campaignData.trafficTableData.tracking_tag).length > 0) {
              const trackingSelectedColumns: any[] = campaignData.trafficTableData.tracking_tag?.th;
              const trackingTagColumnValue = Object.values(trackingSelectedColumns);
              const trackingTagKeys = Object.keys(trackingSelectedColumns);
              csvRows.push(trackingTagColumnValue.map(header => header).join(','));
              trackingTagDataTable[campaignData.campaign_id]?.data.forEach((rowData, rowIndex) => {
                csvRows.push(trackingTagKeys.map(header => rowData[header] || '').join(','));
              });
              csvRows.push('');
            }

            if(campaignData.trafficTableData !== null && campaignData.trafficTableData.custom_tag && Object.entries(campaignData.trafficTableData.custom_tag.th).length > 0) {
              Object.entries(campaignData.trafficTableData.custom_tag.th).forEach((customTagName, customTagIndex) => {
                const customSelectedColumns: any[] = campaignData.trafficTableData.custom_tag?.th?.[customTagName[0]];
                const customTagColumnValue = Object.values(customSelectedColumns);
                const customTagKeys = Object.keys(customSelectedColumns);
                csvRows.push(customTagColumnValue.map(header => header).join(','));
                customTagDataTable[campaignData.campaign_id]?.[customTagName[0]]?.forEach((rowData, rowIndex) => {
                  csvRows.push(customTagKeys.map(header => rowData[header] || '').join(','));
                });
              })        
              csvRows.push('');
            }
          })

          if (data.data.network_traffic_table && data.data.network_traffic_table.traffic_source && Object.keys(data.data.network_traffic_table.traffic_source).length > 0) {
            Object.entries(data.data.network_traffic_table.traffic_source).forEach(([trafficName, trafficData]) => {
              const tableData = (trafficData as { td: any[] }).td;
              const tableKeys = Object.keys(tableData[0]);
              let trafficSourceKeys: { key: string, value: string }[] = [];
              /*GET COLUMN KEY NAME OF GOAL WISE THROUGH TRAFFIC FUNNEL METRICS AND REST OF THE KEYS LIKE UNIQUE, VISIT GET FROM TABLE TH*/
              tableKeys?.map((keyName) => {
                if (data.data.traffic_funnel_metrics && Object.keys(data.data.traffic_funnel_metrics).length > 0){
                  const matchedEntry = Object.entries(data.data.traffic_funnel_metrics).find(([columnKey, columnValue]) => columnKey === keyName);
                  if(matchedEntry){
                    trafficSourceKeys.push({ key: matchedEntry[0], value: matchedEntry[1] as string });
                  }else{
                    const value = formatKey(keyName);
                    trafficSourceKeys.push({ key: keyName, value: value as string });
                  }
                }else{
                  const value = formatKey(keyName);
                  trafficSourceKeys.push({ key: keyName, value: value as string });
                }
              });

              console.log(trafficSourceKeys);

              trafficSourceKeys = trafficSourceKeys.filter((item) => item.key !== 'type' && item.key !== 'encode_campaign_name' && item.key !== 'checkbox' && item.key !== 'c_r_adset_id' && item.key !== 'c_r_ad_id' && item.key !== 'device_breakdown' && item.key !== 'hour_breakdown' && !item.key.includes('customer_type_breakdown') && item.key !== 'customer_type_eligible' && !item.key.includes('_campaign_goal_id') && !item.key.includes('_session_ids') && !item.key.includes('campaign_data_id') && !item.key.includes('_campaign_goal_id_with_type') && !item.key.includes('_campaign_goal_type'));
              if (trafficName === "linkedin") {
                const updatedColumns = trafficSourceKeys.map(col => {
                  if (col.key === "c_r_campaign_name") {
                    return { ...col, value: "Campaign Group Name" };
                  }
                  if (col.key === "c_r_adset_name") {
                    return { ...col, value: "Campaign Name" };
                  }
                  if (col.key === "c_r_ad_name") {
                    return { ...col, value: "Ad" };
                  }
                  return col;
                });
                trafficSourceKeys = updatedColumns;
              }
              csvRows.push(trafficSourceKeys.map(header => header.value).join(','));
              const deviceIdentifierKeys = ['c_r_campaign_name', 'c_r_adset_name', 'c_r_ad_name', 'c_r_campaignid'];
              const deviceBlankKeys = ['c_r_traffic_source', 'checkbox', 'c_r_placement'];
              const firstIdentifierKey = trafficSourceKeys.find(h => deviceIdentifierKeys.includes(h.key))?.key;
              tableData.forEach(rowData => {
                csvRows.push(trafficSourceKeys.map(header => (rowData[header.key] === undefined || rowData[header.key] === null) ? '' : rowData[header.key].toString()).join(','));
                if (showDeviceBreakdown && Array.isArray(rowData.device_breakdown) && rowData.device_breakdown.length > 0 && rowData['c_r_traffic_source'] !== 'Total') {
                  rowData.device_breakdown.forEach(dev => {
                    let firstIdentifierUsed = false;
                    const devCells = trafficSourceKeys.map(header => {
                      if (header.key === firstIdentifierKey && !firstIdentifierUsed) {
                        firstIdentifierUsed = true;
                        return `"  -> ${dev.device_name}"`;
                      }
                      if (deviceIdentifierKeys.includes(header.key) || deviceBlankKeys.includes(header.key)) {
                        return '';
                      }
                      const val = dev[header.key];
                      return (val === undefined || val === null || val === '') ? '' : val.toString();
                    });
                    csvRows.push(devCells.join(','));
                  });
                }
                if (showHourBreakdown && Array.isArray(rowData.hour_breakdown) && rowData.hour_breakdown.length > 0 && rowData['c_r_traffic_source'] !== 'Total') {
                  rowData.hour_breakdown.forEach(h => {
                    let firstIdentifierUsed = false;
                    const hourCells = trafficSourceKeys.map(header => {
                      if (header.key === firstIdentifierKey && !firstIdentifierUsed) {
                        firstIdentifierUsed = true;
                        return `"  -> ${h.hour_label}"`;
                      }
                      if (deviceIdentifierKeys.includes(header.key) || deviceBlankKeys.includes(header.key)) {
                        return '';
                      }
                      const val = h[header.key];
                      return (val === undefined || val === null || val === '') ? '' : val.toString();
                    });
                    csvRows.push(hourCells.join(','));
                  });
                }
                /* Customer Type sub-rows, same shape as the device block above. A column that is
                   not an eligible purchase goal exports "-", matching what the report displays,
                   so an ineligible cell is never mistaken for a zero. */
                if (showCustomerTypeBreakdown && Array.isArray(rowData.customer_type_breakdown) && rowData.customer_type_breakdown.length > 0) {
                  const ctFlags = (rowData as any)?.customer_type_eligible;
                  const ctEligible = (colKey: string) => {
                    if (!ctFlags || typeof ctFlags !== 'object') { return false; }
                    const hit = Object.keys(ctFlags).find((k) => colKey.includes(k) || k.includes(colKey));
                    return hit ? Number(ctFlags[hit]) === 1 : false;
                  };
                  rowData.customer_type_breakdown.forEach((ct: any) => {
                    let firstIdentifierUsed = false;
                    const ctCells = trafficSourceKeys.map(header => {
                      if (header.key === firstIdentifierKey && !firstIdentifierUsed) {
                        firstIdentifierUsed = true;
                        return `"  -> ${ct.customer_type_name}"`;
                      }
                      if (deviceIdentifierKeys.includes(header.key) || deviceBlankKeys.includes(header.key)) {
                        return '';
                      }
                      if (!ctEligible(header.key)) { return '-'; }
                      const val = ct[header.key];
                      return (val === undefined || val === null || val === '') ? '' : val.toString();
                    });
                    csvRows.push(ctCells.join(','));
                  });
                }
              });
            });
          }

          if(data.data.campaign_organic_traffic && Object.keys(data.data.campaign_organic_traffic).length > 0){
            Object.entries(data.data.campaign_organic_traffic).map(([campaign_name, tableData], index) => {
              const organicTh = (tableData as any).organic_traffic.th || {};
              const organicThColumns = Object.entries(organicTh).map(([key, value]) => ({
                key,
                value,
                show: true
              }));

              const organicColumns = [...organicTrafficMetricsColumns, ...organicThColumns];
              csvRows.push(`Campaign Name: ${campaign_name}`);
              csvRows.push(organicColumns.map(header => header.value).join(','));
              // Organic and Direct are two rows of the same table.
              ['organic_traffic', 'direct_traffic'].forEach((rowKey) => {
                const organicData = (tableData as any)[rowKey]?.td;
                if (organicData) {
                  csvRows.push(organicColumns.map(header => (organicData[header.key] ?? '').toString()).join(','));
                }
              });
            })
          }

          if(Object.entries(campaignCombineDataTable).length > 0){
            csvRows.push(Object.values(generalColumns).map(header => header.value).join(','));
            csvRows.push(Object.keys(campaignCombineDataTable).map(key => campaignCombineDataTable[key] ?? '-').join(','));
          }

          setIsVisiLoaderVisible(false);
          const csvContent = csvRows.join('\n');
          const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'exported_campaign_report.csv');
          document.body.appendChild(link);
          link.click(); 
          document.body.removeChild(link);
        }else{
          setIsVisiLoaderVisible(false);
        }
      })
      .catch(error => {
        console.error("API Error:", error);
        setIsVisiLoaderVisible(false);
      });
    }
    
  };

  /*START BACK TO CAMPAIGN BUTTON*/
  const [triggerTrafficbackToCampaign, setTriggerTrafficbackToCampaign] = useState<string | null>(null);
  const handleRemoveCampaignBackButton = (trafficName:any) => {
    const trafficAdsetKey = trafficName+'Adset';
    const trafficAdsKey = trafficName+'Ads';
    setCheckedUniquesVisits(prev => prev.filter(item => item.trafficName !== trafficAdsetKey && item.trafficName !== trafficAdsKey));
    setCheckedGoalConversion(prev => prev.filter(item => item.trafficName !== trafficAdsetKey && item.trafficName !== trafficAdsKey));
    const filteredFacebookBtn = showBacktoCampButton.filter((config) => config.trafficName === trafficName ? null : config);
    setShowBacktoCampButton(filteredFacebookBtn);

    const filteredAdsetBtn = showBacktoAdsetButton.filter((config) => config.trafficName === trafficName ? null : config);
    setShowBacktoAdsetButton(filteredAdsetBtn);

    const existingAdsTable = showAdsTable.find((ads) => ads.trafficName === trafficName);
    if(existingAdsTable){
      setShowAdsTable((prev) => 
        prev.map((ads) => 
          ads.trafficName === trafficName
            ? { ...ads, show: false }
            : ads
        )
      );
    } 
    const existingAdsetTable = showAdsetTable.find((adset) => adset.trafficName === trafficName);
    if(existingAdsetTable){
      setShowAdsetTable((prev) => 
        prev.map((adset) => 
          adset.trafficName === trafficName
            ? { ...adset, show: false }
            : adset
        )
      );
    } 

    const existingTrafficTable = showTrafficSourceTable.find((traffic) => traffic.trafficName === trafficName);
    if(existingTrafficTable){
      setShowTrafficSourceTable((prev) => 
        prev.map((traffic) => 
          traffic.trafficName === trafficName
            ? { ...traffic, show: true }
            : traffic
        )
      );
    }
    const funnelBlocksCampaignCopy = {
      facebook: facebookFunnelBlocksCampaignCopy,
      google: googleFunnelBlocksCamCopy,
      microsoft: microsoftFunnelBlocksCamCopy,
      tiktok: tiktokFunnelBlocksCampaignCopy,
      applovin: applovinFunnelBlocksCamCopy,
      outbrain: outbrainFunnelBlocksCampaignCopy,
      linkedin: linkedinFunnelBlocksCampaignCopy,
    };
    const setFunnelBlockData = {
      facebook: setFacebookFunnelBlocks,
      google: setGoogleFunnelBlocks,
      microsoft: setMicrosoftFunnelBlocks,
      tiktok: setTiktokFunnelBlocks,
      applovin: setApplovinFunnelBlocks,
      outbrain: setOutbrainFunnelBlocks,
      linkedin: setLinkedinFunnelBlocks,
    };
    setFunnelBlockData[trafficName]?.(funnelBlocksCampaignCopy[trafficName]);
    setTriggerTrafficbackToCampaign(trafficName);
  };
  /*END BACK TO CAMPAIGN BUTTON*/

  /*START BACK TO ADSET BUTTON*/
  const [triggerTrafficbackToAdset, setTriggerTrafficbackToAdset] = useState<string | null>(null);
  const handleRemoveAdsetBackButton = (trafficName:any) => {  
    const trafficAdsKey = trafficName+'Ads';
    setCheckedUniquesVisits(prev => prev.filter(item => item.trafficName !== trafficAdsKey));
    setCheckedGoalConversion(prev => prev.filter(item => item.trafficName !== trafficAdsKey));
    const filteredAdsetBtn = showBacktoAdsetButton.filter((config) => config.trafficName === trafficName ? null : config);
    setShowBacktoAdsetButton(filteredAdsetBtn);

    const existingAdsTable = showAdsTable.find((ads) => ads.trafficName === trafficName);
    if(existingAdsTable){
      setShowAdsTable((prev) => 
        prev.map((ads) => 
          ads.trafficName === trafficName
            ? { ...ads, show: false }
            : ads
        )
      );
    } 
    const existingAdsetTable = showAdsetTable.find((adset) => adset.trafficName === trafficName);
    if(existingAdsetTable){
      setShowAdsetTable((prev) => 
        prev.map((adset) => 
          adset.trafficName === trafficName
            ? { ...adset, show: true }
            : adset
        )
      );
    } 

    const existingTrafficTable = showTrafficSourceTable.find((traffic) => traffic.trafficName === trafficName);
    if(existingTrafficTable){
      setShowTrafficSourceTable((prev) => 
        prev.map((traffic) => 
          traffic.trafficName === trafficName
            ? { ...traffic, show: false }
            : traffic
        )
      );
    }
    const funnelBlocksAdsetCopy = {
      facebook: facebookFunnelBlocksAdsetCopy,
      google: googleFunnelBlocksAdsetCopy,
      tiktok: tiktokFunnelBlocksAdsetCopy,
      linkedin: linkedinFunnelBlocksAdsetCopy
    };
    const setFunnelBlockData = {
      facebook: setFacebookFunnelBlocks,
      google: setGoogleFunnelBlocks,
      tiktok: setTiktokFunnelBlocks,
      linkedin: setLinkedinFunnelBlocks,
    };
    setFunnelBlockData[trafficName]?.(funnelBlocksAdsetCopy[trafficName]);
    setTriggerTrafficbackToAdset(trafficName);
  };
  /*END BACK TO ADSET BUTTON*/

  /*START FILTER TABLES BY COLUMNS*/
  const handleFilterByChange = (value:any) => {
    setFilterByValue(value);
    handleFilterCampaignTables(value, filterFromValue, filterToValue);
  };

  const handleFilterFromChange = (value: any) => {
    if (!isNaN(value) || value === '') {
      setFilterFromValue(value);
    }
  };

  const handleFilterToChange = (value: any) => {    
    if (!isNaN(value) || value === '') {
      setFilterToValue(value);
    }
  };

  const getFilteredData = (data:any, metric:any, from:any, to:any) => {
    const fromvalue = parseFloat(from.replace(/,/g, ""));
    const toValue = parseFloat(to.replace(/,/g, ""));    
    const totalRows = (data ?? []).filter((rowData: any) =>
      Object.values(rowData).some(
        (val) => typeof val === "string" && val === "Total"
      )
    );
    const filteredData = (data ?? []).filter((rowData) => {
      const hasTotalValue = Object.values(rowData).some((val) =>
        typeof val === "string" && val.toLowerCase().includes("total")
      );
      if (hasTotalValue) return false;
      const filteredValueData = rowData[metric];
      if (filteredValueData !== null && filteredValueData !== undefined) {
        const filterValue = parseFloat(filteredValueData.toString().replace(/,/g, ""));
        return (
          !isNaN(filterValue) &&
          filterValue >= fromvalue &&
          filterValue <= toValue
        );
      }else{
        return false;
      }      
    });
    return [...filteredData, ...totalRows];
  }

  const handleFilterCampaignTables = (filterMetric:any, fromValue:any, toValue:any) => {   
    const trafficSourceSetMap = {
      facebook: setFacebookData,
      google: setGoogleData,
      microsoft: setMicrosoftData,
      tiktok: setTiktokData,
      applovin: setApplovinData,
      outbrain: setOutbrainData,
      linkedin: setLinkedinData,
    };

    const trafficAdsetMap = {
      facebook: setFacebookAdsetData,
      google: setGoogleAdsetData,
      tiktok: setTiktokAdsetData,
      microsoft: setMicrosoftAdsetData,
      applovin: setApplovinAdsetData,
      linkedin: setLinkedinAdsetData,
    };

    const trafficAdsMap = {
      facebook: setFacebookAdsData,
      google: setGoogleAdsData,
      tiktok: setTiktokAdsData,
      linkedin: setLinkedinAdsData,
    };

    if (filterMetric !== '' && fromValue !== '' && toValue !== '') {
      /*FILTER TRAFFIC SOURCE TABLES DATA*/
      const namesArray = ['facebook', 'google', 'microsoft', 'tiktok', 'applovin', 'outbrain', 'linkedin'];
      const adsetNamesArray = ['facebook', 'google', 'microsoft', 'tiktok', 'applovin', 'linkedin'];
      const adsNamesArray = ['facebook', 'google', 'tiktok', 'linkedin'];
      if(allTrafficSourceData !== undefined && (allTrafficSourceData.length > 0 || Object.keys(allTrafficSourceData).length > 0)){
        namesArray.forEach((name) => {
          const data = allTrafficSourceData[name]?.td;
          const filteredData = getFilteredData(data, filterMetric, fromValue, toValue);
          trafficSourceSetMap[name](filteredData);
        });
      }
      if(trafficAdsetData !== undefined && (trafficAdsetData.length > 0 || Object.keys(trafficAdsetData).length > 0)){
        adsetNamesArray.forEach((name) => {
          const data = trafficAdsetData[name]?.td;
          const filteredData = getFilteredData(data, filterMetric, fromValue, toValue);
          trafficAdsetMap[name](filteredData);
        });
      }
      if(adsetAdsData !== undefined && (adsetAdsData.length > 0 || Object.keys(adsetAdsData).length > 0)){
        adsNamesArray.forEach((name) => {
          const data = adsetAdsData[name]?.td;          
          const filteredData = getFilteredData(data, filterMetric, fromValue, toValue);
          trafficAdsMap[name](filteredData);
        });
      }
    }else{
      if(allTrafficSourceData !== undefined){
        Object.entries(allTrafficSourceData).forEach(([trafficName, trafficData]) => {
          if (trafficSourceSetMap[trafficName]) {
            const tableData = (trafficData as { td: any[] }).td;
            trafficSourceSetMap[trafficName](() => [...tableData]);
          } 
        });
      }

      if(trafficAdsetData !== undefined){
        Object.entries(trafficAdsetData).forEach(([trafficName, trafficData]) => {
          if (trafficAdsetMap[trafficName]) {
            const tableData = (trafficData as { td: any[] }).td;
            trafficAdsetMap[trafficName](() => {
              const dataArray = Array.isArray(tableData) ? tableData : Object.values(tableData);
              return [...dataArray];
            });
          } 
        });
      }

      if(adsetAdsData !== undefined){
        Object.entries(adsetAdsData).forEach(([trafficName, trafficData]) => {
          if (trafficAdsMap[trafficName]) {
            const tableData = (trafficData as { td: any[] }).td;
            trafficAdsMap[trafficName](() => {
              const dataArray = Array.isArray(tableData) ? tableData : Object.values(tableData);
              return [...dataArray];
            });
          } 
        });
      }
    }
  };
  /*END FILTER TABLES BY COLUMNS*/

  const handleShowIcons = (campaignId:any, table:any) => {
    let updatedShowValue = false;
    setShowTableByIcons((prev) => {
      const exists = prev.some((column) => column.campaign_id === campaignId && column.tableName === table);
      if (exists) {
        return prev.map((column) => {
          if (column.campaign_id === campaignId && column.tableName === table) {
            const newShow = !column.show;
            updatedShowValue = newShow;
            return { ...column, show: newShow };
          }
          return column;
        });
      } else {
        updatedShowValue = true;
        return [...prev, { campaign_id: campaignId, tableName: table, show: true }];
      }
    });
    handleLocalStorageData(reportId, campaignId, table, updatedShowValue, 'campaign', trafficSourceData);
  };

  const handleOrganicOpen = () => {
    let show = !showOrganicTrafficTable;
    setShowOrganicTrafficTable(!showOrganicTrafficTable);
    handleLocalStorageData(reportId, '', 'organicTraffic', show, 'organicTraffic', '', '');
  };


  const fetchGraphCampaignList = () => {
    CampaignReport.getcampaigndropdown({
      campaign_id: selectedCampaigns,
      selected_campaign_id: selectedGraphCampaign
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate("/logout");
        }
      }
    })
    .then(data => {
      if (data.status === 1) {
        setGraphCampaignList(data.data.campaign_drop_list);
        setShowGraphCampaignDropdown(data.data.campaign_drop_display);
        const selectedCampaign = data.data.campaign_drop_list.find((campaign) => campaign.selected === 'selected')?.campaign_id;
        setSelectedGraphCampaign(selectedCampaign);
      }
    })
    .catch(error => {
      console.error("API Error:", error);
    });
  };

  const handleGraphCampaignChange = (value:any) => {
    setFirstFromValue("");
    setFirstToValue("");
    setSecondFromValue("");
    setSecondToValue("");
    setVelocityFromValue("");
    setVelocityToValue("");
    setSelectedGraphCampaign(value);
    handleGraphChange(selectedGraphType, value, "", "", "", "", allCampaignTableData, "", "");
  };

  const filterSearchData = (totalData:any, data:any, searchOn:any, value:any) => {
    const searchField = 'c_r_'+searchOn;
    const totalRow = totalData.filter(row => row['c_r_traffic_source'] === 'Total');
    const filteredData = data.filter(row => row['c_r_traffic_source'] !== 'Total').filter(row => row[searchField]?.toString().toLowerCase().includes(value.toLowerCase()));
    const finalData = filteredData.concat(totalRow);
    return finalData;
  };

  const handleSearch = (value: any, trafficName:any, tableName: any, searchOn: any) => {
    const searchMapValue = {
      campaign_name: campaignSearchValue,
      campaignid: campaignSearchValue,
      adset_name: adsetSearchValue,
      ad_name: adsSearchValue,
      placement: placement
    };
    const searchMapSetValue = {
      campaign_name: setCampaignSearchValue,
      campaignid: setCampaignSearchValue,
      adset_name: setAdsetSearchValue,
      ad_name: setAdsSearchValue,
      placement: setPlacement
    };
    const existingTrafficTable = searchMapValue[searchOn].find((traffic) => traffic.trafficName === trafficName && traffic.tableName === tableName);
    if(existingTrafficTable){
      searchMapSetValue[searchOn]((prev) => 
        prev.map((traffic) => 
          traffic.trafficName === trafficName && traffic.tableName === tableName
            ? { ...traffic, value: value }
            : traffic
        )
      );
    }else{
      searchMapSetValue[searchOn]((prev) => [
        ...prev,
        {value: value, trafficName: trafficName, tableName: tableName},
      ]);
    }

    const trafficSourceSetMap = {
      facebook: setFacebookData,
      facebookAdset: setFacebookAdsetData,
      facebookAds: setFacebookAdsData,
      google: setGoogleData,
      googleAdset: setGoogleAdsetData,
      googleAds: setGoogleAdsData,
      microsoft: setMicrosoftData,
      microsoftAdset: setMicrosoftAdsetData,
      tiktok: setTiktokData,
      tiktokAdset: setTiktokAdsetData,
      tiktokAds: setTiktokAdsData,
      applovin: setApplovinData,
      applovinAdset: setApplovinAdsetData,
      outbrain: setOutbrainData,
      linkedin: setLinkedinData,
      linkedinAdset: setLinkedinAdsetData,
      linkedinAds: setLinkedinAdsData,
    };

    const trafficSourceMap = {
      facebook: facebookData,
      facebookAdset: facebookAdsetData,
      facebookAds: facebookAdsData,
      google: googleData,
      googleAdset: googleAdsetData,
      googleAds: googleAdsData,
      microsoft: microsoftData,
      microsoftAdset: microsoftAdsetData,
      tiktok: tiktokData,
      tiktokAdset: tiktokAdsetData,
      tiktokAds: tiktokAdsData,
      applovin: applovinData,
      applovinAdset: applovinAdsetData,
      outbrain: outbrainData,
      linkedin: linkedinData,
      linkedinAdset: linkedinAdsetData,
      linkedinAds: linkedinAdsData,
    };

    let campaignSearchTrafficValue = '';
    let adsetSearchTrafficValue = '';
    let adsSearchTrafficValue = '';
    if(campaignSearchValue && campaignSearchValue.length > 0){
      const matchCampaignValue = campaignSearchValue.find((traffic) => traffic.trafficName === trafficName && traffic.tableName === tableName);
      campaignSearchTrafficValue = matchCampaignValue ? matchCampaignValue.value : '';
    }else if(searchOn === 'campaign_name' || searchOn === 'campaignid'){
      campaignSearchTrafficValue = value;
    }
    if(adsetSearchValue && adsetSearchValue.length > 0){
      const matchAdsetValue = adsetSearchValue.find((traffic) => traffic.trafficName === trafficName && traffic.tableName === tableName);
      adsetSearchTrafficValue = matchAdsetValue ? matchAdsetValue.value : '';
    }else if(searchOn === 'adset_name'){
      adsetSearchTrafficValue = value;
    }
    if(adsSearchValue && adsSearchValue.length > 0){
      const matchAdsValue = adsSearchValue.find((traffic) => traffic.trafficName === trafficName && traffic.tableName === tableName);
      adsSearchTrafficValue = matchAdsValue ? matchAdsValue.value : '';
    }else if(searchOn === 'ad_name'){
      adsSearchTrafficValue = value;
    }

    if(searchOn === 'campaign_name' || searchOn === 'campaignid'){
      let finalCampaignData = [];      
      if(!tableName.includes('Adset') && !tableName.includes('Ads')){
        const data = allTrafficSourceData[trafficName]?.td;
        finalCampaignData = filterSearchData(data, data, searchOn, value);
        setFilteredData(finalCampaignData);
      }else if(tableName.includes('Adset') && adsetSearchTrafficValue === ''){
        const data = trafficAdsetData[trafficName]?.td;
        finalCampaignData = filterSearchData(data, data, searchOn, value);
        setFilteredData(finalCampaignData);
      }else if(tableName.includes('Adset') && adsetSearchTrafficValue !== ''){
        finalCampaignData = filterSearchData(filteredData, filteredData, searchOn, value);
      }else if(tableName.includes('Ads') && adsetSearchTrafficValue === '' && adsSearchTrafficValue === ''){
        const data = adsetAdsData[trafficName]?.td;
        finalCampaignData = filterSearchData(data, data, searchOn, value);
        setFilteredData(finalCampaignData);
      }else if(tableName.includes('Ads') && (adsetSearchTrafficValue !== '' || adsSearchTrafficValue !== '')){
        finalCampaignData = filterSearchData(filteredData, filteredData, searchOn, value);
      }
      trafficSourceSetMap[tableName]((prevData) => {
        const updatedData = finalCampaignData.map((data) => {
          const previousData = lastTrafficSourceData.find((prev) => prev.table === tableName)?.data;
          const matchData = previousData && previousData.length > 0 ? previousData.find((prev) => prev.campaign_name === data.campaign_name) : null;
          return {
            ...data,
            ...(matchData ? { checkbox: matchData.checkbox } : {}),
          };
        });
        return updatedData;
      });
    }
    
    if(searchOn === 'adset_name'){
      let finalAdsetData = [];      
      let searchOnName = trafficName === 'applovin' ? 'ad_name' : searchOn;
      if(campaignSearchTrafficValue === '' && tableName.includes('Adset')){
        const data = trafficAdsetData[trafficName]?.td;
        finalAdsetData = filterSearchData(data, data, searchOnName, value);
        setFilteredData(finalAdsetData);
      }else if(campaignSearchTrafficValue !== '' && tableName.includes('Adset')){
        finalAdsetData = filterSearchData(trafficSourceMap[tableName], filteredData, searchOnName, value);
      }else if(tableName.includes('Ads') && campaignSearchTrafficValue === '' && adsSearchTrafficValue === ''){
        const data = adsetAdsData[trafficName]?.td;
        finalAdsetData = filterSearchData(data, data, searchOnName, value);
        setFilteredData(finalAdsetData);
      }else{
        finalAdsetData = filterSearchData(filteredData, filteredData, searchOnName, value);
      }

      trafficSourceSetMap[tableName]((prevData) => {
        const updatedData = finalAdsetData.map((data) => {
          const matchData = prevData.find((prev) => prev.campaign_name === data.campaign_name);
          return {
            ...data,
            ...(matchData ? { checkbox: matchData.checkbox } : {}),
          };
        });
        return updatedData;
      });
    }

    if(searchOn === 'ad_name'){
      let finalAdsData = [];
      if(campaignSearchTrafficValue === '' && adsetSearchTrafficValue === ''){
        const data = adsetAdsData[trafficName]?.td;
        finalAdsData = filterSearchData(data, data, searchOn, value);
        setFilteredData(finalAdsData);
      }else{
        finalAdsData = filterSearchData(trafficSourceMap[tableName], filteredData, searchOn, value);
      }
      trafficSourceSetMap[tableName]((prevData) => {
        const updatedData = finalAdsData.map((data) => {
          const matchData = prevData.find((prev) => prev.campaign_name === data.campaign_name);
          return {
            ...data,
            ...(matchData ? { checkbox: matchData.checkbox } : {}),
          };
        });
        return updatedData;
      });
    }

    if(searchOn === 'placement'){
      let finalPlacementdata = [];      
      if(!tableName.includes('Adset') && !tableName.includes('Ads')){
        if(campaignSearchTrafficValue === ''){
          const data = allTrafficSourceData[trafficName]?.td;
          finalPlacementdata = filterSearchData(data, data, searchOn, value);
          setFilteredData(finalPlacementdata);
        }else{
          finalPlacementdata = filterSearchData(trafficSourceMap[tableName], filteredData, searchOn, value); 
        }
      }else if(tableName.includes('Adset')){
        if(campaignSearchTrafficValue === '' && adsetSearchTrafficValue === ''){
          const data = trafficAdsetData[trafficName]?.td;
          finalPlacementdata = filterSearchData(data, data, searchOn, value);
          setFilteredData(finalPlacementdata);
        }else{
          finalPlacementdata = filterSearchData(trafficSourceMap[tableName], filteredData, searchOn, value); 
        }
      }else if(tableName.includes('Ads')){
        if(campaignSearchTrafficValue === '' && adsetSearchTrafficValue === '' && adsSearchTrafficValue === ''){
          const data = adsetAdsData[trafficName]?.td;
          finalPlacementdata = filterSearchData(data, data, searchOn, value);
          setFilteredData(finalPlacementdata);
        }else{
          finalPlacementdata = filterSearchData(trafficSourceMap[tableName], filteredData, searchOn, value); 
        }
      } 
      trafficSourceSetMap[tableName]((prevData) => {
        const updatedData = finalPlacementdata.map((data) => {
          const matchData = prevData.find((prev) => prev.campaign_name === data.campaign_name);
          return {
            ...data,
            ...(matchData ? { checkbox: matchData.checkbox } : {}),
          };
        });
        return updatedData;
      });
    }
  };

  /*START HANDLING CALCULATION OF TRAFFIC FUNNEL BLOCKS*/
  const [checkedUniquesVisits, setCheckedUniquesVisits] = useState<{ trafficName: string; traffic_campaign_name: string; uniques: number; visits: number; rowIndex: number;  }[]>([]);
  const [checkedGoalConversion, setCheckedGoalConversion] = useState<{ trafficName: string; traffic_campaign_name: string; goalId: string; rowIndex: number; }[]>([]);

  /*USEEFFCT FOR HANDLING CHECKED CHECKBOX DATA WHEN CAMPAIGN IS SELECTED*/
  useEffect(() => {
    const trafficSourceStates = {
      facebook: facebookData,
      google: googleData,
      microsoft: microsoftData,
      tiktok: tiktokData,
      applovin: applovinData,
      outbrain: outbrainData,
      linkedin: linkedinData,
    }; 
    if (triggerTrafficbackToCampaign) {
      const data = trafficSourceStates[triggerTrafficbackToCampaign];
      if (data) {
        sendRowCalculation(data, triggerTrafficbackToCampaign);
      }
      setTriggerTrafficbackToCampaign(null);
    }
  }, [triggerTrafficbackToCampaign]);

  const sendRowCalculation = (data:any, trafficName:any) => {
    const selectedRows = data?.filter((row) => row.c_r_traffic_source !== 'Total');
    selectedRows?.forEach((row, index) => {
      calculateCheckedData(row, index, trafficName);
    });
  };

  useEffect(() => {
    sendRowCalculation(facebookData, 'facebook');
  }, [facebookData]);

  useEffect(() => {
    sendRowCalculation(facebookAdsetData, 'facebookAdset');
  }, [facebookAdsetData]);

  useEffect(() => {
    sendRowCalculation(googleData, 'google');
  }, [googleData]);

  useEffect(() => {
    sendRowCalculation(googleAdsetData, 'googleAdset');
  }, [googleAdsetData]);

  useEffect(() => {
    sendRowCalculation(microsoftData, 'microsoft');
  }, [microsoftData]);

  useEffect(() => {
    sendRowCalculation(microsoftAdsetData, 'microsoftAdset');
  }, [microsoftAdsetData]);

  useEffect(() => {
    sendRowCalculation(tiktokData, 'tiktok');
  }, [tiktokData]);

  useEffect(() => {
    sendRowCalculation(tiktokAdsetData, 'tiktokAdset');
  }, [tiktokAdsetData]);

  useEffect(() => {
    sendRowCalculation(applovinData, 'applovin');
  }, [applovinData]);

  useEffect(() => {
    sendRowCalculation(applovinAdsetData, 'applovinAdset');
  }, [applovinAdsetData]);

  useEffect(() => {
    sendRowCalculation(outbrainData, 'outbrain');
  }, [outbrainData]);

  useEffect(() => {
    sendRowCalculation(linkedinData, 'linkedin');
  }, [linkedinData]);

  useEffect(() => {
    sendRowCalculation(linkedinAdsetData, 'linkedinAdset');
  }, [linkedinAdsetData]);
  
  /*USEEFFCT FOR HANDLING CHECKED CHECKBOX DATA WHEN ADSET IS SELECTED*/
  useEffect(() => {
    const trafficSourceStates = {
      facebookAdset: facebookAdsetData,
      googleAdset: googleAdsetData,
      microsoftAdset: microsoftAdsetData,
      tiktokAdset: tiktokAdsetData,
      applovinAdset: applovinAdsetData,
      linkedinAdset: linkedinAdsetData,
    };  
    if(triggerTrafficbackToAdset){
      const trafficName = triggerTrafficbackToAdset+'Adset';
      const data = trafficSourceStates[trafficName];
      if (data) {
        const selectedRows = data.filter((row) => row.traffic_source !== 'Total');
        selectedRows.forEach((row, index) => {
          calculateCheckedData(row, index, trafficName);
        });
      }
      setTriggerTrafficbackToAdset(null);
    }
  }, [triggerTrafficbackToAdset]);

  const calculateCheckedData = (rowData:any, rowIndex:number, trafficName:string) => {
    if(rowData.checkbox === true){
      const goalsConversions = Object.entries(rowData)
        .filter(([key]) => key.includes('_visiopt_conversions_campaign_goal_id_with_type'))
        .map(([key, goalId]) => {
          const prefix = key.replace('_visiopt_conversions_campaign_goal_id_with_type', '');
          const conversionsKey = `${prefix}_visiopt_conversions`;
          const conversions = parseInt(rowData[conversionsKey] || '0', 10);

          return {
            goalId: goalId,
            conversions,
            rowIndex,
            trafficName,
          };
      });

      let campaign_name = rowData.c_r_campaign_id;
      let campaign_adset_name = rowData.c_r_campaign_id;
      if(trafficName.includes('Adset')){
        campaign_adset_name = campaign_name+'#visi#'+rowData.c_r_adset_id;
      }else if(trafficName.includes('Ads')){
        campaign_adset_name = campaign_name+'#visi#'+rowData.c_r_ad_id;
      }
      setCheckedUniquesVisits(prev => {
        const exists = prev.some(item => item.rowIndex === rowIndex && item.trafficName === trafficName);
        return exists ? prev : [...prev, { trafficName: trafficName, traffic_campaign_name: campaign_adset_name, uniques: rowData.c_r_uniques, visits: rowData.c_r_visits, rowIndex: rowIndex }];
      });
      setCheckedGoalConversion(prev => {
        let newConversions = (goalsConversions as {
          goalId: string[];
          rowIndex: number;
          trafficName: string;
        }[])
          .flatMap(newItem =>
            newItem.goalId.map(goalId => ({
              trafficName: newItem.trafficName,
              traffic_campaign_name: campaign_adset_name,
              goalId: goalId,
              rowIndex: newItem.rowIndex,
            }))
          )
          .filter(newItem =>
            !prev.some(existingItem =>
              existingItem.rowIndex === newItem.rowIndex &&
              existingItem.trafficName === newItem.trafficName &&
              existingItem.goalId === newItem.goalId
            )
          );
        return [...prev, ...newConversions];
      });
    }else{
      setCheckedUniquesVisits(prev => prev.filter(item => item.rowIndex !== rowIndex || item.trafficName !== trafficName));
      setCheckedGoalConversion(prev => prev.filter(item => item.rowIndex !== rowIndex || item.trafficName !== trafficName));
    }
  };

  useEffect(() => {
    const funnelBlocksSetters = {
      facebook: setFacebookFunnelBlocks,
      google: setGoogleFunnelBlocks,
      microsoft: setMicrosoftFunnelBlocks,
      tiktok: setTiktokFunnelBlocks,
      applovin: setApplovinFunnelBlocks,
      outbrain: setOutbrainFunnelBlocks,
      linkedin: setLinkedinFunnelBlocks,
    };

    const trafficNamesArray = ['facebook', 'google', 'microsoft', 'tiktok', 'applovin', 'outbrain', 'linkedin'];
    trafficNamesArray.forEach((trafficName) => {
      funnelBlocksSetters[trafficName]?.((prev) => {
        let updatedData = prev ? JSON.parse(JSON.stringify(prev)) : [];
        Object.entries(updatedData).forEach(([campaignIndex, campaignDataRaw]) => {
          let conversionWithGoalId = [];
          const campaignData = campaignDataRaw as FunnelBlock;
          Object.entries(campaignData).forEach(([trafficBlockName, trafficBlockGroup]) => {
            let totalUniques = 0;
            let totalVisits = 0;
            const isTrackedTraffic = trafficNamesArray.includes(trafficName.toLowerCase());
            const filteredCheckedUniquesVisits = checkedUniquesVisits?.filter((item) =>
              item.trafficName.includes(trafficName)
            );
            const filteredCheckedConversions = checkedGoalConversion?.filter((item) => item.trafficName.includes(trafficName));
            if ((filteredCheckedUniquesVisits.length === 0 || filteredCheckedConversions.length === 0) && isTrackedTraffic) {
              if (trafficBlockGroup.lp_page_unique) {
                trafficBlockGroup.lp_page_unique.forEach((campaignObj) => {
                  Object.entries(campaignObj).forEach(([campaignName, counts]) => {
                    const countData = counts as any;
                    totalUniques += Number(countData.uniques || 0);
                    totalVisits += Number(countData.visits || 0);
                    Object.entries(countData).forEach(([key, value]) => {
                      if (key !== 'visits' && key !== 'uniques') {
                        const existingGoal = conversionWithGoalId.find((goal) => goal.goal_id === key && goal.traffic_name === trafficName);
                        const conversionValue = Number(value || 0);
                        if (existingGoal) {
                          existingGoal.conversions += conversionValue;
                        } else {
                          conversionWithGoalId.push({
                            traffic_name: trafficName,
                            goal_id: key,
                            conversions: conversionValue,
                          });
                        }
                      }
                    });
                  });
                })
              }
            }else{
              if(trafficBlockGroup.lp_page_unique){
                trafficBlockGroup.lp_page_unique.forEach((campaignObj) => {
                  Object.entries(campaignObj).forEach(([campaignName, campaignUniqueVisits]) => {
                    const campaignUniqueVisitsData = campaignUniqueVisits as any;
                    filteredCheckedUniquesVisits.forEach((item) => {
                      if (item.traffic_campaign_name === campaignName) {
                        totalUniques += Number(campaignUniqueVisitsData.uniques || 0); 
                        totalVisits += Number(campaignUniqueVisitsData.visits || 0);
                      }
                    });
                    filteredCheckedConversions.forEach((item) => {
                      if (item.traffic_campaign_name === campaignName) {
                        const existingGoal = conversionWithGoalId.find((goal) => goal.goal_id === item.goalId && goal.traffic_name === trafficName);
                        const conversionValue = Number(campaignUniqueVisitsData[item.goalId] || 0);
                        if (existingGoal) {
                          existingGoal.conversions += conversionValue;
                        } else {
                          conversionWithGoalId.push({
                            traffic_name: trafficName,
                            goal_id: item.goalId,
                            conversions: conversionValue,
                          });
                        }
                      }
                    });
                    
                  });
                })
              }
            }

            /*SET DATA OF CHECKED CHECKBOX*/
            if (trafficBlockGroup.goal_blocks) {
              const updatedGoalData = trafficBlockGroup.goal_blocks.map((goalBlock) => {
                const updatedBlock = { ...goalBlock };
                if ('uniques' in goalBlock) {
                  updatedBlock.uniques = totalUniques;
                }            
                if ('visits' in goalBlock) {
                  updatedBlock.visits = totalVisits;
                }
                if ('visiopt_conversions' in goalBlock && goalBlock.goal_type !== 'button') {
                  const goalBlockId = goalBlock.goal_id+'_'+goalBlock.goal_type;
                  const matchingConversion = conversionWithGoalId.find((goalData) => goalData.goal_id === goalBlockId && goalData.traffic_name === trafficName);
                  updatedBlock.visiopt_conversions = matchingConversion ? matchingConversion.conversions : 0;
                }
                return updatedBlock;
              });
              
              /*CALCULATE UNIQUE PERCENTAGE*/
              const updated = updatedGoalData.map((data, goalIndex) => {
                const updatedData = { ...data };
                let uniquePercentage = 0;
                let uniquesPercentageText = '';
                if (goalIndex === 1) {
                  if(updatedGoalData[0].uniques !== 0){
                    uniquePercentage = (updatedData.visiopt_conversions / updatedGoalData[0].uniques) * 100;
                  }
                  uniquesPercentageText = '% Visits from ' + updatedGoalData[0].custom_title;
                } else if (goalIndex > 1) {
                  if(updatedGoalData[goalIndex - 1].visiopt_conversions !== 0){
                    uniquePercentage = (updatedData.visiopt_conversions / updatedGoalData[goalIndex - 1].visiopt_conversions) * 100;
                  }
                  uniquesPercentageText = '% Visits from ' + updatedGoalData[goalIndex - 1].custom_title;
                }
                if (!isFinite(uniquePercentage)) {
                  uniquePercentage = 0;
                }
                uniquePercentage = parseFloat(uniquePercentage.toFixed(2)) || 0;
                updatedData.unique_percentage = uniquePercentage + uniquesPercentageText;
                if(updatedData.goal_type !== 'button'){
                  let ucr = (updatedData.visiopt_conversions / updatedGoalData[0].uniques) * 100;
                  let gcr = (updatedData.visiopt_conversions / updatedGoalData[0].visits) * 100;
                  if (!isFinite(ucr) || isNaN(ucr)) ucr = 0;
                  if (!isFinite(gcr) || isNaN(gcr)) gcr = 0;
                  updatedData.ucr = ucr.toFixed(2);
                  updatedData.gcr = gcr.toFixed(2);
                }
                return updatedData;
              });
              trafficBlockGroup.goal_blocks = updated;
            }
          });
        });
        return updatedData;
      });
    });
  }, [checkedUniquesVisits, checkedGoalConversion]);
  
  /*END HANDLING CALCULATION OF TRAFFIC FUNNEL BLOCKS*/

  const handleAnalyzeLifecycleOpenModal = (campaignId: any) => {
    setLifecycleCampaignId(campaignId);
    setShowLifecycleModal(true);
  }
  
  const funnelBlocksRow = (trafficName:any) => {
    const trafficFunnelBlocksData = {
      facebook: facebookFunnelBlocks,
      google: googleFunnelBlocks,
      microsoft: microsoftFunnelBlocks,
      tiktok: tiktokFunnelBlocks,
      applovin: applovinFunnelBlocks,
      outbrain: outbrainFunnelBlocks,
      linkedin: linkedinFunnelBlocks
    }
    const funnelBlocksData = trafficFunnelBlocksData[trafficName];
    return (
      <>
        {Object.entries(funnelBlocksData)?.map(([campaignId, campaignData]) => {
          return Object.entries(campaignData).map(([trafficBlockName, trafficBlocksData]) => {
            return Object.entries(trafficBlocksData).map(([trafficBlockKey, trafficBlockData]) => {
              if (trafficBlockKey === 'goal_blocks') {
                const goals = trafficBlockData as any[];
                return (
                  <>
                    <Text weight={500} size={20} style={{ marginTop: '20px', marginLeft: '5px' }}>{goals[0].visiopt_campaign}</Text>
                    <SimpleBar forceVisible="x" autoHide={false} style={{paddingBottom : '12px'}}> 
                      <table>
                        <tbody>
                          <tr>
                            {goals && goals.map((goal, index) => {
                              return (
                                <>
                                  {index !== 0 && <div className="page-arrow" style={{ marginTop: "75%" }} />}
                                  {goalCards(goal.custom_title, goal.uniques,goal.visits,goal.visiopt_conversions, goal.ucr, goal.gcr, goal.thumb, goal.unique_percentage)}
                                </>
                              );
                            })}
                          </tr>
                        </tbody>
                      </table>
                      </SimpleBar>
                  </>
                );
              }
              return null;
            });
          });
        })}
      </>
    )
  };

  const handleClickClockCon = (trafficSource:any, columnKey:any, rowData:any, trafficLevel:any) => {
    const encode_traffic_name = rowData.hasOwnProperty('encode_campaign_name') ? rowData['encode_campaign_name'] : '';
    const campaign_name = rowData.hasOwnProperty('c_r_campaign_id') ? rowData['c_r_campaign_id'] : '';
    const adset_name = rowData.hasOwnProperty('c_r_adset_id') ? rowData['c_r_adset_id'] : '';
    const goalIds = rowData[columnKey+'_campaign_goal_id'];
    const campaign_id = rowData[columnKey+'_campaign_data_id'];
    const goalName = trafficFunnelMetricsColumns.find((d) => d.key === columnKey)?.value;
    let display_campaign_name = rowData.hasOwnProperty('c_r_campaign_name') ? rowData['c_r_campaign_name'] : '';
    if(trafficLevel === 'adset'){
      display_campaign_name = rowData.hasOwnProperty('c_r_adset_name') ? rowData['c_r_adset_name'] : '';
    }else if(trafficLevel === 'ads'){
      display_campaign_name = rowData.hasOwnProperty('c_r_ad_name') ? rowData['c_r_ad_name'] : '';
    }
    setShowVelocityDrawer(true);
    setVelocityDrawerGoalName(goalIds[0]);
    setVelocityDrawerEncodeTrafficName(encode_traffic_name);
    setVelocityDrawerCampaignName(campaign_name);
    setVelocityDrawerAdsetName(adset_name);
    setVelocityDrawerTrafficSourceName(trafficSource);
    setVelocityDrawerCampaignId(campaign_id);
    setVelocityDrawerTrafficLevel(trafficLevel);
    setVelocityDrawerGoalType(rowData[columnKey+'_campaign_goal_type']);
    setVelocityDrawerCombinedGoalType(goalName.includes('(Combined)'));
    setVelocityDrawerDisplayCampaignName(display_campaign_name);
  };

  const handleClickKeywordView = (rowData:any) => {
    const campaignKey = Object.keys(rowData).find(key =>
      key.endsWith('_campaign_data_id')
    );
    const campaign_id = campaignKey ? rowData[campaignKey] : null;
    const adset_name = rowData['c_r_adset_name'];
    const adset_id = rowData['c_r_adset_id'];
    setShowKeywordDrawer(true);
    setSelectedAdsetCampaignid(campaign_id);
    setSelectedAdsetName(adset_name);
    setSelectedAdsetId(adset_id);
  };

  /* Keyword View on an individual ad. Uses the same encoded ad id the ad preview uses, since both
     identify the ad by the creative id Google put on the click. */
  const handleClickAdKeywordView = (rowData:any) => {
    const campaignKey = Object.keys(rowData).find(key =>
      key.endsWith('_campaign_data_id')
    );
    const campaign_id = campaignKey ? rowData[campaignKey] : null;
    setShowAdKeywordDrawer(true);
    setSelectedAdKeywordCampaignid(campaign_id);
    setSelectedAdKeywordName(rowData['c_r_ad_name']);
    setSelectedAdKeywordEncodedId(rowData['encode_campaign_name']);
  };

  const columnRefs = {
    campaign_name: useRef<HTMLTableCellElement>(null),
    adset_name: useRef<HTMLTableCellElement>(null),
    ad_name: useRef<HTMLTableCellElement>(null),
  };

  const [leftOffsets, setLeftOffsets] = useState({
    campaign_name: 0,
    adset_name: 0,
    ad_name: 0,
  });

  const getThStyle = (column:any,isColor:any,tableName:string='') => {    
    const rowColor = colorTheme === "light" ? '#fff' : '#25262b' ;
    const thStyle = {
      cursor: 'pointer',
      backgroundColor: isColor ? '#E4E9ED' : rowColor,
      whiteSpace: 'nowrap'
    } as React.CSSProperties;
    let trafficSourceWidth = 96;
    const hasTrafficSource = tableName && campaignColumns[tableName]?.some(col => col[0] === 'traffic_source');
    const tableSortConfig = trafficSortConfig.filter(config => config.table === tableName);
    const isTrafficSourceSorted = tableSortConfig.some(
      config => config.key === 'traffic_source' && config.direction
    ); 

    if (column === 'traffic_source' && hasTrafficSource) {
      thStyle.position = 'sticky';
      thStyle.left = 0;
      thStyle.zIndex = 6;
      thStyle.width = '90px';
    }else if (column === 'checkbox') {
      thStyle.position = 'sticky';
      // thStyle.left = hasTrafficSource ? `${trafficSourceWidth}px` : '0px';
      const baseLeft = hasTrafficSource ? trafficSourceWidth : 0;
       thStyle.left = isTrafficSourceSorted ? `${baseLeft + 24}px` : `${baseLeft}px`;
      thStyle.zIndex = 5;
      thStyle.width = '50px';
    }else if(column === 'campaignid'){
      thStyle.position = 'sticky';
      thStyle.left = hasTrafficSource ? leftOffsets['campaign_name'] : (leftOffsets['campaign_name'] - trafficSourceWidth);
      thStyle.zIndex = 3;
      thStyle.width = '250px';
      thStyle.minWidth = '250px';
      thStyle.maxWidth = '400px';
      thStyle.whiteSpace = 'normal';
      thStyle.wordBreak = 'break-word';
      thStyle.paddingLeft = isTrafficSourceSorted ? '40px' : '25px';
    }else if (['campaign_name', 'campaignid', 'adset_name', 'ad_name'].includes(column)) {
      thStyle.position = 'sticky';
      thStyle.left = hasTrafficSource ? leftOffsets[column] : (leftOffsets[column] - trafficSourceWidth);
      thStyle.zIndex = 3;
      thStyle.width = '250px';
      thStyle.minWidth = '250px';
      thStyle.maxWidth = '400px';
      thStyle.whiteSpace = 'normal';
      thStyle.wordBreak = 'break-word';
      thStyle.paddingLeft = isTrafficSourceSorted ? '40px' : '25px';
    }
    if(column === 'placement'){
      thStyle.width = '100px';
      thStyle.minWidth = '160px';
      thStyle.maxWidth = '250px';
    }
    return thStyle;
  };

  /*TRAFFIC SOURCE CAMPAIGN TABLE*/
  const trafficSourceConfig: Record<string, { icon: React.ReactNode; color: string; label: string }> = {
    facebook: {
      icon: <IconBrandFacebook size={20} color="#1877F2" />,
      color: "#1877F2",
      label: "Facebook",
    },
    google: {
      icon: <IconBrandGoogle size={20} color="#1877F2" />,
      color: "#1877F2",
      label: "Google",
    },
    microsoft: {
      icon: <IconBrandWindows size={20} color="#1877F2" />,
      color: "#1877F2",
      label: "Microsoft",
    },
    tiktok: {
      icon: <IconBrandTiktok size={20} color="black" />,
      color: 'black',
      label: 'Tiktok',
    },
    applovin: {
      icon: <Image src="/img/social-media/applovin_icon.png" width={20} height={20}/>,
      color: 'cyan',
      label: 'Applovin',
    },
    outbrain: {
      icon: <Image src="/img/social-media/outbrain-icon.png" width={30} height={30}/>,
      color: 'orange',
      label: 'Outbrain',
    },
    linkedin: {
      icon: <IconBrandLinkedin size={20} color="#1877F2" />,
      color: "#1877F2",
      label: "LinkedIn",
    },
    chatgpt: {
      icon: <IconBrandOpenai size={20} color="black" />,
      color: "black",
      label: "ChatGPT",
    },
  };

  // Paid ChatGPT table: single aggregate row. Uses campaignColumns['chatgpt'] so it follows the metric
  // show/hide selection and proper goal-name labels. Hides checkbox, campaign/adset/ad name columns and the Total row.
  const chatgptTrafficSourceTable = (trafficData:any) => {
    const rows = (trafficData && trafficData.td) ? trafficData.td : [];
    const dataRows = rows.filter((r:any) => r['c_r_traffic_source'] !== 'Total');
    if (dataRows.length === 0) { return null; }
    const excludeKeys = ['checkbox','campaign_name','campaignid','campaign_id','adset_name','adset_id','ad_name','ad_id','placement','device_name'];
    const configColumns = campaignColumns['chatgpt'] || [];
    const columns:any[] = [];
    const addedKeys = new Set();
    configColumns.forEach((col:any) => {
      if (excludeKeys.includes(col[0]) || addedKeys.has(col[0])) { return; }
      const matchingKey = Object.keys(dataRows[0]).find((key) => key.includes(col[0]));
      if (matchingKey) {
        columns.push({ key: col[0], value: col[1] });
        addedKeys.add(col[0]);
      }
    });
    const rowColor = colorTheme === "light" ? '#fff' : '#25262b';
    const subRowBg = colorTheme === 'light' ? '#edf5ff' : '#2c3847';
    // Device/Hour breakdown sub-row: device/hour label goes in the first (traffic_source) column.
    const renderCgptBreakdownRows = (row:any, rowIndex:number, breakdownKey:string, labelKey:string, prefix:string) => {
      const breakdown = Array.isArray(row[breakdownKey]) ? row[breakdownKey] : [];
      if (breakdown.length === 0) { return null; }
      return breakdown.map((sub:any, si:number) => (
        <tr key={`${prefix}-${rowIndex}-${si}`} style={{ background: subRowBg }}>
          {columns.map((col, colIndex) => {
            if (col.key === 'traffic_source') {
              return (<td key={colIndex} style={{ background: subRowBg }}><span style={{ paddingLeft: '14px', fontStyle: 'italic', opacity: 0.9 }}>&#8627; {sub[labelKey]}</span></td>);
            }
            const matchedKey = Object.keys(sub).find((key) => key.includes(col.key));
            const v = matchedKey ? sub[matchedKey] : undefined;
            return (<td key={colIndex} style={{ background: subRowBg }}>{(v === undefined || v === null || v === '') ? '-' : v}</td>);
          })}
        </tr>
      ));
    };
    return (
      <SimpleBar forceVisible="x" autoHide={false} style={{ paddingBottom: '10px' }}>
        <Table striped highlightOnHover withBorder my={5} fontSize="xs" withColumnBorders style={{ borderCollapse: 'separate', borderSpacing: 'unset' }}>
          <thead>
            <tr>
              {columns.map((col, index) => (
                <th key={index} style={{ backgroundColor: rowColor, whiteSpace: 'nowrap' }}>{col.value}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {dataRows.map((row:any, rowIndex:number) => (
              <React.Fragment key={rowIndex}>
                <tr>
                  {columns.map((col, colIndex) => {
                    const matchedKey = Object.keys(row).find((key) => key.includes(col.key));
                    const columnValue = matchedKey ? row[matchedKey] : '';
                    const isConv = col.key.includes('_visiopt_conversions');
                    return (
                      <td
                        key={colIndex}
                        style={isConv ? { cursor: 'pointer' } : undefined}
                        onClick={isConv ? () => handleCustomerJourneyOpenModal('', row, columnValue, 'traffic_source', col.key, 'chatgpt', 'campaign', row['encode_campaign_name']) : undefined}
                      >
                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                          <span>{columnValue}</span>
                          {isConv && (
                            <button
                              onClick={(e) => { e.stopPropagation(); handleClickClockCon('chatgpt', col.key, row, 'campaign'); }}
                              title="Velocity Report"
                              style={{ background: 'transparent', border: 'none', cursor: 'pointer', padding: '4px', color: velocityIconColor, display: 'flex', alignItems: 'center' }}
                              onMouseOver={(e) => (e.currentTarget.style.backgroundColor = velocityIconHoverBg)}
                              onMouseOut={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
                            >
                              <IconClock size="1.1rem" />
                            </button>
                          )}
                        </div>
                      </td>
                    );
                  })}
                </tr>
                {showDeviceBreakdown && renderCgptBreakdownRows(row, rowIndex, 'device_breakdown', 'device_name', 'cgpt-dev')}
                {showHourBreakdown && renderCgptBreakdownRows(row, rowIndex, 'hour_breakdown', 'hour_label', 'cgpt-hour')}
              </React.Fragment>
            ))}
          </tbody>
        </Table>
      </SimpleBar>
    );
  };

  const renderDeviceBreakdownRows = (rowData: any, columns: any[], rowIndex: number, isTotalRow: boolean, tableName: string) => {
    if (!showDeviceBreakdown) return null;
    if (isTotalRow) return null;
    const breakdown = rowData?.device_breakdown;
    if (!Array.isArray(breakdown) || breakdown.length === 0) return null;
    const identifierCols = ['campaign_name', 'adset_name', 'ad_name', 'campaignid'];
    const emptyCols = new Set(['traffic_source', 'checkbox', 'placement', 'encode_campaign_name', 'type']);
    const subRowBg = colorTheme === 'light' ? '#edf5ff' : '#2c3847';
    const firstIdentifierIdx = columns.findIndex((c: any) => identifierCols.includes(c.key));
    return breakdown.map((dev: any, di: number) => (
      <tr key={`dev-${rowIndex}-${di}`} style={{ background: subRowBg }}>
        {columns?.map((col: any, colIndex: number) => {
          const thStyle = getThStyle(col.key, false, tableName);
          const cellStyle = { ...thStyle, backgroundColor: subRowBg, fontWeight: 400 } as any;
          if (colIndex === firstIdentifierIdx) {
            return (
              <td key={colIndex} style={cellStyle}>
                <span style={{ paddingLeft: '14px', fontStyle: 'italic', opacity: 0.9 }}>
                  &#8627; {dev.device_name}
                </span>
              </td>
            );
          }
          if (emptyCols.has(col.key) || identifierCols.includes(col.key)) {
            return <td key={colIndex} style={cellStyle}></td>;
          }
          const matchedKey = Object.keys(dev).find((key) => key.includes(col.key));
          const v = matchedKey ? dev[matchedKey] : undefined;
          const display = (v === undefined || v === null || v === '') ? '-' : v;
          return <td key={colIndex} style={cellStyle}>{display}</td>;
        })}
      </tr>
    ));
  };

  // Hour-of-day sub-row renderer — mirror of device, keyed off hour_breakdown / hour_label.
  /* Customer Type sub-rows - same shape as the device breakdown.
     A conversion column can only be split when its goal is a webhook with Count as Purchase
     enabled. Any column that is not eligible is drawn as a muted "-" rather than left blank,
     so an empty cell is never mistaken for a zero. Values come from the report; nothing is
     calculated here. */
  const renderCustomerTypeBreakdownRows = (rowData: any, columns: any[], rowIndex: number, isTotalRow: boolean, tableName: string) => {
    if (!showCustomerTypeBreakdown) return null;
    if (isTotalRow) return null;
    /* The two segments are fixed, so the rows can be drawn before the report supplies any
       figures - that is what makes the layout reviewable ahead of the calculation. Once the
       report sends customer_type_breakdown these same rows fill in; nothing here changes. */
    const CT_SEGMENTS = ['First-time Customers', 'Returning Customers'];
    const supplied = Array.isArray(rowData?.customer_type_breakdown) ? rowData.customer_type_breakdown : [];
    const breakdown = CT_SEGMENTS.map((name) => {
      const match = supplied.find((x: any) => x && x.customer_type_name === name);
      return match ? match : { customer_type_name: name };
    });
    const identifierCols = ['campaign_name', 'adset_name', 'ad_name', 'campaignid'];
    const emptyCols = new Set(['traffic_source', 'checkbox', 'placement', 'encode_campaign_name', 'type']);
    const subRowBg = colorTheme === 'light' ? '#edf5ff' : '#2c3847';
    const naColor  = colorTheme === 'light' ? '#adb5bd' : '#6c757d';
    const firstIdentifierIdx = columns.findIndex((c: any) => identifierCols.includes(c.key));
    /* Eligibility travels with the row, one flag per conversion column. */
    const eligible = (colKey: string) => {
      const flags = rowData?.customer_type_eligible;
      if (!flags || typeof flags !== 'object') { return false; }
      const hit = Object.keys(flags).find((k) => colKey.includes(k) || k.includes(colKey));
      return hit ? Number(flags[hit]) === 1 : false;
    };
    return breakdown.map((ct: any, ci: number) => (
      <tr key={`ct-${rowIndex}-${ci}`} style={{ background: subRowBg }}>
        {columns?.map((col: any, colIndex: number) => {
          const thStyle = getThStyle(col.key, false, tableName);
          const cellStyle = { ...thStyle, backgroundColor: subRowBg, fontWeight: 400 } as any;
          if (colIndex === firstIdentifierIdx) {
            return (
              <td key={colIndex} style={cellStyle}>
                <span style={{ paddingLeft: '14px', fontStyle: 'italic', opacity: 0.9 }}>
                  &#8627; {ct.customer_type_name}
                </span>
              </td>
            );
          }
          if (emptyCols.has(col.key) || identifierCols.includes(col.key)) {
            return <td key={colIndex} style={cellStyle}></td>;
          }
          /* Not a purchase-webhook column: say so distinctly, rather than showing a number that
             would read as "none of these were first-time buyers". */
          if (!eligible(col.key)) {
            return (
              <td key={colIndex} style={cellStyle}>
                <span style={{ color: naColor, fontStyle: 'italic' }} title="Customer Type applies only to webhook goals with Count as Purchase enabled">-</span>
              </td>
            );
          }
          const matchedKey = Object.keys(ct).find((key) => key.includes(col.key));
          const v = matchedKey ? ct[matchedKey] : undefined;
          const display = (v === undefined || v === null || v === '') ? '-' : v;
          return <td key={colIndex} style={cellStyle}>{display}</td>;
        })}
      </tr>
    ));
  };

  const renderHourBreakdownRows = (rowData: any, columns: any[], rowIndex: number, isTotalRow: boolean, tableName: string) => {
    if (!showHourBreakdown) return null;
    if (isTotalRow) return null;
    const breakdown = rowData?.hour_breakdown;
    if (!Array.isArray(breakdown) || breakdown.length === 0) return null;
    const identifierCols = ['campaign_name', 'adset_name', 'ad_name', 'campaignid'];
    const emptyCols = new Set(['traffic_source', 'checkbox', 'placement', 'encode_campaign_name', 'type']);
    const subRowBg = colorTheme === 'light' ? '#edf5ff' : '#2c3847';
    const firstIdentifierIdx = columns.findIndex((c: any) => identifierCols.includes(c.key));
    return breakdown.map((h: any, hi: number) => (
      <tr key={`hour-${rowIndex}-${hi}`} style={{ background: subRowBg }}>
        {columns?.map((col: any, colIndex: number) => {
          const thStyle = getThStyle(col.key, false, tableName);
          const cellStyle = { ...thStyle, backgroundColor: subRowBg, fontWeight: 400 } as any;
          if (colIndex === firstIdentifierIdx) {
            return (
              <td key={colIndex} style={cellStyle}>
                <span style={{ paddingLeft: '14px', fontStyle: 'italic', opacity: 0.9 }}>
                  &#8627; {h.hour_label}
                </span>
              </td>
            );
          }
          if (emptyCols.has(col.key) || identifierCols.includes(col.key)) {
            return <td key={colIndex} style={cellStyle}></td>;
          }
          const matchedKey = Object.keys(h).find((key) => key.includes(col.key));
          const v = matchedKey ? h[matchedKey] : undefined;
          const display = (v === undefined || v === null || v === '') ? '-' : v;
          return <td key={colIndex} style={cellStyle}>{display}</td>;
        })}
      </tr>
    ));
  };

  // Network Conversion hover: the event the network counts for the row.
  const networkEventHint = (rowData:any) => rowData['c_r_network_conversion_event'] === 'mixed'
    ? 'Multiple conversion events. Open the campaign\'s ad sets for results.'
    : (rowData['c_r_network_conversion_event'] ? `Event: ${rowData['c_r_network_conversion_event']}` : '');

  const trafficSourceTable = (trafficName:any, tableName:any) => {
    const networkTrafficChecked = {
      facebook: facebookTrafficChecked,
      google: googleTrafficChecked,
      microsoft: microsoftTrafficChecked,
      tiktok: tiktokTrafficChecked,
      outbrain: outbrainTrafficChecked,
      applovin: applovinTrafficChecked,
      linkedin: linkedinTrafficChecked,
    };
    const networkData = {
      facebook: facebookData,
      google: googleData,
      microsoft: microsoftData,
      tiktok: tiktokData,
      outbrain: outbrainData,
      applovin: applovinData,
      linkedin: linkedinData
    };
    const columns: any[] = [];
    const addedKeys = new Set();
    campaignColumns[trafficName].forEach((col) => {
      networkData[tableName].forEach((rowdata) => {
        const matchingKey = Object.keys(rowdata).find((key) => key.includes(col[0]));
        if (matchingKey && !addedKeys.has(col[0])) {
          columns.push({ key: col[0], value: col[1] });
          addedKeys.add(col[0]);
        }
      });
    });

    if(networkData[tableName].length > 0){
      return(
        <SimpleBar forceVisible="x" autoHide={false} style={{paddingBottom : '10px'}}>
            <Table striped highlightOnHover withBorder my={5} fontSize="xs" withColumnBorders style={{ borderCollapse: 'separate',borderSpacing: 'unset' }}>
              <thead>
                <tr>
                  {columns?.map((col, index) => {
                    const isColor = showTrafficColumnsColor.find(d => d.tableName === tableName && d.columnName === col.key && d.show === true);
                    const thStyle = getThStyle(col.key, isColor, tableName);
                    const rowColor = colorTheme === "light" ? '#fff' : '#25262b' ;
                    const rowColorDark = colorTheme === "light" ? '#E4E9ED' : '#7b7f83' ;
                    const fullIndex = campaignColumns[trafficName]?.findIndex(column => column[0] === col.key);
                    if(col.key !== 'checkbox') {
                      return(
                        <th
                          key={index}
                          draggable={!['campaign_name', 'campaignid', 'traffic_source'].includes(col.key)}
                          onDragStart={!['campaign_name', 'campaignid', 'traffic_source'].includes(col.key) ? (e) => handleDragStart(e, fullIndex, tableName) : undefined }
                          onDrop={!['campaign_name', 'campaignid', 'traffic_source'].includes(col.key) ? (e) => handleDrop(e, fullIndex) : undefined }
                          onDragOver={!['campaign_name', 'campaignid', 'traffic_source'].includes(col.key) ? (e) => e.preventDefault() : undefined }
                          onClick={(e) => handleTrafficSorting(col.key, tableName)}
                          ref={col.key === 'campaign_name' || col.key === 'campaignid' ? columnRefs.campaign_name : null}
                          style={{...thStyle,backgroundColor: isColor ? rowColorDark : rowColor}}
                        >
                        <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                          {col.value}{(() => {
                            const tableSortConfig = trafficSortConfig.filter(config => config.table === tableName);
                            const sort = tableSortConfig.find(config => config.key === col.key);

                            if (sort) {
                              return sort.direction === 'ascending' ? <IconCaretUpFilled /> : <IconCaretDownFilled />;
                            }
                          })()}
                        </span>
                        </th>
                      );
                    }else {
                      return(
                        <th key={index} style={thStyle}>
                          <Checkbox
                            checked={networkTrafficChecked[tableName]}
                            onChange={() => handleTrafficSourceColumnChecked(tableName)}
                          />
                        </th>
                      );
                    }})}
                </tr>
              </thead>
              <tbody>
                {searchRows(columns, tableName, tableName)}
                {networkData[tableName].map((rowData, rowIndex) => {
                  return (
                    <React.Fragment key={rowIndex}>
                    <tr
                      style={rowData['c_r_traffic_source'] === 'Total' ? { fontWeight: 'bold' } : {}}
                    >
                      {columns?.map((col, colIndex) => {
                        const isColor = showTrafficColumnsColor.find(d => d.tableName === tableName && d.columnName === col.key && d.show === true);
                        const thStyle = getThStyle(col.key, isColor, tableName);
                        const rowColor = colorTheme === "light" ? '#fff' : '#25262b';
                        const rowColorDark = colorTheme === "light" ? '#E4E9ED' : '#7b7f83';
                        const matchedKey = col.key !== 'campaign_name' ? Object.keys(rowData).find((key) => key.includes(col.key)): 'c_r_campaign_name';
                        const columnValue = matchedKey ? rowData[matchedKey] : '';
                        const metricKey = extractMetricKey(col.key);
                        const benchColor = getBenchmarkColor(metricKey, columnValue);
                        if (col.key !== 'checkbox') {
                          return (
                            <td
                              key={colIndex}
                              onClick={() => {
                                if (col.key.includes('_visiopt_conversions') && rowData['c_r_traffic_source'] !== 'Total') {
                                  handleCustomerJourneyOpenModal('',rowData,columnValue,'traffic_source',col.key,trafficName,'campaign',rowData['encode_campaign_name']);
                                } else if (tableName !== 'outbrain') {
                                  handleTrafficDataChecked(col.value,rowIndex,trafficName,rowData['type'],rowData['c_r_cpc'],rowData['c_r_ctr'],rowData['c_r_cpm']);
                                }
                                handleColumnDataClicked('', tableName, col.key);
                              }}
                              style={{
                                ...thStyle,
                                ...(benchColor && rowData['c_r_traffic_source'] !== 'Total'
                                  ? { color: benchColor === 'green' ? '#05b456' : benchColor === 'red' ? '#b9031c' : '#bec309' }
                                  : {}),
                                ...(rowData['c_r_traffic_source'] !== 'Total' &&
                                  {
                                    backgroundColor:
                                      rowData['checkbox'] === true || isColor ? rowColorDark : rowColor
                                  }) ||
                                  (rowData['c_r_traffic_source'] === 'Total' && {
                                    backgroundColor: isColor ? rowColorDark : rowColor
                                  })
                              }}
                            >
                              <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                {col.key.includes('network_conversions') && networkEventHint(rowData) ? (
                                  <Tooltip label={networkEventHint(rowData)} withArrow><span>{columnValue}</span></Tooltip>
                                ) : (
                                  <span>{columnValue}</span>
                                )}
                                {col.key.includes('_visiopt_conversions') && rowData['c_r_traffic_source'] !== 'Total' && (
                                  <button
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleClickClockCon(tableName, col.key, rowData, 'campaign');
                                    }}
                                    title="Velocity Report"
                                    style={{ background: 'transparent', border: 'none', cursor: 'pointer', padding: '4px', color: velocityIconColor, display: 'flex', alignItems: 'center' }}
                                    onMouseOver={(e) => (e.currentTarget.style.backgroundColor = velocityIconHoverBg)}
                                    onMouseOut={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
                                  >
                                    <IconClock size="1.1rem" />
                                  </button>
                                )}
                              </div>
                            </td>
                          );
                        } else {
                          if (rowData['c_r_traffic_source'] === 'Total') {
                            return <td key={colIndex} style={thStyle}></td>;
                          }
                          return (
                            <td key={colIndex} style={thStyle}>
                              {tableName !== 'outbrain' ? (
                                <Checkbox
                                  checked={matchedKey ? rowData[matchedKey] : true}
                                  onChange={() => handleTrafficRowChecked(rowIndex, tableName)}
                                />
                              ) : (
                                <Checkbox disabled />
                              )}
                            </td>
                          );
                        }
                      })}
                    </tr>
                    {renderDeviceBreakdownRows(rowData, columns, rowIndex, rowData['c_r_traffic_source'] === 'Total', tableName)}
                    {renderHourBreakdownRows(rowData, columns, rowIndex, rowData['c_r_traffic_source'] === 'Total', tableName)}
                    {renderCustomerTypeBreakdownRows(rowData, columns, rowIndex, rowData['c_r_traffic_source'] === 'Total', tableName)}
                    </React.Fragment>
                  );
                })}
              </tbody>
            </Table>
        </SimpleBar>
      );
    }
  };

  /*TRAFFIC  SOURCE ADSET TABLE*/
  const trafficSourceAdsetTable = (trafficName:any, tableName:any) => {
    const networkTrafficChecked = {
      facebookAdset: facebookAdsetTrafficChecked,
      googleAdset: googleAdsetTrafficChecked,
      microsoftAdset: microsoftAdsetTrafficChecked,
      tiktokAdset: tiktokAdsetTrafficChecked,
      linkedinAdset: linkedinAdsetTrafficChecked,
    };
    const networkAdsetData = {
      facebookAdset: facebookAdsetData,
      googleAdset: googleAdsetData,
      microsoftAdset: microsoftAdsetData,
      tiktokAdset: tiktokAdsetData,
      applovinAdset: applovinAdsetData,
      linkedinAdset: linkedinAdsetData
    };
    
    const columns: any[] = [];
    const addedKeys = new Set();
    campaignColumns[tableName].forEach((col) => {
      networkAdsetData[tableName].forEach((rowdata) => {
        const matchingKey = Object.keys(rowdata).find((key) => key.includes(col[0]));
        if (matchingKey && !addedKeys.has(col[0])) {
          columns.push({ key: col[0], value: col[1] });
          addedKeys.add(col[0]);
        }
      });
    });

    if(networkAdsetData[tableName].length > 0){
      return(
        <SimpleBar forceVisible="x" autoHide={false} style={{paddingBottom : '12px'}}>
            <Table striped highlightOnHover withBorder my={5} fontSize="xs" withColumnBorders style={{ borderCollapse: 'separate', borderSpacing: 'unset'}}>
              <thead>
                <tr>
                  {columns?.map((col, index) => {
                    const isColor = showColumnColor.find(d => d.tableName === tableName && d.columnName === col.key && d.show === true);
                    const thStyle = col.key === 'applovinAdset' && col.key === 'ad_name' ? getThStyle('adset_name', isColor) : getThStyle(col.key, isColor, tableName);
                    const rowColor = colorTheme === "light" ? '#fff' : '#25262b' ;
                    const rowColorDark = colorTheme === "light" ? '#E4E9ED' : '#7b7f83' ;
                    const fullIndex = campaignColumns[tableName]?.findIndex(column => column[0] === col.key);
                    if(col.key !== 'checkbox') {                                        
                      return(
                        <th
                          key={index}
                          draggable={!['campaign_name', 'campaignid', 'traffic_source', 'adset_name', 'ad_name'].includes(col.key)}
                          onDragStart={!['campaign_name', 'campaignid', 'traffic_source', 'adset_name', 'ad_name'].includes(col.key) ? (e) => handleDragStart(e, fullIndex, tableName) : undefined }
                          onDrop={!['campaign_name', 'campaignid', 'traffic_source', 'adset_name', 'ad_name'].includes(col.key) ? (e) => handleDrop(e, fullIndex) : undefined }
                          onDragOver={!['campaign_name', 'campaignid', 'traffic_source', 'adset_name', 'ad_name'].includes(col.key) ? (e) => e.preventDefault() : undefined }
                          onClick={(e) => handleTrafficSorting(col.key, tableName)}
                          ref={col.key === 'campaign_name' || col.key === 'campaignid' ? columnRefs.campaign_name :
                                col.key === 'adset_name' ? columnRefs.adset_name : null}
                          style={{...thStyle,backgroundColor: isColor ? rowColorDark : rowColor}}
                        >
                        <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                          {col.value}{(() => {
                            const tableSortConfig = trafficSortConfig.filter(config => config.table === tableName);
                            const sort = tableSortConfig.find(config => config.key === col.key);

                            if (sort) {
                              return sort.direction === 'ascending' ? <IconCaretUpFilled /> : <IconCaretDownFilled />;
                            }
                          })()}
                        </span>
                        </th>
                      );
                    }else {
                      return(
                        <th key={index} style={thStyle}>
                          {tableName !== 'applovinAdset' && tableName !== 'microsoftAdset' ? (
                            <Checkbox
                              checked={networkTrafficChecked[tableName]}
                              onChange={() => handleTrafficSourceColumnChecked(tableName)}
                            />
                          ) : (
                            <Checkbox disabled />
                          )}                        
                        </th>
                      );
                    }})}
                </tr>
              </thead>
              <tbody>
                {searchRows(columns, trafficName, tableName)}
                {networkAdsetData[tableName].map((rowData, rowIndex) => {
                  return (
                    <React.Fragment key={rowIndex}>
                    <tr
                      style={rowData['c_r_traffic_source'] === 'Total' ? { fontWeight: 'bold' } : {}}
                    >
                      {columns?.map((col, colIndex) => {
                        const isColor = showColumnColor.find(d => d.tableName === tableName && d.columnName === col.key && d.show === true);
                        const thStyle = getThStyle(col.key, isColor, tableName);
                        const rowColor = colorTheme === "light" ? '#fff' : '#25262b' ;
                        const rowColorDark = colorTheme === "light" ? '#E4E9ED' : '#7b7f83' ;
                        const matchedKey = col.key !== 'campaign_name' ? Object.keys(rowData).find((key) => key.includes(col.key)) : 'c_r_campaign_name';
                        const columnValue = matchedKey ? rowData[matchedKey] : '';
                        const metricKey = extractMetricKey(col.key);
                        const benchColor = getBenchmarkColor(metricKey, columnValue);
                        if (col.key !== 'checkbox') {
                          return (
                            <td
                              key={colIndex}
                              onClick={() => {
                                if(col.key.includes('_visiopt_conversions') && rowData['c_r_traffic_source'] !== 'Total'){
                                  handleCustomerJourneyOpenModal('', rowData, columnValue, 'traffic_source', col.key, trafficName, 'adset', rowData['encode_campaign_name']);
                                }else if(tableName !== 'applovinAdset' && tableName !== 'microsoftAdset') {
                                  handleTrafficAdsetDataClick(col.value, rowIndex, tableName, trafficName, rowData['traffic_camp_name'], rowData['type'], rowData['c_r_cpc'], rowData['c_r_ctr'], rowData['c_r_cpm']);
                                }
                                handleColumnDataClicked('', tableName, col.key);
                              }}
                              style={{
                                ...thStyle,
                                ...(rowData['c_r_traffic_source'] !== 'Total'
                                    ? (benchColor
                                        ? { color: benchColor === "green" ? "#05b456" : benchColor === "red" ? "#b9031c" : "#bec309" }
                                        : {})
                                    : {}),
                                ...(rowData['c_r_traffic_source'] !== 'Total' &&
                                  { backgroundColor: rowData['checkbox'] === true || isColor ? rowColorDark : rowColor }) ||
                                  (rowData['c_r_traffic_source'] === 'Total' &&
                                  { backgroundColor: isColor ? rowColorDark : rowColor })
                              }}
                            >
                              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '8px',width: '100%' }}>
                                <div style={{ flex: 1, wordBreak: 'break-word' }}>
                                  {col.key === 'ad_name' && rowData['c_r_traffic_source'] !== 'Total' && (trafficName === 'facebook' || trafficName === 'google') ? (
                                    <span
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleAdNameClick(rowData, trafficName);
                                      }}
                                      style={{
                                        textDecoration: 'underline',
                                        cursor: 'pointer'
                                      }}
                                    >
                                      {columnValue}
                                    </span>
                                  ) : (
                                    col.key.includes('network_conversions') && networkEventHint(rowData) ? (
                                      <Tooltip label={networkEventHint(rowData)} withArrow><span>{columnValue}</span></Tooltip>
                                    ) : (
                                      <span>{columnValue}</span>
                                    )
                                  )}
                                </div>
                                {col.key === 'adset_name' && trafficName === 'google' && rowData['c_r_traffic_source'] !== 'Total' && (
                                  <button
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleClickKeywordView(rowData);
                                    }}
                                    style={keywordViewButtonStyle}
                                    onMouseEnter={(e) => {
                                      e.currentTarget.style.backgroundColor = keywordViewHoverInBg;
                                    }}
                                    onMouseLeave={(e) => {
                                      e.currentTarget.style.backgroundColor = keywordViewHoverOutBg;
                                    }}
                                    onMouseDown={(e) => {
                                      e.currentTarget.style.backgroundColor = keywordViewActiveBg;
                                    }}
                                    onMouseUp={(e) => {
                                      e.currentTarget.style.backgroundColor = keywordViewHoverInBg;
                                    }}
                                  >
                                    Keyword View
                                  </button>
                                )}
                                {col.key.includes('_visiopt_conversions') && rowData['c_r_traffic_source'] !== 'Total' && (
                                  <button
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleClickClockCon(trafficName, col.key, rowData, 'adset');
                                    }}
                                    title="Velocity Report1"
                                    style={{ background: 'transparent', border: 'none', cursor: 'pointer', padding: '4px', color: velocityIconColor, display: 'flex', alignItems: 'center' }}
                                    onMouseOver={(e) => (e.currentTarget.style.backgroundColor = velocityIconHoverBg)}
                                    onMouseOut={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
                                  >
                                    <IconClock size="1.1rem" />
                                  </button>
                                )}
                              </div>
                            </td>
                          );
                        } else {
                          if (rowData['c_r_traffic_source'] === 'Total') {
                            return <td key={colIndex} style={thStyle}></td>;
                          }
                          return (
                            <td key={colIndex} style={thStyle}>
                              {tableName !== 'applovinAdset' && tableName !== 'microsoftAdset' ? (
                                <Checkbox
                                  checked={matchedKey ? rowData[matchedKey] : true}
                                  onChange={() => handleTrafficRowChecked(rowIndex, tableName)}
                                />
                              ) : (
                                <Checkbox disabled />
                              )}
                            </td>
                          );
                        }
                      })}
                    </tr>
                    {renderDeviceBreakdownRows(rowData, columns, rowIndex, rowData['c_r_traffic_source'] === 'Total', tableName)}
                    {renderHourBreakdownRows(rowData, columns, rowIndex, rowData['c_r_traffic_source'] === 'Total', tableName)}
                    {renderCustomerTypeBreakdownRows(rowData, columns, rowIndex, rowData['c_r_traffic_source'] === 'Total', tableName)}
                    </React.Fragment>
                  );
                })}
              </tbody>
            </Table>
        </SimpleBar>
      );
    }
  };

  /*TRAFFIC SOURCE ADS TABLE*/
  const trafficSourceAdsTable = (trafficName:any, tableName:any) => {
    const networkAdsData = {
      facebookAds: facebookAdsData,
      googleAds: googleAdsData,
      tiktokAds: tiktokAdsData,
      linkedinAds: linkedinAdsData,
    };

    const columns: any[] = [];
    const addedKeys = new Set();
    campaignColumns[tableName].forEach((col) => {
      networkAdsData[tableName].forEach((rowdata) => {
        const matchingKey = Object.keys(rowdata).find((key) => key.includes(col[0]));
        if (matchingKey && !addedKeys.has(col[0])) {
          columns.push({ key: col[0], value: col[1] });
          addedKeys.add(col[0]);
        }
      });
    });

    if(networkAdsData[tableName].length > 0){
      return(
        <SimpleBar forceVisible="x" autoHide={false} style={{paddingBottom : '12px'}}>
            <Table striped highlightOnHover withBorder my={5} fontSize="xs" withColumnBorders style={{ borderCollapse: 'separate', borderSpacing: 'unset' }}>
              <thead>
                <tr>
                  {columns?.map((col, index) => {
                    const isColor = showColumnColor.find(d => d.tableName === tableName && d.columnName === col.key && d.show === true);
                    const thStyle = getThStyle(col.key, isColor, tableName);
                    const rowColor = colorTheme === "light" ? '#fff' : '#25262b' ;
                    const rowColorDark = colorTheme === "light" ? '#E4E9ED' : '#7b7f83' ;
                    const fullIndex = campaignColumns[tableName]?.findIndex(column => column[0] === col.key);
                    if(col.key !== 'checkbox') {                    
                      return(
                        <th
                          key={index}
                          draggable={!['campaign_name', 'campaignid', 'traffic_source', 'adset_name', 'ad_name'].includes(col.key)}
                          onDragStart={!['campaign_name', 'campaignid', 'traffic_source', 'adset_name', 'ad_name'].includes(col.key) ? (e) => handleDragStart(e, fullIndex, tableName) : undefined }
                          onDrop={!['campaign_name', 'campaignid', 'traffic_source', 'adset_name', 'ad_name'].includes(col.key) ? (e) => handleDrop(e, fullIndex) : undefined }
                          onDragOver={!['campaign_name', 'campaignid', 'traffic_source', 'adset_name', 'ad_name'].includes(col.key) ? (e) => e.preventDefault() : undefined }
                          onClick={(e) => handleTrafficSorting(col.key, tableName)}
                          ref={col.key === 'campaign_name' || col.key === 'campaignid' ? columnRefs.campaign_name :
                                col.key === 'adset_name' ? columnRefs.adset_name :
                                col.key === 'ad_name' ? columnRefs.ad_name : null}
                          style={{...thStyle,backgroundColor: isColor ? rowColorDark : rowColor}}
                        >
                        <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                          {col.value}{(() => {
                            const tableSortConfig = trafficSortConfig.filter(config => config.table === tableName);
                            const sort = tableSortConfig.find(config => config.key === col.key);

                            if (sort) {
                              return sort.direction === 'ascending' ? <IconCaretUpFilled /> : <IconCaretDownFilled />;
                            }
                          })()}
                        </span>
                        </th>
                      );
                    }else{
                      return(
                        <th key={index} style={thStyle}>
                          <Checkbox disabled />                                                        
                        </th>
                      );
                    }})}
                </tr>
              </thead>
              <tbody>
                {searchRows(columns, trafficName, tableName)}
                {networkAdsData[tableName].map((rowData, rowIndex) => {

                  return (
                    <React.Fragment key={rowIndex}>
                    <tr
                      style={rowData['c_r_traffic_source'] === 'Total' ? { fontWeight: 'bold' } : {}}
                    >
                      {columns?.map((col, colIndex) => {
                        const isColor = showColumnColor.find(d => d.tableName === tableName && d.columnName === col.key && d.show === true);
                        const thStyle = getThStyle(col.key, isColor, tableName);
                        const rowColor = colorTheme === "light" ? '#fff' : '#25262b' ;
                        const rowColorDark = colorTheme === "light" ? '#E4E9ED' : '#7b7f83' ;
                        const matchedKey = col.key !== 'campaign_name' ? Object.keys(rowData).find((key) => key.includes(col.key)) : 'c_r_campaign_name';
                        const columnValue = matchedKey ? rowData[matchedKey] : '';
                        const metricKey = extractMetricKey(col.key);
                        const benchColor = getBenchmarkColor(metricKey, columnValue);
                        if (col.key !== 'checkbox') {

                          return (
                            <td
                              key={colIndex}
                              onClick={() => {
                                if(col.key.includes('_visiopt_conversions') && rowData['c_r_traffic_source'] !== 'Total'){
                                  handleCustomerJourneyOpenModal('', rowData, columnValue, 'traffic_source', col.key, trafficName, 'ad', rowData['encode_campaign_name']);
                                }
                                handleColumnDataClicked('', tableName, col.key);
                              }}
                              style={{
                                ...thStyle,
                                ...(rowData['c_r_traffic_source'] !== 'Total'
                                    ? (benchColor
                                        ? { color: benchColor === "green" ? "#05b456" : benchColor === "red" ? "#b9031c" : "#bec309" }
                                        : {})
                                    : {}),
                                ...(rowData['c_r_traffic_source'] !== 'Total' &&
                                  { backgroundColor: rowData['checkbox'] === true || isColor ? rowColorDark : rowColor }) ||
                                  (rowData['c_r_traffic_source'] === 'Total' &&
                                  { backgroundColor: isColor ? rowColorDark : rowColor })
                              }}
                            >
                              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '8px',width: '100%' }}>
                                <div style={{ flex: 1, wordBreak: 'break-word' }}>
                                  {col.key === 'ad_name' && rowData['c_r_traffic_source'] !== 'Total' && (trafficName === 'facebook' || trafficName === 'google') ? (
                                    <span
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleAdNameClick(rowData, trafficName);
                                      }}
                                      style={{
                                        textDecoration: 'underline',
                                        cursor: 'pointer'
                                      }}
                                    >
                                      {columnValue}
                                    </span>
                                  ) : (
                                    col.key.includes('network_conversions') && networkEventHint(rowData) ? (
                                      <Tooltip label={networkEventHint(rowData)} withArrow><span>{columnValue}</span></Tooltip>
                                    ) : (
                                      <span>{columnValue}</span>
                                    )
                                  )}
                                </div>
                                {col.key === 'ad_name' && trafficName === 'google' && rowData['c_r_traffic_source'] !== 'Total' && (
                                  <button
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleClickAdKeywordView(rowData);
                                    }}
                                    style={keywordViewButtonStyle}
                                    onMouseEnter={(e) => {
                                      e.currentTarget.style.backgroundColor = keywordViewHoverInBg;
                                    }}
                                    onMouseLeave={(e) => {
                                      e.currentTarget.style.backgroundColor = keywordViewHoverOutBg;
                                    }}
                                    onMouseDown={(e) => {
                                      e.currentTarget.style.backgroundColor = keywordViewActiveBg;
                                    }}
                                    onMouseUp={(e) => {
                                      e.currentTarget.style.backgroundColor = keywordViewHoverInBg;
                                    }}
                                  >
                                    Keyword View
                                  </button>
                                )}
                                {col.key === 'adset_name' && trafficName === 'google' && rowData['c_r_traffic_source'] !== 'Total' && (
                                  <button
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleClickKeywordView(rowData);
                                    }}
                                    style={keywordViewButtonStyle}
                                    onMouseEnter={(e) => {
                                      e.currentTarget.style.backgroundColor = keywordViewHoverInBg;
                                    }}
                                    onMouseLeave={(e) => {
                                      e.currentTarget.style.backgroundColor = keywordViewHoverOutBg;
                                    }}
                                    onMouseDown={(e) => {
                                      e.currentTarget.style.backgroundColor = keywordViewActiveBg;
                                    }}
                                    onMouseUp={(e) => {
                                      e.currentTarget.style.backgroundColor = keywordViewHoverInBg;
                                    }}
                                  >
                                    Keyword View
                                  </button>
                                )}
                                {col.key.includes('_visiopt_conversions') && rowData['c_r_traffic_source'] !== 'Total' && (
                                  <button
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleClickClockCon(trafficName, col.key, rowData, 'ads');
                                    }}
                                    title="Velocity Report"
                                    style={{ background: 'transparent', border: 'none', cursor: 'pointer', padding: '4px', color: velocityIconColor, display: 'flex', alignItems: 'center' }}
                                    onMouseOver={(e) => (e.currentTarget.style.backgroundColor = velocityIconHoverBg)}
                                    onMouseOut={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
                                  >
                                    <IconClock size="1.1rem" />
                                  </button>
                                )}
                              </div>
                            </td>
                          );
                        } else {
                          if (rowData['c_r_traffic_source'] === 'Total') {
                            return <td key={colIndex} style={thStyle}></td>;
                          }
                          return (
                            <td key={colIndex} style={thStyle}>
                              <Checkbox disabled />
                            </td>
                          );
                        }
                      })}
                    </tr>
                    {renderDeviceBreakdownRows(rowData, columns, rowIndex, rowData['c_r_traffic_source'] === 'Total', tableName)}
                    {renderHourBreakdownRows(rowData, columns, rowIndex, rowData['c_r_traffic_source'] === 'Total', tableName)}
                    {renderCustomerTypeBreakdownRows(rowData, columns, rowIndex, rowData['c_r_traffic_source'] === 'Total', tableName)}
                    </React.Fragment>
                  );
                })}
              </tbody>
            </Table>
        </SimpleBar>
      );
    }
  };

  const searchRows = (columns:any, trafficName:any, tableName:any) => {
    const campaignSearchTrafficValue = campaignSearchValue.find((traffic) => traffic.trafficName === trafficName && traffic.tableName === tableName)?.value;
    const adsetSearchTrafficValue = adsetSearchValue.find((traffic) => traffic.trafficName === trafficName && traffic.tableName === tableName)?.value;
    const adsSearchTrafficValue = adsSearchValue.find((traffic) => traffic.trafficName === trafficName && traffic.tableName === tableName)?.value;

    return(
      <tr>
        {columns?.map((col, colIndex) => {
          const isColor = showTrafficColumnsColor.find(d => d.tableName === tableName && d.columnName === col.key && d.show === true);
          const thStyle = getThStyle(col.key, isColor, tableName);
          const rowColor = colorTheme === "light" ? '#fff' : '#25262b' ;
          const rowColorDark = colorTheme === "light" ? '#E4E9ED' : '#7b7f83' ;
          if (col.key === 'campaign_name') {
            return (
              <td key={colIndex} style={{...thStyle,backgroundColor: isColor ? rowColorDark : rowColor}}>
                <TextInput placeholder="Campaign Name Search" value={campaignSearchTrafficValue} onChange={(event) => handleSearch(event.currentTarget.value, trafficName, tableName, 'campaign_name')}></TextInput>
              </td>
            );
          }
          if (col.key === 'placement') {
            return (
              <td key={colIndex} style={{...thStyle,backgroundColor: isColor ? rowColorDark : rowColor}}>
                <TextInput placeholder="Placement Search" onChange={(event) => handleSearch(event.currentTarget.value, trafficName, tableName, 'placement')}></TextInput>
              </td>
            );
          }
          if (col.key === 'campaignid') {
            return (
              <td key={colIndex} style={{...thStyle,backgroundColor: isColor ? rowColorDark : rowColor}}>
                <TextInput placeholder="Campaign Id Search" value={campaignSearchTrafficValue} onChange={(event) => handleSearch(event.currentTarget.value, trafficName, tableName, 'campaignid')}></TextInput>
              </td>
            );
          }
          if (col.key === 'adset_name') {
            return (
              <td key={colIndex} style={{...thStyle,backgroundColor: isColor ? rowColorDark : rowColor}}>
                <TextInput placeholder="Ad Set/Group Name Search" value={adsetSearchTrafficValue} onChange={(event) => handleSearch(event.currentTarget.value, trafficName, tableName, 'adset_name')}></TextInput>
              </td>
            );
          }
          if (col.key === 'ad_name' && trafficName !== 'applovin') {
            return (
              <td key={colIndex} style={{...thStyle,backgroundColor: isColor ? rowColorDark : rowColor}}>
                <TextInput placeholder="Ad Name Search" value={adsSearchTrafficValue} onChange={(event) => handleSearch(event.currentTarget.value, trafficName, tableName, 'ad_name')}></TextInput>
              </td>
            );
          }
          if (col.key === 'ad_name' && trafficName === 'applovin') {
            return (
              <td key={colIndex} style={{...thStyle,backgroundColor: isColor ? rowColorDark : rowColor}}>
                <TextInput placeholder="Ad Name Search" value={adsetSearchTrafficValue} onChange={(event) => handleSearch(event.currentTarget.value, trafficName, tableName, 'adset_name')}></TextInput>
              </td>
            );
          }
          return <td key={colIndex} style={{...thStyle,backgroundColor: isColor ? rowColorDark : rowColor}}></td>;
        })}
      </tr>
    );
  };

  useEffect(() => {
    if(selectedCampaigns.length > 1){
      fetchGraphCampaignList();
    }
  }, [selectedCampaigns]);

  const getCustomTrackingSourceStickyStyle = (columnKey:any, columnValue:any, isColor:any) => {
    const stickyStyles = {
      cursor: 'pointer',
      backgroundColor: isColor ? '#E4E9ED' : '#fff',
      whiteSpace: 'nowrap'
    } as React.CSSProperties;
    if(columnKey === columnValue){
      stickyStyles.position = 'sticky';
      stickyStyles.left = 0;
      stickyStyles.zIndex = 2;
      stickyStyles.width = '110px';
      stickyStyles.minWidth = '110px';
      stickyStyles.maxWidth = '150px';
      stickyStyles.whiteSpace = 'normal';
      stickyStyles.wordBreak = 'break-word';
    }
    return stickyStyles;
  }

  const getFontSize = (value) => {
    if (!value) return "1rem";
    if (value <= 3) return "1.4rem";
    if (value <= 4) return "1.2rem";
    return "1rem";
  };

  const goalCards = (goalName:any, uniques:any, visits:any, conversionValue:any, ucbValue:any, crValue:any, imagePath:any, visitText:any) => {
    const allValues = [uniques, visits, conversionValue, ucbValue, crValue].filter((v) => v !== undefined && v !== null);
    const maxLength = Math.max(...allValues.map((v) => v.toString().length));
    const fontSize = getFontSize(maxLength);
    return(
      <td>
        <Card radius="md" withBorder style={{ height: '250px' , width: '260px'}}>
          <div style={{ height: '40%', width: '100%' }}>
            <Text weight={750} size = {15} color = 'grey' style={{ position: 'absolute', top: 7, left: 10, overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', width: '250px', cursor: 'pointer' }} title={goalName}>{goalName}</Text>
              {(uniques !== undefined && visits !== undefined)&& (
                <Group mt="md" spacing="xl">
                  <div>
                    <Text weight={700} style={{display: 'flex', position: 'absolute' , top: 30, left: 10, fontSize}}>{uniques}</Text>
                    <Text size={11} c="dimmed" style={{display: 'flex' , position: 'absolute', top: 56, left: 10}}>Uniques</Text>
                  </div>
                  <div>
                    <Text weight={700} style={{position: 'absolute' , top: 30, left: 100, fontSize}}>{visits}</Text>
                    <Text size={11} c="dimmed" style={{display: 'flex' , position: 'absolute', top: 56, left: 100}}>Visits</Text>
                  </div>
                </Group>
              )}

              {(conversionValue !== undefined && ucbValue !== undefined && crValue !== undefined) && (
               <Group mt="md" spacing="xl">
                  <div>
                    <Text weight={700} style={{display: 'flex', position: 'absolute' , top: 30, left: 10, fontSize}}>{conversionValue}</Text>
                    <Text size={11} c="dimmed" style={{display: 'flex', position: 'absolute', top: 56, left: 10}}>Conversion</Text>
                  </div>
                  <div>
                    <Text weight={700} style={{display: 'flex', position: 'absolute' , top: 30, left: '81px', fontSize}}>{ucbValue}<span style={{position: 'relative' , top: '0.4em', fontSize :'0.7em'}}>%</span></Text>
                    <Text size={11} c="dimmed" style={{display: 'flex', position: 'absolute', top: 56, left: '81px'}}>UCR</Text>
                  </div>
                  <div>
                    <Text weight={700} style={{display: 'flex', position: 'absolute' , top: 30, left: '152px', fontSize}}>{crValue}<span style={{position: 'relative' , top: '0.4em', fontSize :'0.7em'}}>%</span></Text>
                    <Text size={11} c="dimmed" style={{display: 'flex', position: 'absolute', top: 56, left: '152px'}}>CR</Text>
                  </div>
                  <Text size = {12} weight={600} style={{display: 'flex', position: 'absolute' , top: 83,left: 10,wordWrap: 'break-word', whiteSpace: 'normal'}} color={colorTheme === "light" ? 'gray' : '#C1C2C5'}>{visitText}</Text>
                </Group>
                )}
            </div>
            <Card.Section style={{ borderTop: '3px solid #174c80' }}>
              <Image src={imagePath} height={140} width="100%" fit="cover" />
            </Card.Section>
      </Card>
    </td>
    );
  }
  return (
    <>
    {reportLoader && <VisiLoader VisiLoaderVisible={true} loaderType={loaderType} />}
    <VisiLoader VisiLoaderVisible={isVisiLoaderVisible}/>
    {/*Customer Journey Model*/}
    <CustomerJourney
      emailValue={emailValue}
      setEmailValue={setEmailValue}
      reportTimeValue={reportTimeValue()}
      campaignId={customerJourneyCampaignId}
      campaignGoalId={customerJourneyCampaignGoalId}
      customerJourneyType={customerJourneyType}
      isCustomerJourneyModalOpen={isCustomerJourneyModalOpen}
      onCustomerJourneyClose={handleCustomerJourneyCloseModal}
      customerJourneyCampaignDataId={customerJourneyCampaignDataId}
      report_id={reportId || updateReportId}
      customerJourneyAdsNetwork={customerJourneyAdsNetwork}
      customerJourneyAdsNetworkType={customerJourneyAdsNetworkType}
      customerJourneyAdsNetworkName={customerJourneyAdsNetworkName}
      customerJourneyPayloadData={customerJourneyPayloadData}
      customerJourneyGoalType={customerJourneyGoalType}
      goalTestId={goalTestId}
      customerJourneyCampaignName={customerJourneyCampaignName}
      customerJourneyAdsetName={customerJourneyAdsetName}
    />
    {/*Lifecycle Model*/}
    <LifecycleAnalysisReport
      selectedMemberWebsite={selectedMemberWebsite}
      showLifecycleModal={showLifecycleModal}
      setShowLifecycleModal={setShowLifecycleModal}
      lifecycleCampaignId={lifecycleCampaignId}
      lifecycleTrafficData={lifecycleTrafficData}
      lifecycleReportId={reportId || updateReportId}
      selectedAttributionModal={selectedAttributionModal}
    />
    {/*Variation Ads Modal*/}
    <VariationAdsModal
      isOpen={isVariationModalOpen}
      onClose={handleVariationModalClose}
      payload={selectedVariationPayload}
    />
    {/*Behavioral Filters Model*/}
    <BehavioralDimensions
      selectedMemberWebsite={selectedMemberWebsite}
      campaignId={behavioralCampaignId}
      isBehavioralFilterModalOpen={behavioralFilterModalOpen}
      onBehavioralFilterClose={handleBehavioralFilterCloseModal}
      selectedVisioptCampaign={selectedVisioptCampaign}
      CampaignGoalDropDown={getVisioptCampaignGoalDropDown}
      reportId={reportId || updateReportId}
      setSelectedTrackingTagData={setSelectedTrackingTagData}
      setSelectedCustomTagData={setSelectedCustomTagData}
      setSelectedSourceData={setSelectedSourceData}
      setSelectedOrganicCustomTag={setSelectedOrganicCustomTag}
      setSelectedOrganicTrackingTag={setSelectedOrganicTrackingTag}
    />
    {showVelocityDrawer && (
      <ReportVelocityDrawer
        report_id={reportId || updateReportId}
        showVelocityDrawer={showVelocityDrawer}
        setShowVelocityDrawer={setShowVelocityDrawer}
        campaignGoalId={velocityDrawerGoalName}
        encodeCampaignName={velocityDrawerEncodeTrafficName}
        selectedCampaignName={velocityDrawerCampaignName}
        adsetName={velocityDrawerAdsetName}
        trafficSource={velocityDrawerTrafficSourceName}
        campaign_id={velocityDrawerCampaignId}
        trafficLevel={velocityDrawerTrafficLevel}
        goalType={velocityDrawerGoalType}
        combinedGoalType={velocityDrawerCombinedGoalType}
        selectedAttributionModal={selectedAttributionModal}
        displayCampaignName={velocityDrawerDisplayCampaignName}
      />
    )}
    {showKeywordDrawer && (
      <ReportKeywordDrawer
        showKeywordDrawer={showKeywordDrawer}
        setShowKeywordDrawer={setShowKeywordDrawer}
        selectedAdsetName={selectedAdsetName}
        selectedAdsetId={selectedAdsetId}
        selectedAdsetCampaignid={selectedAdsetCampaignid}
        reportTimeValue={reportTimeValue()}
      />
    )}
    {showAdKeywordDrawer && (
      <AdKeywordDrawer
        showAdKeywordDrawer={showAdKeywordDrawer}
        setShowAdKeywordDrawer={setShowAdKeywordDrawer}
        selectedAdName={selectedAdKeywordName}
        selectedAdEncodedId={selectedAdKeywordEncodedId}
        selectedAdCampaignid={selectedAdKeywordCampaignid}
        reportTimeValue={reportTimeValue()}
        attributionName={selectedAttributionModal}
        adsTrackingNetwork={formattedTrackingNetwork}
        adsCustomNetwork={formattedCustomTags}
        sourceNetwork={formattedSource}
        testVariationsData={testVariationData}
      />
    )}
    {/*Ad Preview Drawer*/}
    <AdPreviewDrawer
      opened={showAdPreviewDrawer}
      onClose={() => setShowAdPreviewDrawer(false)}
      platform={selectedAdPreview.platform as 'facebook' | 'google'}
      adName={selectedAdPreview.adName}
      adId={selectedAdPreview.adId}
    />
    {/*Save Report Model*/}
    <Modal.Root opened={saveReportModalOpen} onClose={handleSaveReportModalCloseModal} trapFocus={false}>
      <Modal.Overlay />
      <Modal.Content>
        <Modal.Header>
          <Modal.Title>SAVE REPORT <HelpTip helpId={182} /></Modal.Title>
          <Modal.CloseButton />
        </Modal.Header>
        <Modal.Body>
          <form>
            <Group>
              <Text>Enter Report Name: </Text>
              <Input
                name="report_name"
                value={reportName}
                onChange={(event) => setReportNameValue(event.currentTarget.value)}
              />
              <Button type="button" size="sm" w={80} mt={5} onClick={() => handleReportData('save',selectedAttributionModal)}>
                Save
              </Button>
            </Group>
          </form>
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>
    {/*ResetStats Modal*/}
    <ResetStats
      siteId={resetStatsSiteId}
      campaignId={resetStatsCampaignId}
      isResetStatsModalOpen={isResetStatsModalOpen}
      onResetStatsClose={handleResetStatsCloseModal}
      selectedVisioptCampaign={selectedVisioptCampaign}
      CampaignGoalDropDown={getVisioptCampaignGoalDropDown}
      reportId={reportId || updateReportId}
      fetchTrafficTableData={fetchTrafficTableData}
    />
    <HeaderMenu HeaderMenuValue={selectedMemberWebsite} HeaderMenuOnChange={handleHeaderMenuComponentChange}/>
    <Container size="xxl">
      <Card shadow="sm" padding="sm" radius="md" withBorder>
        <Group position="apart" mb="xs">
          <Text weight={500}>{reportName !== '' ? reportName.toUpperCase() : 'Campaign Report'}{" "}<HelpTip helpId={332} /></Text>
            <CampaignSetting
              selectedMemberWebsite={selectedMemberWebsite}
              SelectedVisioptCampaign={logCampaignId}
              ConversionGoalOptions={conversionGoalOptions}
              reportId={reportId}
              updateReportId={updateReportId}
            />
        </Group>       
        <div style={{ display: 'flex',marginBottom: 10}}>
          <Text mr={10} mt={4}>Select Campaign: <HelpTip helpId={333} /></Text>
          <Select
            data={Object.entries(visioptCampaignOptions).flatMap(([domain, campaigns]) =>
                  campaigns.map(campaign => ({
                    value: campaign.campaign_id,
                    label: campaign.campaign_name,
                    group: domain,
                  }))
                )}
            withinPortal
            value={selectedVisioptCampaign}
            onChange={handleSelectedVisioptCampaign}
            maxDropdownHeight={280}
            searchable
            styles={{ input: { cursor: 'pointer' } }}
          />
          <Text mx={10} mt={4}>Comparison Visiopt Campaign(s): <HelpTip helpId={334} /></Text>
          <MultiSelect
            ref={multiSelectRef}
            data={Object.entries(compVisioptCampaignOptions).flatMap(([domain, campaigns]) =>
                  campaigns.map(campaign => ({
                    value: campaign.campaign_id,
                    label: campaign.campaign_name,
                    group: domain,
                  }))
                )}
            withinPortal
            value={comparisonVisiCampaign}
            maxDropdownHeight={280}
            searchable
            onChange={handleComparisonVisiCampaign}
          />
        </div>
        <div style={{ display: 'flex',marginBottom: 10}}>
          <Text mr={10} mt={4}>Attribution Model: <HelpTip helpId={316} /></Text>
          <Select
            data={attributionList.map((attribution) => ({
              value: attribution.attribution_name,
              label: attribution.attribution_name,
            }))}
            maxDropdownHeight={280}
            searchable
            value={selectedAttributionModal}
            onChange={handleChangeAttributionModel}
            styles={{ input: { cursor: 'pointer' } }}
          />     
          <ActionIcon
            variant="white"
            size="lg"
            title="Time Filter"
          >
            <IconClockHour4 size="1.1rem" />
          </ActionIcon>
          <SelectTimePicker SelectTimePickerValue={selectedTimePicker} SelectTimePickerOnChange={handleselectedTimePickerComponentChange} SelectTimePickerFromDateOnChange={handleselectedTimePickerFromDateChange} SelectTimePickerToDateOnChange={handleselectedTimePickerToDateChange} SelectTestStartDate={getTodayDate()} SelectTestEndDate={getEndDate()} SelectedPage="create_report"/>     
          <Text mx={10} mt={4}>Filter by :</Text>
          <Select
            data={[
            { value: '',  label: 'Select Metrics', disabled: true },
            { value: 'c_r_uniques', label: 'Uniques' },
            { value: 'c_r_visits', label: 'Visits' },
            { value: 'c_r_ad_spend', label: 'Ad spend' },
            { value: 'c_r_network_conversions', label: 'Network Conversions' },
            ]}
            withinPortal
            maxDropdownHeight={280}
            searchable
            value={filterByValue}
            onChange={handleFilterByChange}
            styles={{ input: { cursor: 'pointer' } }}
          />
          <Text mx={10} mt={4}>From:</Text>
          <Input
            maw={100}
            value={filterFromValue}
            onChange={(event) => handleFilterFromChange(event.currentTarget.value)}
            onBlur={() => handleFilterCampaignTables(filterByValue, filterFromValue, filterToValue)}
          />
          <Text mx={10} mt={4}>To:</Text>
          <Input
            maw={100}
            value={filterToValue}
            onChange={(event) => handleFilterToChange(event.currentTarget.value)}
            onBlur={() => handleFilterCampaignTables(filterByValue, filterFromValue, filterToValue)}
          />
          <div style={{ display: 'flex', gap: '4px', marginTop: '4px' }}>
            <Text ml={10}>Show All Ad Costs :</Text>
            <HelpTip helpId={335} />
            <Switch 
              size="md"
              onLabel="ON"
              offLabel="OFF"
              checked={showAllAdCosts}
              onChange={(event) => setShowAllAdCosts(event.currentTarget.checked)}
              styles={{
                track: { cursor: 'pointer' },
                thumb: { cursor: 'pointer' } 
              }}
            />
          </div>
        </div>         
        {conversionGoalOptions.map((options, index) => (
          <div key={index}> 
            <Divider my="xs" label={options.campaign_name} labelPosition="center" color="red"/>
            <Group position="apart" mb="xs">
              <Text c="red" size="lg">{options.campaign_name}</Text>
            </Group>
            <div style={{ display: 'flex', marginBottom: 10 }}>
              {options.customerPathData.length > 0 && (
                <>
                  <Text mt={4} ml={10} mr={10}>Select Goals Through: </Text>
                  <Select
                    data={options.customerPathData.map((goal) => ({
                      value: goal.goal_id,
                      label: goal.goal_name
                    }))}
                    value={selectedCustomerGoal.find((data) => data.campaignid === options.campaign_id)
                          ?.selectedGoal || ''}
                    maxDropdownHeight={280}
                    onChange={(value) => handleCustomerGoalChange(options.campaign_id, value)}
                  />
                </>                                
              )}
              <Button variant="default" ml={10} onClick={() => handleBehavioralFilterOpenModal(options.campaign_id)}
                sx={(theme) => ({
                  backgroundColor: options.behavioral_dimension_value === 1 ? '#e7fcf5' : undefined,
                  color: options.behavioral_dimension_value === 1 ? 'black' : colorTheme !== "light" ? 'white' : 'black',
                  '&:hover': {
                    backgroundColor: options.behavioral_dimension_value === 1 ? 'inherit' : undefined,
                    color: colorTheme === 'light' ? 'black' : 'white',
                  },
                })}
              >
                Behavioral Dimensions
              </Button>
              {options.test_variation === 'show' &&
                <Button
                  variant="default"
                  ml={10}
                  sx={(theme) => ({
                    backgroundColor: options.test_variation_value === 1 ? '#e7fcf5' : undefined,
                    color: options.test_variation_value === 1 ? 'black' : colorTheme !== "light" ? 'white' : 'black',
                    '&:hover': {
                      backgroundColor: options.test_variation_value === 1 ? 'inherit' : undefined,
                      color: colorTheme === 'light' ? 'black' : 'white',
                    },
                  })}
                  onClick={() => {
                    if ((reportId && reportId !== '') || (updateReportId && updateReportId !== '')) {
                      handleTestVariation(options.campaign_id, options.test_variation_value);
                    }
                  }}
                >
                  Test Variations
                </Button>
              }
              {hasPermission("operational_access") && (
                <Button variant="default" ml={10} onClick={() => handleResetStatsModalOpen(options.campaign_id,options.site_id)}>
                  Reset Stats
                </Button>
              )}
            </div>
            {/*Facebook Account Dropdown*/}
            {options.facebookDropDownData && Object.entries(options.facebookDropDownData).length > 0 && ( 
              <div style={{ display: 'flex', marginBottom: 10 }}>
                <Text weight={500} mt={4} mr={10}>Facebook Account: </Text>
                <Select
                    data={
                      Object.entries(options.facebookDropDownData) && Object.entries(options.facebookDropDownData).length > 0
                        ? Object.entries(options.facebookDropDownData).map(([key, value]) => {
                            const fbData = value as { fb_account_id: string };
                            return { label: fbData.fb_account_id, value: fbData.fb_account_id };
                          })
                        : [{ label: 'No matches found', value: '', disabled: true }]
                    }                 
                  value={selectedFacebookDropdownData?.find((data) => data.campaignid === options.campaign_id)?.selectedValue || ''}
                  maxDropdownHeight={280}
                  onChange={(value) => handleFacebookAccountChange(options.campaign_id, value)}
                />
              </div>
            )}
            {/*Tracking Tag Dropdown*/}
            {options.trackingTagsData && Object.entries(options.trackingTagsData).length > 0 && ( 
              <div className="ads_network">
                <Text weight={500} mt={15}>Tracking Tags</Text>
                {Object.entries(options.trackingTagsData).map(([trackingKey, trackingValue], trackingIndex) => {
                  const value = trackingValue as { dropdown_data: any[] };
                  return (
                    <div className="ads_network" style={{ display: 'flex', marginTop: '15px' }} key={trackingIndex}>
                      <Text color="red" mx={5} mt={4}>{trackingKey}</Text>
                      <MultiSelect                        
                        data={
                          value.dropdown_data && value.dropdown_data.length > 0
                            ? value.dropdown_data.map((dataValue) => ({ label: dataValue.value, value: dataValue.key }))
                            : [{ label: 'No matches found', value: '', disabled: true }]
                        }
                        value={selectedTrackingTagData.find((data) => data.campaignid === options.campaign_id && data.trackingTagKey === trackingKey)
                        ?.trackingTagValues || []}
                        searchable
                        radius="sm"
                        size="sm"
                        mr={10}
                        onChange={(value) => handleTrackingTagValues(value, options.campaign_id, trackingKey, (trackingValue as any).array_id)}
                      />
                    </div>
                  );
                })}
              </div>
            )}
            {/*Custom Tag Dropdown*/}
            {options.customTagData && Object.entries(options.customTagData).length > 0 && ( 
              <div className="ads_network">
                <Text weight={500} mt={15}>Custom tags</Text>
                {Object.entries(options.customTagData).map(([customTagKey, customTagValue], CustomTagIndex) => {
                  const value = customTagValue as { dropdown_data: any[] };
                  return (
                    <div className="ads_network" style={{ display: 'flex', marginTop: '15px' }} key={CustomTagIndex}>
                      <Text color="red" mx={5} mt={4}>{customTagKey}</Text>
                      <MultiSelect
                        data={
                          value.dropdown_data && value.dropdown_data.length > 0
                            ? value.dropdown_data.map((dataValue) => ({ label: dataValue.value, value: dataValue.key }))
                            : [{ label: 'No matches found', value: '', disabled: true }]
                        }
                        value={selectedCustomTagData.find((data) => data.campaignid === options.campaign_id && data.customTagKey === customTagKey)
                        ?.customTagValues || []}
                        searchable
                        radius="sm"
                        size="sm"
                        mr={10}
                        onChange={(value) => handleCustomTagValues(value, options.campaign_id, customTagKey, (customTagValue as any).array_id)}
                      />
                    </div>
                  );
                })}
              </div>
            )}
            {/*Source Dropdown*/}
            {options.sourceData && options.sourceData.dropdown_data && (
              <div className="ads_network">
                <Text weight={500} mt={15}>Traffic Source</Text>
                <div className="ads_network" style={{ display: 'flex', marginTop: '15px' }}>
                  <Text color="red" mx={5} mt={4}>Traffic Source</Text>
                  <MultiSelect
                    data={options.sourceData.dropdown_data.map((sourceItem) => {
                      const item = sourceItem as { key: string; value: string; selected: string };
                      return {
                        label: item.value,
                        value: item.key
                      };
                    })}
                    value={selectedSourceData.find((data) => data.campaignid === options.campaign_id)
                        ?.sourceValues || []}
                    searchable
                    radius="sm"
                    size="sm"
                    mr={10}
                    onChange={(value) => handleSourceDataChange(options.campaign_id, value)}
                  />
                </div>
              </div>
            )}
            {/*Organic Traffic Dropdown*/}
            {options.organicTrafficData && Object.entries(options.organicTrafficData).length > 0 && ( 
              <div className="ads_network">
                <Text weight={500} mt={15}>Exclude Organic + Direct Traffic</Text>
                <div className="ads_network" style={{ display: 'flex', marginTop: '15px' }}>
                  <Text mt={4} mr={10}>Select Custom Tags: </Text>
                  <MultiSelect
                    data={options.organicTrafficData.exclude_organic_custom_tag?.dropdown_data && Object.entries(options.organicTrafficData.exclude_organic_custom_tag.dropdown_data).length > 0
                         ? Object.entries(options.organicTrafficData.exclude_organic_custom_tag.dropdown_data).map(
                              ([dataKey, dataValue]) => {
                                const item = dataValue as { key: string; value: string; selected: string };
                                return {
                                  label: item.value,
                                  value: item.key
                                };
                              })
                         : [{ label: 'No matches found', value: '', disabled: true }]
                    }
                    value={selectedOrganicCustomTag.find((data) => data.campaignid === options.campaign_id)
                        ?.selectedValues || []}
                    searchable
                    radius="sm"
                    size="sm"
                    mr={10}
                    onChange={(value) => handleOrganicCustomTagData(options.campaign_id, value)}
                  />
                  <Text mt={4} mx={10}>Select Tracking Tags: </Text>
                  <MultiSelect
                    data={options.organicTrafficData.exclude_organic_tracking_tag?.dropdown_data && Object.entries(options.organicTrafficData.exclude_organic_tracking_tag.dropdown_data).length > 0
                         ? Object.entries(options.organicTrafficData.exclude_organic_tracking_tag.dropdown_data).map(
                              ([dataKey, dataValue]) => {
                                const item = dataValue as { key: string; value: string; selected: string };
                                return {
                                  label: item.value,
                                  value: item.key
                                };
                              })
                         : [{ label: 'No matches found', value: '', disabled: true }]
                    }  
                    value={selectedOrganicTrackingTag.find((data) => data.campaignid === options.campaign_id)
                        ?.selectedValues || []}                 
                    searchable
                    radius="sm"
                    size="sm"
                    mr={10}
                    onChange={(value) => handleOrganicTrackingTagData(options.campaign_id, value)}
                  />
                </div>
              </div>
            )}
          </div>
        ))}            
        <Space h="xl"/>
        <Divider my="xs" mb={30} />
        {((reportId && reportId !== '') || updateReportId !== '') && (
        <div>
          <Group position="left">
            {showGraphCampaignDropdown && (
              <>
                <Text mt={4} mr={10}>Select Campaign: </Text>
                <Select
                  data={graphCampaignList.map((campaign) => ({
                    value: campaign.campaign_id,
                    label: campaign.campaign_name,
                  }))}
                  value={selectedGraphCampaign}
                  onChange={handleGraphCampaignChange}
                />  
              </>
            )}
            <Text mt={4} mr={10}>Select Graph: </Text>
            <Select
              data={[
                { value: '1', label: 'ROAS — All-Time Baseline vs Selected Range (7-day MA)'},
                { value: '2', label: 'Total Revenue vs Ad Spend (Stacked Bar)'},
                { value: '3', label: 'Parallel Growth (Cumulative Spend & Conversions) with ROAS Trend'},
                { value: '4', label: 'CPC, CPM, and CR Over Time'},
                { value: '5', label: 'Daily Efficiency — ROAS & CPA (Selected Range)'},
                { value: '6', label: 'Goal → Goal Conversion (Uniques)'},
                { value: '7', label: 'Velocity Report'},
              ]}
              sx={{ width: '20%' }}
              value={selectedGraphType}
              onChange={(value) => handleGraphChange(value, selectedGraphCampaign, firstFromValue, firstToValue, secondFromValue, secondToValue, allCampaignTableData, velocityFromValue, velocityToValue)}
            />
            <HelpTip helpId={0} />
            <Button disabled={!chartReady} onClick={downloadChart}>
              Export Chart as PNG
            </Button>
          </Group>
          <Box pos="relative">
            <LoadingOverlay visible={reportchartLoader} overlayBlur={2} loaderProps={{variant:"bars", color:"gray"}} />
              <div style={{ display: 'flex',marginBottom: 50}}>
                <Box style={{ width: '70%', marginTop: '1rem', textAlign: 'center' }}>
                  {selectedGraphType === '1' && (() => {
                    const formattedChartData: (string | Date | number | null)[][] = [
                      ["Date", "Selected Date Range ROAS", "All Time ROAS", "Selected Range ROAS (7-day MA)"],
                    ];
                    for (let i = 1; i < SelectedGraphData.length; i++) {
                      const [dateStr, selectedRoas, allRoas, maRoas] = SelectedGraphData[i];
                      const parsedDate = dateStr !== null ? new Date(dateStr) : new Date();

                      if (i === 1) {
                      formattedChartData.push([
                        parsedDate,
                          selectedRoas || 0,
                          allRoas || 0,
                          maRoas || 0,
                        ]);
                      } else {
                        formattedChartData.push([
                          parsedDate,
                          selectedRoas === null ? null : selectedRoas,
                          allRoas === null ? null : allRoas,
                          maRoas === null ? null : maRoas,
                        ]);
                      }
                    }
                    return(
                      <Box style={{ textAlign: "left" }}>
                        <Box ml={60}>
                          <Stack spacing={4} justify="flex-start">
                            <Text size="1rem" fw={500} c={colorTheme === "light" ? "#4D4D4D" : "white"}>
                              ROAS — All-Time Baseline vs Selected Range (7-day MA)
                            </Text>
                            <Text size="1rem" fw={400} c={colorTheme === "light" ? "#4D4D4D" : "white"}>
                              {chartTime} {allTimeRoasTitle}
                            </Text>
                          </Stack>
                        </Box>
                        {formattedChartData.length > 1 ? (
                          <Chart
                            chartType="LineChart"
                            data={formattedChartData}
                            options={{
                              interpolateNulls: false,
                              legend: {
                                position: 'bottom',
                                alignment: 'start',
                                textStyle: { color: colorTheme === "light" ? "black" : "white", fontSize: 16,
                                layout: 'vertical', },
                              },
                              colors: ['#FF9900', '#0000FF', '#008000'],
                              series: {
                                0: { lineDashStyle: [0], labelInLegend: 'Selected Date Range ROAS', color: '#FF0000' },
                                1: { lineDashStyle: [0], labelInLegend: 'All Time ROAS' },
                                2: { lineDashStyle: [4, 4], labelInLegend: 'Selected Range ROAS (7-day MA)' },
                              },
                              backgroundColor: colorTheme === "light" ? "#ffffff" : "#25262b",
                              chartArea: { top: 20, height: 'auto', width: '90%', left: '60' },
                              hAxis: { 
                                title: "Date",
                                format: "MM/dd/yyyy",
                                slantedText: true,
                                slantedTextAngle: 45,
                                textStyle: {
                                  color: colorTheme === "light" ? "black" : "white"
                                },
                                titleTextStyle: {
                                    color: colorTheme === "light" ? "black" : "white",
                                },
                                ticks: formattedChartData.slice(1).map(row => toSafeDate(row[0]))
                              },
                              vAxis: { 
                                title: "ROAS(x)",  
                                format: '0.00',
                                viewWindow: { min: 0 },
                                textStyle: {
                                  color: colorTheme === "light" ? "black" : "white"
                                },titleTextStyle: {
                                    color: colorTheme === "light" ? "black" : "white",
                                },
                                scaleType: 'log',
                              },
                            }}
                            getChartWrapper={(wrapper) => handleWrapperLoad(wrapper, '1')}
                            width="100%"
                            height="500px"
                          />
                        ) : (
                          <ReportChartStyle />
                        )}
                      </Box>
                    );
                  })()}
                  {selectedGraphType === '2' && 
                    <Box style={{ textAlign: "left" }}>
                      <Box ml={60}>
                        <Stack spacing={4} justify="flex-start">
                          <Text size="1rem" fw={500} c={colorTheme === "light" ? "#4D4D4D" : "white"}>
                            Total Revenue vs Ad Spend (Stacked Bar)
                          </Text>
                          <Text size="1rem" fw={400} c={colorTheme === "light" ? "#4D4D4D" : "white"}>
                            {chartTime}
                          </Text>
                        </Stack>
                      </Box>
                      {SelectedGraphData.length > 1 ? (
                        <Chart
                          chartType="ColumnChart"
                          data={SelectedGraphData}
                          options={{
                            isStacked: true,
                            legend: { position: 'bottom', alignment: 'center', layout: 'vertical',textStyle: {
                                color: colorTheme === "light" ? "black" : "white"
                              }},
                            bar: { groupWidth: "30%" },
                            colors: ['#FF0800', '#009000'],
                            backgroundColor: colorTheme === "light" ? "#ffffff" : "#25262b",
                            chartArea: { height: 'auto', width: '90%', top: '20', left: '60' },
                            hAxis: {
                              title: "Date",
                              format: "MM/dd/yyyy",
                              slantedText: true,
                              slantedTextAngle: 45,
                              textStyle: {
                                color: colorTheme === "light" ? "black" : "white"
                              },
                              titleTextStyle: {
                                  color: colorTheme === "light" ? "black" : "white",
                              }
                            },
                            vAxis: {
                              title: "Amount($)",
                              // scaleType: 'log',
                              textStyle: {
                                color: colorTheme === "light" ? "black" : "white"
                              },
                              titleTextStyle: {
                                  color: colorTheme === "light" ? "black" : "white",
                              }
                            },
                          }}
                          getChartWrapper={(wrapper) => handleWrapperLoad(wrapper, '2')}
                          style={{ width: '100%', height: '400px' }}
                        />
                      ) : (
                        <ReportChartStyle />
                      )}
                    </Box>
                  }
                  {selectedGraphType === '3' && (() => {
                    const roasValues = SelectedGraphData
                      .slice(1)
                      .map(row => row[3])
                      .filter(val => val !== null && !isNaN(val));

                    const minROAS = Math.min(...roasValues);
                    const maxROAS = Math.max(...roasValues);

                    return(
                      <Box style={{ textAlign: "left" }}>
                        <Box ml={60}>
                          <Stack spacing={4} justify="flex-start">
                            <Text size="1rem" fw={500} c={colorTheme === "light" ? "#4D4D4D" : "white"}>
                              Parallel Growth (Cumulative Spend & Conversions) with ROAS Trend
                            </Text>
                            <Text size="1rem" fw={400} c={colorTheme === "light" ? "#4D4D4D" : "white"}>
                              {chartTime}
                            </Text>
                          </Stack>
                        </Box>
                        {SelectedGraphData.length > 1 ? (
                          <Chart
                            chartType="ComboChart"
                            data={SelectedGraphData}
                            options={{
                              interpolateNulls: false,
                              legend: { textStyle: { color: colorTheme === "light" ? "#4D4D4D" : "white"}, position: 'bottom', alignment: 'start' },
                              chartArea: { height: 'auto', width: '90%', top: '20', left: '60' },
                              backgroundColor: colorTheme === "light" ? "#ffffff" : "#25262b",
                              hAxis: {
                                title: 'Date',
                                format: "MM/dd/yyyy",
                                slantedText: true,
                                slantedTextAngle: 45,
                                textStyle: {
                                  color: colorTheme === "light" ? "black" : "white"
                                },
                                titleTextStyle: {
                                    color: colorTheme === "light" ? "black" : "white",
                                },
                                ticks: SelectedGraphData.slice(1).map(row => toSafeDate(row[0]))
                              },
                              vAxes: {
                                0: { title: 'Cumulative Spend (USD) and Conversions',
                                  textStyle: {
                                    color: colorTheme === "light" ? "black" : "white"
                                  },
                                  titleTextStyle: {
                                      color: colorTheme === "light" ? "black" : "white",
                                  }},
                                1: { title: 'ROAS(x)',
                                      viewWindow: {
                                        min: Math.max(0, minROAS * 0.95),
                                        max: maxROAS * 1.05
                                      },
                                      textStyle: {
                                        color: colorTheme === "light" ? "black" : "white"
                                      },
                                      titleTextStyle: {
                                          color: colorTheme === "light" ? "black" : "white",
                                      },
                                      format: '0.00'
                                    },
                              },
                              series: {
                                0: { targetAxisIndex: 0, color: '#3357FF', lineWidth: 2 },
                                1: { targetAxisIndex: 0, color: '#33FF57', lineWidth: 2 },
                                2: { targetAxisIndex: 1, color: '#FF0000', lineWidth: 2, lineDashStyle: [4, 4] },
                              },
                            }}
                            getChartWrapper={(wrapper) => handleWrapperLoad(wrapper, '3')}
                            style={{ width: '100%', height: '500px' }}
                          />
                        ) : (
                          <ReportChartStyle />
                        )}
                      </Box>
                    );
                  })()}
                  {selectedGraphType === '4' && (() => {
                    const chartData: any[] = [
                      graphMetric === 'cpc' ? ['Date', 'CPC', 'CR'] : ['Date', 'CPM', 'CR']
                    ];
                    const startIndex = typeof SelectedGraphData[0]?.[0] === 'string' && isNaN(Date.parse(SelectedGraphData[0][0])) ? 1 : 0;
                    for (let i = startIndex; i < SelectedGraphData.length; i++) {
                      const row = SelectedGraphData[i];
                      const dateObj = typeof row[0] === 'string' ? new Date(row[0]) : row[0];
                      const newRow: any[] = [dateObj];
                      if (graphMetric === 'cpc') newRow.push(row[1] !== null ? Number(row[1]) : null);
                      if (graphMetric === 'cpm') newRow.push(row[2] !== null ? Number(row[2]) : null);
                      newRow.push(row[3] !== null ? Number(row[3]) : null);
                      chartData.push(newRow);
                    }
                    const filteredGraphData = chartData;

                    let leftAxisMin, leftAxisMax;
                    if (graphMetric === 'cpc') {
                      const cpcValues = SelectedGraphData.slice(startIndex).map((r) => r[1] !== null ? Number(r[1]) : null).filter((v) => v != null);
                      if (cpcValues.length > 0) {
                        const min = Math.min(...cpcValues);
                        const max = Math.max(...cpcValues);
                        const padding = (max - min) * 0.05;
                        leftAxisMin = min - padding;
                        leftAxisMax = max + padding;
                      }
                    }

                    const seriesConfig: any = {};
                    let colIndex = 0;
                    if (graphMetric === 'cpc') {
                      seriesConfig[colIndex++] = {
                        targetAxisIndex: 0,
                        color: "#3366CC",
                        lineWidth: 2,
                        pointSize: 5
                      };
                    }
                    if (graphMetric === 'cpm') {
                      seriesConfig[colIndex++] = {
                        targetAxisIndex: 0,
                        color: "#DC3912",
                        lineWidth: 2,
                        pointSize: 5
                      };
                    }
                    seriesConfig[colIndex++] = {
                      targetAxisIndex: 1,
                      color: "#FF9900",
                      lineWidth: 2,
                      lineDashStyle: [4, 4],
                      pointSize: 5
                    };

                    return(
                      <>
                        <Group spacing="xl" mt="xs">
                          <Text>Select Graph Metric : </Text>
                          <Radio.Group value={graphMetric} onChange={setGraphMetric}>
                            <Group mt="xs">
                              <Radio value="cpc" label="CPC" />
                              <Radio value="cpm" label="CPM" />
                            </Group>
                          </Radio.Group>
                        </Group>
                        <Box style={{ textAlign: "left" }}>
                          <Box ml={60}>
                            <Stack spacing={4} justify="flex-start">
                              <Text size="1rem" mt={10} fw={500} c={colorTheme === "light" ? "#4D4D4D" : "white"}>
                                CPC, CPM, and CR Over Time
                              </Text>
                              <Text size="1rem" fw={400} c={colorTheme === "light" ? "#4D4D4D" : "white"}>
                                {chartTime}
                              </Text>
                            </Stack>
                          </Box>
                          {filteredGraphData.length > 1 ? (
                            <Chart
                              chartType="LineChart"
                              data={filteredGraphData}
                              options={{
                                backgroundColor: colorTheme === "light" ? "#ffffff" : "#25262b",
                                legend: {
                                  position: 'bottom',
                                  alignment: 'start',
                                  textStyle: { color: colorTheme === "light" ? "#4D4D4D" : "white", fontSize: 16 },
                                  layout: 'vertical',
                                },
                                chartArea: { height: 'auto', width: '90%', top: '10', left: '60' },
                                hAxis: {
                                  title: 'Date',
                                  slantedText: true,
                                  slantedTextAngle: 45,
                                  textStyle: {
                                    color: colorTheme === "light" ? "black" : "white"
                                  },
                                  titleTextStyle: {
                                      color: colorTheme === "light" ? "black" : "white",
                                  },
                                  format: "MM/dd/yyyy",
                                  ticks: filteredGraphData.slice(1).map(row => {
                                    const dateValue = row[0];
                                    if (dateValue instanceof Date && !isNaN(dateValue.getTime())) {
                                      return dateValue;
                                    }
                                    return toSafeDate(dateValue);
                                  })
                                },
                                vAxes: {
                                  0: { title: "Cost ($)",
                                  viewWindow: { min: leftAxisMin, max: leftAxisMax },
                                  textStyle: {
                                    color: colorTheme === "light" ? "black" : "white"
                                  },
                                  titleTextStyle: {
                                      color: colorTheme === "light" ? "black" : "white",
                                  }},
                                  1: { title: "Conversion Rate (%)",
                                    textStyle: {
                                      color: colorTheme === "light" ? "black" : "white"
                                    },
                                    titleTextStyle: {
                                        color: colorTheme === "light" ? "black" : "white",
                                    }},
                                },
                                series: seriesConfig,
                              }}
                              getChartWrapper={(wrapper) => handleWrapperLoad(wrapper, '4')}
                              style={{ width: '100%', height: '500px' }}
                            />
                          ) : (
                            <ReportChartStyle />
                          )}
                        </Box>
                      </>
                    );
                  })()}
                  {selectedGraphType === '5' && (
                    <>
                      <Box style={{ textAlign: "left" }}>
                        <Box ml={60}>
                          <Stack spacing={4} justify="flex-start">
                            <Text size="1rem" mt={10} fw={500} c={colorTheme === "light" ? "#4D4D4D" : "white"}>
                              Daily Efficiency — ROAS & CPA (Selected Range)
                            </Text>
                            <Text size="1rem" fw={400} c={colorTheme === "light" ? "#4D4D4D" : "white"}>
                              {chartTime}
                            </Text>
                          </Stack>
                        </Box>
                        {chart_5_Data.length > 1 ? (
                          <Chart
                            chartType="LineChart"
                            width="100%"
                            height="350px"
                            data={chart_5_Data}
                            options={{
                              intervals: { style: "area" },
                              chartArea: { height: 'auto', width: '90%', top: '20' },
                              backgroundColor: colorTheme === "light" ? "#ffffff" : "#25262b",
                              // curveType: "function",
                              legend: { position: "bottom" },
                              interpolateNulls: false,
                              series: {
                                0: {
                                  targetAxisIndex: 0,
                                  lineDashStyle: [1, 0],
                                  pointSize: 2,
                                  lineWidth: 2,
                                },
                                1: {
                                  targetAxisIndex: 1,
                                  lineDashStyle: [4, 4],
                                  pointSize: 2,
                                  lineWidth: 2,
                                },
                                2: {
                                  targetAxisIndex: 0,
                                  lineDashStyle: [1, 0],
                                  pointSize: 2,
                                  lineWidth: 2,
                                },
                                3: {
                                  targetAxisIndex: 1,
                                  lineDashStyle: [4, 4],
                                  pointSize: 2,
                                  lineWidth: 2,
                                },
                              },
                              vAxes: {
                                0: { title: "CPA ($)",  ...(cpaRange ? { viewWindow: cpaRange } : {}), gridlines: { color: "#ccc" }, minValue: 0 },
                                1: { title: "ROAS (x)", ...(roasRange ? { viewWindow: roasRange } : {}), gridlines: { color: "transparent" }, format: "0.00" },
                              },
                              hAxis: {
                                title: "Date",
                                slantedText: true,
                                slantedTextAngle: 45,
                                textStyle: { color: colorTheme === "light" ? "black" : "white" },
                                titleTextStyle: { color: colorTheme === "light" ? "black" : "white" },
                                showTextEvery: 1,
                                format: "MM/dd/yyyy",
                                ticks: chart_5_Data.slice(1).map(row => toSafeDate(row[0]))
                              },
                              tooltip: { isHtml: false },
                            }}
                            formatters={[
                              {
                                type: "DateFormat",
                                column: 0,
                                options: { pattern: "MM-dd-yyyy" },
                              },
                            ]}
                            getChartWrapper={(wrapper) => handleWrapperLoad(wrapper, '5')}
                            style={{ width: '100%', height: '500px' }}
                          />
                        ) : (
                          <ReportChartStyle />
                        )}
                      </Box>
                    </>
                  )}
                  {selectedGraphType === '6' && (
                    <>
                      <Box style={{ textAlign: "left" }}>
                        <Box ml={60} mb={10}>
                          <Stack spacing={4} justify="flex-start">
                            <Text size="1rem" mt={10} fw={500} c={colorTheme === "light" ? "#4D4D4D" : "white"}>
                              Goal → Goal Conversion (Uniques)
                            </Text>
                            <Text size="1rem" fw={400} c={colorTheme === "light" ? "#4D4D4D" : "white"}>
                              {chartTime}
                            </Text>
                          </Stack>
                        </Box>
                        <Group spacing="md" align="center">
                          <Text size="md" weight={500}>
                            From:
                          </Text>
                          <Select
                            data={chartGoalDrop
                              .filter(goal => goal.goal_page_id !== firstToValue)
                              .map(goal => ({
                                value: goal.goal_page_id,
                                label: goal.goal_name,
                              }))
                            }
                            value={firstFromValue}
                            onChange={(e) => handleGraphGoalChange(e, 'firstFrom')}
                            withinPortal
                            maxDropdownHeight={280}
                            searchable
                            w={220}
                            styles={{ input: { cursor: "pointer" } }}
                          />

                          <IconArrowRight />
                          <Text size="md" weight={500}>
                            To:
                          </Text>
                          <Select
                            data={chartGoalDrop
                              .filter(goal => goal.goal_page_id !== firstFromValue && !goal.goal_name.startsWith("LP"))
                              .map(goal => ({
                                value: goal.goal_page_id,
                                label: goal.goal_name,
                              }))
                            }
                            value={firstToValue}
                            onChange={(e) => handleGraphGoalChange(e, 'firstTo')}
                            withinPortal
                            maxDropdownHeight={280}
                            searchable
                            w={220}
                            styles={{ input: { cursor: "pointer" } }}
                          />
                        </Group>
                        <Group spacing="md" align="center" mt={10}>
                          <Text size="md" weight={500}>
                            From:
                          </Text>
                          <Select
                            data={chartGoalDrop
                              .filter(goal => goal.goal_page_id !== secondToValue)
                              .map(goal => ({
                                value: goal.goal_page_id,
                                label: goal.goal_name,
                              }))
                            }
                            onChange={(e) => handleGraphGoalChange(e, 'secondFrom')}
                            value={secondFromValue}
                            withinPortal
                            maxDropdownHeight={280}
                            searchable
                            w={220}
                            styles={{ input: { cursor: "pointer" } }}
                          />

                          <IconArrowRight />
                          <Text size="md" weight={500}>
                            To:
                          </Text>
                          <Select
                            data={chartGoalDrop
                              .filter(goal => goal.goal_page_id !== secondFromValue && !goal.goal_name.startsWith("LP"))
                              .map(goal => ({
                                value: goal.goal_page_id,
                                label: goal.goal_name,
                              }))
                            }
                            value={secondToValue}
                            onChange={(e) => handleGraphGoalChange(e, 'secondTo')}
                            withinPortal
                            maxDropdownHeight={280}
                            searchable
                            w={220}
                            styles={{ input: { cursor: "pointer" } }}
                          />
                        </Group>
                        {SelectedGraphData.length !== 0 && (
                          <Chart
                            chartType="BarChart"
                            width="100%"
                            height="300px"
                            data={SelectedGraphData}
                            options={{
                              chartArea: { left: 180, top: 20, right: 100, bottom: 40 },
                              isStacked: false,
                              bars: "horizontal",
                              bar: {
                                groupWidth: "80%",
                              },
                              backgroundColor: colorTheme === "dark" ? "#1f1f1f" : "#fff",
                              annotations: {
                                alwaysOutside: false,
                                textStyle: {
                                  fontSize: 12,
                                  color: "#fff",
                                },
                              },
                              legend: { position: "none" },
                              hAxis: {
                                title: "Unique visitors",
                                titleTextStyle: {
                                  color: colorTheme === "dark" ? "#e0e0e0" : "#000",
                                },
                                textStyle: {
                                  color: colorTheme === "dark" ? "#b0b0b0" : "#000",
                                },
                                gridlines: {
                                  color: colorTheme === "dark" ? "#404040" : "#e0e0e0",
                                },
                                minValue: 0,
                                scaleType: 'log'
                              },
                              vAxis: {
                                textStyle: {
                                  color: colorTheme === "dark" ? "#b0b0b0" : "#000",
                                },
                              },
                              colors: ["#1976d2", "#ff7043", "transparent"],
                              series: {
                                0: { color: "#1976d2" },
                                1: { color: "#ff7043" },
                                2: {
                                  color: "transparent",
                                  annotations: {
                                    style: "point",
                                    textStyle: {
                                      fontSize: 18,
                                      color: colorTheme === "dark" ? "#fff" : "#000",
                                      bold: true,
                                    },
                                  },
                                },
                              },
                            }}
                            getChartWrapper={(wrapper) => handleWrapperLoad(wrapper, '6')}
                          />
                        )}
                      </Box>
                    </>
                  )}
                  {selectedGraphType === '7' && (
                    <>
                      <Box style={{ textAlign: "left" }}>
                        <Box ml={60}>
                          <Stack spacing={4} justify="flex-start">
                            <Text size="1rem" mt={10} fw={500} c={colorTheme === "light" ? "#4D4D4D" : "white"}>
                              {velocityFromLabel !== '' && velocityToLabel !== '' ? velocityFromLabel + ' → ' + velocityToLabel : 'First Click → Goal'}
                            </Text>
                            <Text size="1rem" fw={400} c={colorTheme === "light" ? "#4D4D4D" : "white"}>
                              {chartTime}
                            </Text>
                          </Stack>
                        </Box>
                        <Group spacing="md" align="center" mt={10}>
                          <Text size="md" weight={500}>
                            From:
                          </Text>
                          <Select
                            data={chartGoalDrop
                              .filter(goal => goal.goal_page_id !== velocityToValue)
                              .map(goal => ({
                                value: goal.goal_page_id,
                                label: goal.goal_name,
                              }))
                            }
                            value={velocityFromValue}
                            onChange={setVelocityFromValue}
                            withinPortal
                            maxDropdownHeight={280}
                            searchable
                            w={220}
                            styles={{ input: { cursor: "pointer" } }}
                          />

                          <IconArrowRight />
                          <Text size="md" weight={500}>
                            To:
                          </Text>
                          <Select
                            data={chartGoalDrop
                              .filter((goal, goalIndex) => goal.goal_page_id !== velocityFromValue && goalIndex !== 0)
                              .map(goal => ({
                                value: goal.goal_page_id,
                                label: goal.goal_name,
                              }))
                            }
                            value={velocityToValue}
                            onChange={setVelocityToValue}
                            withinPortal
                            maxDropdownHeight={280}
                            searchable
                            w={220}
                            styles={{ input: { cursor: "pointer" } }}
                          />
                        </Group>
                        <Chart
                          chartType="ColumnChart"
                          width="100%"
                          height="400px"
                          data={SelectedGraphData}
                          options={{
                            legend: { position: "none" },
                            bar: { groupWidth: "55%" },
                            animation: {
                              startup: true,
                              duration: 800,
                              easing: "easeOut",
                            },
                            backgroundColor: "transparent",
                            tooltip: { isHtml: true },
                            chartArea: { width: "85%", height: "75%" },
                            hAxis: {
                              slantedText: true,
                              slantedTextAngle: 45,
                              title: "Conversions",
                              showTextEvery: 1,
                              textStyle: { fontSize: 13, color: "#495057", bold: false },
                              titleTextStyle: { fontSize: 15, bold: true, color: "#212529" },
                              gridlines: { color: "#e9ecef" },
                            },
                            vAxis: {
                              title: "Velocity Bucket",
                              textStyle: { fontSize: 13, color: "#495057", fontWeight: 500 },
                              titleTextStyle: { fontSize: 15, bold: true, color: "#212529" },
                              minValue: 0,
                              gridlines: { color: "#EEEEEE" },
                            },
                          }}
                          getChartWrapper={(wrapper) => handleWrapperLoad(wrapper, '7')}
                          style={{ width: '100%', height: '650px' }}
                        />
                      </Box>
                    </>
                  )}
                </Box>
                <Box style={{ width: '30%', marginTop: '1rem' }}>
                  <Chart
                    chartType="PieChart"
                    data={pieChartSourceDataArray}
                    width={"100%"}
                    height={"300px"}
                    options={pieChartOptions}
                  />
                </Box>
            </div>
          </Box>
        </div>
        )}
        <Space h="xl"/>
        <Flex align="center" justify="space-between" w="100%">
          <Box>
            <SelectMetrics
              generalColumns={generalColumns}
              setGeneralColumns={setGeneralColumns}
              goalColumns={goalColumns}
              setGoalColumns={setGoalColumns}
              trafficSourceColumns={trafficSourceColumns}
              setTrafficSourceColumns={setTrafficSourceColumns}
              organicTrafficMetricsColumns={organicTrafficMetricsColumns}
              sourceMetricsColumns={sourceMetricsColumns}
              setSourceMetricsColumns={setSourceMetricsColumns}
              conversionGoalOptions={conversionGoalOptions}
              setOrganicTrafficColumns={setOrganicTrafficColumns}
              setSourceColumns={setSourceColumns}
              setCustomTagColumns={setCustomTagColumns}
              setTrackingTagColumns={setTrackingTagColumns}
              setCampaignColumns={setCampaignColumns}
              // setIsSaveMetrics={setIsSaveMetrics}
              testVariationColumns={testVariationColumns}
              setTestVariationColumns={setTestVariationColumns}
              trafficFunnelMetricsColumns={trafficFunnelMetricsColumns}
              setTrafficFunnelMetricsColumns={setTrafficFunnelMetricsColumns}
              organicTrafficDataTable={organicTrafficDataTable}
            />
          </Box>
          <Box ml="md">
            <Benchmarks
              report_id={reportId || updateReportId}
              campaign_id={selectedVisioptCampaign}
              comparison_campaign_id={comparisonVisiCampaign}
              getBenchmarks={handleBenchmarksClick}
            />
          </Box>
          <Box ml="md">
            <Popover
              opened={breakdownPopoverOpen}
              onChange={(o) => {
                if (!o) {
                  // Closing without Save — discard the pending change so the popover reflects the
                  // committed value next time the user opens it.
                  setPendingBreakdown(breakdownSelection);
                }
                setBreakdownPopoverOpen(o);
              }}
              position="bottom-start"
              withArrow
              shadow="md"
              closeOnClickOutside
              width={300}
            >
              <Popover.Target>
                <Button color="teal" onClick={() => {
                  // Re-sync pending to committed when opening, so the radio always shows the truth.
                  setPendingBreakdown(breakdownSelection);
                  setBreakdownPopoverOpen((o) => !o);
                }}>
                  Breakdown
                </Button>
              </Popover.Target>
              <Popover.Dropdown>
                <Radio.Group
                  value={pendingBreakdown}
                  onChange={(v) => setPendingBreakdown(v as 'none' | 'device' | 'hour' | 'cust_type')}
                  label="Breakdown by"
                  description="Select one breakdown to view sub-rows under each row in traffic source table"
                >
                  <Stack mt="xs" spacing="xs">
                    <Radio value="none" label="None" />
                    <Radio value="device" label="Device Type" />
                    <Radio value="hour" label="Time" />
                    <Radio value="cust_type" label="Customer Type" />
                  </Stack>
                </Radio.Group>
                <Group position="right" mt="md" spacing="xs">
                  <Button variant="default" size="xs" onClick={() => {
                    setPendingBreakdown(breakdownSelection);
                    setBreakdownPopoverOpen(false);
                  }}>
                    Cancel
                  </Button>
                  <Button color="teal" size="xs" onClick={() => {
                    // Commit the pending selection, close, and refetch the report with the new
                    // breakdown_type so the SQL shape and rendered sub-rows update immediately.
                    if (pendingBreakdown !== breakdownSelection) {
                      setBreakdownSelection(pendingBreakdown);
                      fetchTrafficTableData({
                        report_id: reportId || updateReportId,
                        breakdown_type: pendingBreakdown,
                      });
                    }
                    setBreakdownPopoverOpen(false);
                  }}>
                    Save
                  </Button>
                </Group>
              </Popover.Dropdown>
            </Popover>
          </Box>
          <Box ml="auto">
            <Button color="orange" onClick={handleExportData}>
              Export Report
            </Button>
          </Box>
        </Flex>

        {allCampaignTableData.map((campaignData, index) => (
          <>
            {/*Main Campaign Table*/}
            <Table striped highlightOnHover withBorder my={15} fontSize="xs" style={{tableLayout: 'fixed'}} withColumnBorders>   
              <thead>
                <tr>
                  {generalColumns.length > 0 &&
                    generalColumns
                    .filter(traffic => traffic.show === true)
                    .map((dataColumns, index) => (
                      <th key={index}>{dataColumns.value}</th>
                    ))}
                </tr>
              </thead>
              <tbody>
                <tr>
                  {generalColumns
                    .filter(traffic => traffic.show === true)
                    .map((dataColumns, colIndex) => (
                    <td
                      key={colIndex}
                      style={{ width: 200, cursor: "pointer" }}
                      onClick={() => handleCampaignClick(campaignData.campaign_id)}
                    >
                      {campaignData.campaignTableData[dataColumns.key] !== undefined
                        ? campaignData.campaignTableData[dataColumns.key]
                        : null}
                    </td>
                  ))}
                </tr>
                {trafficSourceData.length > 0 && trafficSourceData.map((data, index) => data.key === campaignData.campaign_id && data.show === true ? (
                  <>
                  <tr>
                    <td colSpan={generalColumnsLength.length}>
                    <SimpleBar forceVisible="x" autoHide={false} style={{paddingBottom : '12px'}}> 
                          <table>
                            <tbody>
                              <tr>
                                {campaignData.campaignGoalBlocksTableData && campaignData.campaignGoalBlocksTableData.map((goal, index) => {
                                  return (
                                    <>
                                      {index !== 0 && <div className="page-arrow" style={{ marginTop: "75%" }} />}
                                      {goalCards(goal.custom_title, goal.uniques,goal.visits,goal.visiopt_conversions, goal.ucr, goal.gcr, goal.thumb, goal.unique_percentage)}
                                    </>
                                  );
                                })}
                              </tr>
                            </tbody>
                          </table>
                    </SimpleBar>
                    </td>
                  </tr>
                  <tr style={{display:''}}>
                    <td colSpan={generalColumnsLength.length}>
                      {/*Goal Tables*/}
                      {showGoalTable && showGoalTable.map((goals) => 
                        goals.campaignid === campaignData.campaign_id && goals.show === true ? (
                          <>
                            <Card radius="sm" withBorder style={{ position: 'relative' }}>
                                {showTableByIcons && showTableByIcons.map((table) => 
                                  table.campaign_id === campaignData.campaign_id && table.tableName === "goals" ? (
                                    <>
                                      <div style={{ display: 'flex', alignItems: 'center', position: 'absolute', top: 0, left: 5, cursor: 'pointer', width: '100%' }} onClick={() => handleShowIcons(campaignData.campaign_id, 'goals')}>
                                        <Title order={6} weight={500} color={colorTheme === "light" ? '#262323' : 'white'}>Goals</Title>
                                        {table.show && <IconCaretDownFilled />}
                                        {!table.show && <IconCaretRightFilled />}
                                      </div>
                                      {table.show && (
                                        <div style={{ marginLeft: '-10px', marginTop: '20px' }}>
                                          {campaignData.campaignGoalTableData && campaignData.campaignGoalTableData?.map((goalTable, goalIndex) => (
                                            <Table striped highlightOnHover withBorder my={5} fontSize="xs" key={goalIndex} style={{ width: '100%', tableLayout: 'fixed' }} withColumnBorders>
                                            <thead>
                                              <tr>
                                                {goalColumns.length > 0 && goalColumns.find(data => data.key === "visi_goal_name" && data.show === true) && (
                                                  <th style={{ width: '10%', textAlign: 'left' }}>{Object.keys(goalTable)[0]}</th>
                                                )}
                                                {goalColumns.length > 0 && goalColumns
                                                  .slice(1)
                                                  .filter(traffic => traffic.show === true)
                                                  .map((columnData, colIndex) => (
                                                    <th key={colIndex} style={{ textAlign: 'left' }}>
                                                      {columnData.value}
                                                    </th>
                                                ))}
                                              </tr>
                                            </thead>
                                            <tbody>
                                              <tr>
                                                {goalColumns.length > 0 && goalColumns.find(data => data.key === "visi_goal_name" && data.show === true) && (
                                                  <>
                                                    {goalTable['campaign_goal_type'] !== 'button' && (
                                                      <td onClick={() => handleCustomerJourneyOpenModal(campaignData.campaign_id,goalTable,goalTable[Object.keys(goalTable)[0]],"goal")} style={{ cursor: 'pointer', textAlign: 'left' }}>
                                                        {goalTable[Object.keys(goalTable)[0]]}
                                                      </td>
                                                    )}
                                                    {goalTable['campaign_goal_type'] === 'button' && (
                                                      <td>{goalTable[Object.keys(goalTable)[0]]}</td>
                                                    )}
                                                  </>
                                                )}
                                                {goalColumns
                                                  .slice(1)
                                                  .filter(traffic => traffic.show === true)
                                                  .map((columnData, colIndex) => (
                                                    <td key={colIndex} style={{ textAlign: 'left' }}>
                                                      {goalTable[columnData.key] !== undefined ? goalTable[columnData.key] : null}
                                                    </td>
                                                ))}
                                              </tr>
                                              {/* Customer Type. The report marks a goal eligible only when its
                                                  webhook counts as a purchase and it has conversions to split,
                                                  so no other goal offers the link. */}
                                              {goalTable['customer_type_available'] === 1 && (() => {
                                                const ctKey = `${campaignData.campaign_id}|goal|${goalIndex}`;
                                                const ctOpen = campaignGoalCtOpen.includes(ctKey);
                                                const ctRows = campaignGoalCt[ctKey]?.rows;
                                                const shown = goalColumns.filter(t => t.show === true);
                                                /* Name the goal in the link and indent the whole block, so it is obvious
                                                   which goal the breakdown belongs to. */
                                                const ctGoalName = String(Object.keys(goalTable)[0]).replace('Goal - ', '');
                                                const ctAccent = `3px solid ${colorTheme === 'light' ? '#ced4da' : '#4a4d55'}`;
                                                const ctBg = colorTheme === 'light' ? '#edf5ff' : '#2c3847';
                                                return (
                                                  <>
                                                    <tr>
                                                      <td colSpan={shown.length} style={{ textAlign: 'left', borderLeft: ctAccent, paddingLeft: 18 }}>
                                                        <Anchor
                                                          component="button"
                                                          type="button"
                                                          fz={11}
                                                          fw={500}
                                                          underline={false}
                                                          aria-expanded={ctOpen}
                                                          aria-label={`${ctOpen ? 'Hide' : 'Show'} Customer Type breakdown for ${ctGoalName}`}
                                                          disabled={campaignGoalCtLoading !== null}
                                                          onClick={() => toggleCampaignGoalCustomerType(ctKey, campaignData.campaign_id, goalTable['campaign_goal_id'], goalTable['campaign_goal_type'])}
                                                          style={{ display: 'flex', alignItems: 'center', gap: 2 }}
                                                        >
                                                          {ctOpen ? <IconChevronDown size="0.75rem" /> : <IconChevronRight size="0.75rem" />}
                                                          {campaignGoalCtLoading === ctKey ? 'Loading…' : 'Customer Type'}
                                                          <span style={{ opacity: 0.65, fontWeight: 400 }}>&nbsp;·&nbsp;{ctGoalName}</span>
                                                        </Anchor>
                                                      </td>
                                                    </tr>
                                                    {ctOpen && campaignGoalCtBody(ctKey, ctRows, shown.length, ctBg)}
                                                    {ctOpen && campaignGoalCtRows(ctKey, ctRows).map((ct: any, ci: number) => (
                                                      <tr key={`ctb-${goalIndex}-${ci}`} style={{ background: ctBg }}>
                                                        {/* This table has no separate conversions column: the first column's
                                                            value IS the count, headed by the goal name. So the split reads in
                                                            that same column, under the number it divides. */}
                                                        <td style={{ textAlign: 'left', paddingLeft: 18, fontStyle: 'italic', opacity: 0.9 }}>
                                                          &#8627; {ct.customer_type_name}&nbsp;&mdash;&nbsp;<strong>{ct.conversions}</strong>
                                                        </td>
                                                        {shown.slice(1).map((columnData, ci2) => (
                                                          <td key={ci2} style={{ textAlign: 'left' }}>
                                                            {ctMetric(columnData.key, ct, ctNum(goalTable[Object.keys(goalTable)[0]]), goalTable)}
                                                          </td>
                                                        ))}
                                                      </tr>
                                                    ))}
                                                  </>
                                                );
                                              })()}
                                            </tbody>
                                          </Table>
                                          ))}
                                          <Button
                                            size="xs"
                                            radius="sm"
                                            variant="light"
                                            leftIcon={<IconChartBar size={14} />}
                                            sx={(theme) => ({
                                              fontSize: 14,
                                              fontWeight: 600,
                                              border: `1px solid ${theme.colors.indigo[5]}`,
                                              color: theme.colors.indigo[6],
                                              backgroundColor: theme.colors.indigo[0],
                                              transition: "all 0.2s ease"
                                            })}
                                            onClick={() => handleAnalyzeLifecycleOpenModal(campaignData.campaign_id)}
                                          >
                                            Analyze Lifecycle
                                          </Button>
                                        </div>
                                      )}
                                    </>
                                  ) : null
                                  )}
                            </Card>
                          </>
                        ) : null
                      )} 
                      {/*Test Variation Tables*/}
                      {showTestVariation && showTestVariation.map((variations) => 
                        variations.campaignid === campaignData.campaign_id && variations.show === true ? (
                          <Card radius="sm" withBorder style={{ position: 'relative' }}>                              
                                {showTableByIcons && showTableByIcons.map((table) => 
                                  table.campaign_id === campaignData.campaign_id && table.tableName === "variation" ? (
                                    <>
                                      <div style={{ display: 'flex', alignItems: 'center', position: 'absolute', top: 0, left: 5, cursor: 'pointer', width: '100%' }} onClick={() => handleShowIcons(campaignData.campaign_id, 'variation')}>
                                        <Title order={6} weight={500} color={colorTheme === "light" ? '#262323' : 'white'}>Goals</Title>
                                        {table.show && <IconCaretDownFilled />}
                                        {!table.show && <IconCaretRightFilled />}
                                      </div>
                                      {table.show && (
                                        <div style={{ marginLeft: '-10px', marginTop: '20px' }}>
                                          {Object.entries(campaignData.campaignGoalTableData)?.map(([goalName, goalData], goalIndex) => {
                                            const testTrafficUniques = (goalData as any)?.test_traffic_uniques;
                                            const goalEntries = Object.entries(goalData).filter(([key]) => isVariationGroupKey(key));
                                            return (
                                            <>
                                              {goalEntries.map(([variationName, variationData], variationIndex) => (
                                                <Table striped highlightOnHover withBorder my={5} fontSize="xs" key={variationIndex} withColumnBorders>
                                                  <thead>
                                                    <tr>
                                                      <th colSpan={testVariationColumns.filter(traffic => traffic.show === true).length} style={{ backgroundColor: colorTheme === "light" ? '#E4E9ED' : '#7b7f83'}}>
                                                        {variationName}
                                                      </th>
                                                    </tr>
                                                    <tr>
                                                      {testVariationColumns
                                                        .filter(traffic => traffic.show === true)
                                                        .map((column, columnIndex) => (
                                                          <th key={columnIndex}>
                                                            <span style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
                                                              {column.value}
                                                              {column.key === 'goal_cpg' && (
                                                                <Tooltip
                                                                  label={"Blended from total campaign spend. For comparing versions only\u2026 not actual CPA."}
                                                                  withArrow
                                                                  multiline
                                                                  w={330}
                                                                  position="right"
                                                                >
                                                                  <ActionIcon variant="subtle" size="sm" color="gray" aria-label="Estimated CPA info">
                                                                    <IconInfoCircle size={14} />
                                                                  </ActionIcon>
                                                                </Tooltip>
                                                              )}
                                                            </span>
                                                          </th>
                                                        ))}
                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                    {(variationData && Array.isArray(variationData) && variationData.length > 0) ? (
                                                      variationData.filter((rowData) => rowData['variation'] !== 'Total').map((rowData, rowIndex) => {
                                                        /* Cache is per goal, so opening a second variation costs no request.
                                                           Open state is per ROW, so expanding one variation leaves the others
                                                           collapsed - the two keys must not be the same. */
                                                        const ctCacheKey = `${campaignData.campaign_id}|var|${goalName}|${variationName}`;
                                                        const ctKey = `${ctCacheKey}|${rowIndex}`;
                                                        const ctOpen = campaignGoalCtOpen.includes(ctKey);
                                                        const shownCols = testVariationColumns.filter(traffic => traffic.show === true);
                                                        const ctBg = colorTheme === 'light' ? '#edf5ff' : '#2c3847';
                                                        /* Match on the variation number, not the row position - the endpoint returns
                                                           only variations that have conversions, so positions do not line up. */
                                                        const ctVariations = campaignGoalCt[ctCacheKey]?.variations;
                                                        const ctRows = Array.isArray(ctVariations)
                                                          ? ctVariations.find((v: any) => Number(v?.variation_no) === Number(rowData['variation_no'] ?? (rowIndex + 1)))?.customer_type_rows
                                                          : undefined;
                                                        const ctEligible = rowData['customer_type_available'] === 1;
                                                        return (
                                                        <React.Fragment key={rowIndex}>
                                                        <tr>
                                                          {shownCols
                                                            .map((column, columnIndex) => (
                                                              <td
                                                                key={columnIndex}
                                                                onClick={() => {
                                                                  if (column.key === 'variation') {
                                                                    handleVariationNameClick(rowData, campaignData.campaign_id);
                                                                  } else if (column.key === 'Conversion') {
                                                                    handleCustomerJourneyOpenModal(campaignData.campaign_id, rowData, rowData[column.key], "test_variation");
                                                                  }
                                                                }}
                                                                style={{ cursor:'pointer', ...(column.key === 'variation' ? { color: colorTheme === 'light' ? '#000' : '#c7bdbd', textDecoration: 'underline' } : {}) }}
                                                              >
                                                                {rowData[column.key]}
                                                                {column.key === 'variation' && ctEligible && (
                                                                  <Anchor
                                                                    component="button"
                                                                    type="button"
                                                                    fz={11}
                                                                    fw={500}
                                                                    underline={false}
                                                                    aria-expanded={ctOpen}
                                                                    disabled={campaignGoalCtLoading !== null}
                                                                    onClick={(e: any) => { e.stopPropagation(); toggleCampaignGoalCustomerType(ctKey, campaignData.campaign_id, rowData['campaign_goal_id'], rowData['campaign_goal_type'], ctCacheKey); }}
                                                                    style={{ display: 'flex', alignItems: 'center', gap: 2, marginTop: 2 }}
                                                                  >
                                                                    {ctOpen ? <IconChevronDown size="0.75rem" /> : <IconChevronRight size="0.75rem" />}
                                                                    {campaignGoalCtLoading === ctKey ? 'Loading…' : 'Customer Type'}
                                                                  </Anchor>
                                                                )}
                                                              </td>
                                                            ))}
                                                        </tr>
                                                        {/* Both helpers look the goal's fetched state up by key, so they must be given
                                                            the CACHE key. ctKey is the per-row open key (cacheKey|rowIndex) and has no
                                                            entry of its own under test variations - passing it here returned no rows and
                                                            no message, so the block rendered empty even though the request had succeeded. */}
                                                        {ctOpen && rowIndex === 0 && campaignGoalCtBody(ctCacheKey, ctRows, shownCols.length, ctBg)}
                                                        {ctOpen && campaignGoalCtRows(ctCacheKey, ctRows).map((ct: any, ci: number) => (
                                                          <tr key={`ct-${rowIndex}-${ci}`} style={{ background: ctBg }}>
                                                            {shownCols.map((column, columnIndex) => (
                                                              <td key={columnIndex} style={{ fontWeight: 400 }}>
                                                                {column.key === 'variation'
                                                                  ? <span style={{ paddingLeft: 14, fontStyle: 'italic', opacity: 0.9 }}>&#8627; {ct.customer_type_name}</span>
                                                                  : column.key === 'Conversion' ? ct.conversions
                                                                  : ctMetric(column.key, ct, ctNum(rowData['Conversion']), rowData)}
                                                              </td>
                                                            ))}
                                                          </tr>
                                                        ))}
                                                        </React.Fragment>
                                                        );
                                                      })
                                                    ) : (
                                                      <tr>
                                                        <td colSpan={testVariationColumns.filter(traffic => traffic.show === true).length}>
                                                          No data available
                                                        </td>
                                                      </tr>
                                                    )}
                                                  </tbody>
                                                </Table>
                                              ))}
                                              {testTrafficUniques && (
                                                <div style={{ fontSize: '12px', fontWeight: 600, color: colorTheme === 'light' ? '#555' : '#cfbbbb', marginTop: '4px', marginBottom: '8px', display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                                                  <span>Test Traffic: {testTrafficUniques} uniques</span>
                                                </div>
                                              )}
                                            </>
                                            );
                                          })}
                                          <Button
                                            size="xs"
                                            radius="sm"
                                            variant="light"
                                            leftIcon={<IconChartBar size={14} />}
                                            sx={(theme) => ({
                                              fontSize: 14,
                                              fontWeight: 600,
                                              border: `1px solid ${theme.colors.indigo[5]}`,
                                              color: theme.colors.indigo[6],
                                              backgroundColor: theme.colors.indigo[0],
                                              transition: "all 0.2s ease"
                                            })}
                                            onClick={() => handleAnalyzeLifecycleOpenModal(campaignData.campaign_id)}
                                          >
                                            Analyze Lifecycle
                                          </Button>
                                        </div>
                                      )}
                                    </>
                                  ) : null
                                )}
                            </Card>
                        ) : null
                      )}
                      {/*Source Table*/}
                      {campaignData.trafficTableData && Object.entries(campaignData.trafficTableData).length > 0 &&
                        <>
                          {campaignData.trafficTableData.source && Object.entries(campaignData.trafficTableData.source).length > 0 && sourceDataTable[campaignData.campaign_id]?.data !== undefined && sourceDataTable[campaignData.campaign_id]?.data.length > 0 &&
                            <>
                              <Card radius="sm" withBorder style={{ position: 'relative', marginTop: '10px' }}>                              
                                {showTableByIcons && showTableByIcons.map((table) => {
                                  if(table.campaign_id === campaignData.campaign_id && table.tableName === "source"){
                                    const sourceSelectedColumns: any[] = getSelectedColumns(sourceColumns[campaignData.campaign_id]?.filter(col => col.show), sourceDataTable[campaignData.campaign_id]?.data);

                                    return(
                                      <>
                                        <div style={{ display: 'flex', alignItems: 'center', position: 'absolute', top: 0, left: 5, cursor: 'pointer', width: '100%' }} onClick={() => handleShowIcons(campaignData.campaign_id, 'source')}>
                                          <Title order={6} weight={500} color={colorTheme === "light" ? '#262323' : 'white'}>Traffic Source</Title>
                                          {table.show && <IconCaretDownFilled />}
                                          {!table.show && <IconCaretRightFilled />}
                                        </div>
                                        {table.show && (
                                          <SimpleBar autoHide={false} style={{paddingBottom : '12px'}}> 
                                            <div style={{ minWidth: '1500px', marginLeft: '-10px', marginTop: '20px' }}>
                                              <Table striped highlightOnHover withBorder my={5} fontSize="xs" withColumnBorders style={{ borderCollapse: 'separate', borderSpacing: '0px', marginLeft: '6px' }}>
                                                <thead>
                                                  <tr>
                                                    {sourceSelectedColumns?.map((column, columnIndex) => {
                                                      const isColor = showColumnColor.find(d => d.campaignid === campaignData.campaign_id && d.tableName === 'source' && d.columnName === column.key && d.show === true);
                                                      const sourceStickyStyle = getCustomTrackingSourceStickyStyle(column.key, 'c_r_source_name', isColor);
                                                      const column_value = campaignData.trafficTableData.source?.th?.[column.key];
                                                      return(
                                                        <th
                                                          key={columnIndex}
                                                          draggable={column.key !== 'c_r_source_name'}
                                                          onDragStart={column.key !== 'c_r_source_name' ? (e) => {
                                                              const fullIndex = sourceColumns[campaignData.campaign_id]?.findIndex(col => col.key === column.key);
                                                              handleDragStart(e, fullIndex, 'source', campaignData.campaign_id);
                                                            } : undefined}
                                                          onDrop={column.key !== 'c_r_source_name' ? (e) => handleDrop(e, columnIndex) : undefined}
                                                          onDragOver={column.key !== 'c_r_source_name' ? (e) => e.preventDefault() : undefined}
                                                          onClick={(e) => handleSorting(column.key, 'source', campaignData.campaign_id)}
                                                          style={sourceStickyStyle}
                                                        >
                                                          <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                                                              {column_value}{(() => {
                                                                const campaignSortConfig = sortConfig[campaignData.campaign_id] || [];
                                                                const tableSortConfig = campaignSortConfig.filter(config => config.table === 'source');
                                                                const sort = tableSortConfig.find(config => config.key === column.key);

                                                                if (sort) {
                                                                  return sort.direction === 'ascending' ? <IconCaretUpFilled /> : <IconCaretDownFilled />;
                                                                }
                                                              })()}
                                                            </span>
                                                        </th>
                                                      );
                                                    })}
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  {sourceDataTable[campaignData.campaign_id]?.data.map((rowData, rowIndex) => (
                                                      <tr 
                                                        key={rowIndex}
                                                        style={campaignData.trafficTableData.source.td.length > 1 && rowIndex === campaignData.trafficTableData.source.td.length - 1 ? { fontWeight: 'bold' } : {}}
                                                      >
                                                        {sourceSelectedColumns?.map((column, columnIndex) => {
                                                          const isColor = showColumnColor.find(d => d.campaignid === campaignData.campaign_id && d.tableName === 'source' && d.columnName === column.key && d.show === true);
                                                          const sourceStickyStyle = getCustomTrackingSourceStickyStyle(column.key, 'c_r_source_name', isColor);
                                                          return(
                                                            <td
                                                              onClick={() => {
                                                                if (column.key.includes('_visiopt_conversions') && rowData['c_r_source_name'] !== 'Total') {
                                                                  handleCustomerJourneyOpenModal(campaignData.campaign_id, rowData, rowData[column.key], "source", column.key);
                                                                }
                                                                handleColumnDataClicked(campaignData.campaign_id, 'source', column.key);
                                                              }}
                                                              style={sourceStickyStyle}
                                                            >{rowData[column.key]}</td>
                                                          );
                                                        })}
                                                      </tr>
                                                  ))}
                                                </tbody>
                                              </Table>
                                            </div>
                                          </SimpleBar> 
                                        )}
                                      </>
                                    );
                                  }
                                  return null;
                                })}
                            </Card>
                            </>
                          }
                          {/*Tracking Tag Table*/}
                          {campaignData.trafficTableData.tracking_tag && Object.entries(campaignData.trafficTableData.tracking_tag).length > 0 && trackingTagDataTable[campaignData.campaign_id]?.data !== undefined && trackingTagDataTable[campaignData.campaign_id]?.data.length > 0  && 
                              <Card radius="sm" withBorder style={{ position: 'relative', marginTop: '10px' }}>                              
                                {showTableByIcons && showTableByIcons.map((table) => {
                                  if(table.campaign_id === campaignData.campaign_id && table.tableName === "trackingTag"){
                                    const trackingSelectedColumns: any[] = getSelectedColumns(trackingTagColumns[campaignData.campaign_id]?.filter((column) => column.key !== 'c_r_source_name' && column.show === true), trackingTagDataTable[campaignData.campaign_id]?.data);

                                    return(
                                      <>
                                        <div style={{ display: 'flex', alignItems: 'center', position: 'absolute', top: 0, left: 5, cursor: 'pointer', width: '100%' }} onClick={() => handleShowIcons(campaignData.campaign_id, 'trackingTag')}>
                                          <Title order={6} weight={500} color={colorTheme === "light" ? '#262323' : 'white'}>Tracking Tag</Title>
                                          {table.show && <IconCaretDownFilled />}
                                          {!table.show && <IconCaretRightFilled />}
                                        </div>
                                        {table.show && (
                                         <SimpleBar autoHide={false} style={{paddingBottom : '12px'}}> 
                                            <div style={{ minWidth: '1500px', marginLeft: '-10px', marginTop: '20px' }}>
                                              <Table striped highlightOnHover withBorder my={5} fontSize="xs" withColumnBorders style={{ borderCollapse: 'separate', borderSpacing: '0px', marginLeft: '6px'}}>
                                                <thead>
                                                  <tr>
                                                    {trackingSelectedColumns.map((column, columnIndex) => {
                                                      const isColor = showColumnColor.find(d => d.campaignid === campaignData.campaign_id && d.tableName === 'tracking_tag' && d.columnName === column.key && d.show === true);
                                                      const trackingStickyStyle = getCustomTrackingSourceStickyStyle(columnIndex, 0, isColor);
                                                      const column_value = campaignData.trafficTableData.tracking_tag?.th?.[column.key];
                                                      return(
                                                        <th
                                                          key={columnIndex}
                                                          draggable={columnIndex !== 0}
                                                          onDragStart={columnIndex !== 0 ? (e) => {
                                                              const fullIndex = trackingTagColumns[campaignData.campaign_id]?.filter((column) => column.key !== 'c_r_source_name').findIndex(col => col.key === column.key);
                                                              handleDragStart(e, fullIndex, 'tracking_tag', campaignData.campaign_id);
                                                            } : undefined}
                                                          onDrop={columnIndex !== 0 ? (e) => handleDrop(e, columnIndex) : undefined}
                                                          onDragOver={columnIndex !== 0 ? (e) => e.preventDefault() : undefined}
                                                          onClick={(e) => handleSorting(column.key, 'tracking_tag', campaignData.campaign_id, campaignData.trafficTableData.tracking_tag.th[0])}
                                                          style={trackingStickyStyle}
                                                        >
                                                          <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                                                            {column_value}{(() => {
                                                              const campaignSortConfig = sortConfig[campaignData.campaign_id] || [];
                                                              const tableSortConfig = campaignSortConfig.filter(config => config.table === 'tracking_tag');
                                                              const sort = tableSortConfig.find(config => config.key === column.key);

                                                              if (sort) {
                                                                return sort.direction === 'ascending' ? <IconCaretUpFilled /> : <IconCaretDownFilled />;
                                                              }
                                                            })()}
                                                          </span>
                                                        </th>
                                                      );
                                                    })}
                                                  </tr>
                                                </thead>
                                                <tbody>                              
                                                  {trackingTagDataTable[campaignData.campaign_id]?.data.map((rowData, rowIndex) => (
                                                      <tr
                                                        key={rowIndex}
                                                        style={campaignData.trafficTableData.tracking_tag.td.length > 1 && rowIndex === campaignData.trafficTableData.tracking_tag.td.length - 1 ? { fontWeight: 'bold' } : {}}
                                                      >
                                                        {trackingSelectedColumns.map((columnData, columnIndex) => {
                                                          const isColor = showColumnColor.find(d => d.campaignid === campaignData.campaign_id && d.tableName === 'tracking_tag' && d.columnName === columnData.key && d.show === true);
                                                          const trackingStickyStyle = getCustomTrackingSourceStickyStyle(columnIndex, 0, isColor);
                                                          return(
                                                            <td
                                                              onClick={() => {
                                                                if (columnData.key.includes('_visiopt_conversions')) {
                                                                  if(!Object.values(rowData).includes("Total")) {
                                                                    handleCustomerJourneyOpenModal(campaignData.campaign_id, rowData, rowData[columnData.key], "tracking_tag", columnData.key);
                                                                  }                                                
                                                                }
                                                                handleColumnDataClicked(campaignData.campaign_id, 'tracking_tag', columnData.key)
                                                              }}
                                                              style={trackingStickyStyle}
                                                            >{rowData[columnData.key] !== '' ? rowData[columnData.key] : '-'}</td>
                                                          );
                                                        })}
                                                      </tr>
                                                  ))}
                                                </tbody>
                                              </Table>
                                            </div>
                                          </SimpleBar>
                                        )}
                                      </>
                                    );
                                  }
                                  return null;
                                })}
                            </Card>
                          }
                          {/*Custom Tag Tables*/}
                          {campaignData.trafficTableData.custom_tag && Object.entries(campaignData.trafficTableData.custom_tag.th).length > 0 &&
                            <>
                             <Card radius="sm" withBorder style={{ position: 'relative', marginTop: '10px' }}>                              
                                {showTableByIcons && showTableByIcons.map((table) => 
                                  table.campaign_id === campaignData.campaign_id && table.tableName === "customTag" ? (
                                    <>
                                      <div style={{ display: 'flex', alignItems: 'center', position: 'absolute', top: 0, left: 5, cursor: 'pointer', width: '100%' }} onClick={() => handleShowIcons(campaignData.campaign_id, 'customTag')}>
                                        <Title order={6} weight={500} color={colorTheme === "light" ? '#262323' : 'white'}>Custom Tag</Title>
                                        {table.show && <IconCaretDownFilled />}
                                        {!table.show && <IconCaretRightFilled />}
                                      </div>
                                      {table.show && (
                                        <SimpleBar autoHide={false} style={{paddingBottom : '12px'}}> 
                                          <div style={{ minWidth: '1500px', marginLeft: '-10px', marginTop: '20px' }}>
                                            {Object.entries(campaignData.trafficTableData.custom_tag.th)?.map((customTagName, customTagIndex) => {
                                              if(customTagDataTable[campaignData.campaign_id]?.[customTagName[0]]?.length > 0){
                                                /*FETCH ONLY THOSE COLUMNS WHICH ARE IN ROW*/
                                                const customColumns: any[] = [];
                                                const addedKeys = new Set();
                                                customTagColumns[campaignData.campaign_id]?.[customTagName[0]]?.filter(column => column.show === true)?.forEach((col) => {
                                                  customTagDataTable[campaignData.campaign_id]?.[customTagName[0]].forEach((rowdata) => {
                                                    const matchingKey = Object.keys(rowdata).find((key) => key.toLowerCase().includes(col.key.toLowerCase()));
                                                    if (matchingKey && !addedKeys.has(col.key)) {
                                                      customColumns.push({ key: col.key, value: col.value });
                                                      addedKeys.add(col.key);
                                                    }
                                                  });
                                                });

                                                return(
                                                  <Table striped highlightOnHover withBorder my={5} fontSize="xs" withColumnBorders style={{ borderCollapse: 'separate', borderSpacing: '0px', marginLeft: '6px'}}>
                                                    <thead>
                                                      <tr>                                      
                                                        {customColumns.map((column, columnIndex) => {
                                                          const isColor = showColumnColor.find(d => d.campaignid === campaignData.campaign_id && d.tableName === 'custom_tag' && d.columnName === column.key && d.show === true);
                                                          const customStickyStyle = getCustomTrackingSourceStickyStyle(columnIndex, 0, isColor);
                                                          const entries = Object.entries(campaignData.trafficTableData.custom_tag?.th?.[customTagName[0]] || {});
                                                          const match = entries.find(([key]) => key.toLowerCase().includes(column.key.toLowerCase()));
                                                          const column_value = match ? match[1] : '';
                                                          return(
                                                            <th
                                                              key={columnIndex}
                                                              draggable={columnIndex !== 0}
                                                              onDragStart={columnIndex !== 0 ? (e) => {
                                                                const fullIndex = customTagColumns[campaignData.campaign_id]?.[customTagName[0]]?.findIndex(col => col.key === column.key);
                                                                handleDragStart(e, fullIndex, 'custom_tag', campaignData.campaign_id);
                                                              } : undefined}
                                                              onDrop={columnIndex !== 0 ? (e) => handleDrop(e, columnIndex, customTagName[0]) : undefined}
                                                              onDragOver={columnIndex !== 0 ? (e) => e.preventDefault() : undefined}
                                                              onClick={(e) => handleSorting(column.key, 'custom_tag', campaignData.campaign_id, customTagName[0])}
                                                              style={customStickyStyle}
                                                            >
                                                              <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                                                                <>
                                                                  {column_value}{(() => {
                                                                    const campaignSortConfig = sortConfig[campaignData.campaign_id] || [];
                                                                    const tableSortConfig = campaignSortConfig.filter(config => config.table === 'custom_tag');
                                                                    const sort = tableSortConfig.find(config => config.key === column.key && config.totalKeyName === customTagName[0]);

                                                                    if (sort) {
                                                                      return sort.direction === 'ascending' ? <IconCaretUpFilled /> : <IconCaretDownFilled />;
                                                                    }
                                                                  })()}
                                                                </>
                                                              </span>
                                                            </th>
                                                          );
                                                        })}
                                                      </tr>
                                                    </thead>
                                                    <tbody>
                                                      {customTagDataTable[campaignData.campaign_id]?.[customTagName[0]]?.map((rowData, rowIndex) => (
                                                        <tr
                                                          key={rowIndex}
                                                          style={
                                                            customTagDataTable[campaignData.campaign_id][customTagName[0]].length > 1 && rowIndex === customTagDataTable[campaignData.campaign_id][customTagName[0]].length - 1
                                                              ? { fontWeight: 'bold' }
                                                              : {}
                                                          }
                                                        >                      
                                                          {customColumns.map((columnData, columnIndex) => {
                                                            const isColor = showColumnColor.find(d => d.campaignid === campaignData.campaign_id && d.tableName === 'custom_tag' && d.columnName === columnData.key && d.show === true);
                                                            const customStickyStyle = getCustomTrackingSourceStickyStyle(columnIndex, 0, isColor);
                                                            const matchedKey = Object.keys(rowData).find((key) => key.toLowerCase().includes(columnData.key.toLowerCase()));
                                                            const columnValue = matchedKey ? rowData[matchedKey] : '';
                                                            return(
                                                            <td
                                                              key={columnIndex}
                                                              onClick={() => {
                                                                if (columnData.key.includes('_visiopt_conversions') && rowData[customTagName[0]] !== 'Total') {
                                                                  handleCustomerJourneyOpenModal(campaignData.campaign_id, rowData, columnValue, "custom_tag", columnData.key, '', '', '', customTagName[0]);
                                                                }
                                                                handleColumnDataClicked(campaignData.campaign_id, 'custom_tag', columnData.key);
                                                              }}
                                                              style={customStickyStyle}
                                                            >{columnValue}</td>
                                                          );
                                                          })}
                                                        </tr>
                                                      ))}
                                                    </tbody>
                                                  </Table>
                                                );
                                              }
                                            })}
                                          </div>
                                        </SimpleBar>
                                      )}
                                    </>
                                  ) : null
                                )}
                            </Card>
                            </>
                          }
                        </>
                      }
                      </td>
                  </tr>
                  </>
                ) : null
                )}
              </tbody>
            </Table>
          </>
        ))}
        {Object.entries(campaignCombineDataTable).length > 0 && (
         <Table striped highlightOnHover withBorder my={15} fontSize="xs" withColumnBorders>   
            <thead>
              <tr>
                {generalColumns.length > 0 &&
                  generalColumns
                  .filter(traffic => traffic.show === true)
                  .map((dataColumns, index) => (
                    <th key={index}>{dataColumns.value}</th>
                  ))}
              </tr>
            </thead>
            <tbody>
              <tr>
                {generalColumns
                  .filter(traffic => traffic.show === true)
                  .map((dataColumns, colIndex) => (
                  <td
                    key={colIndex}
                    style={{ width: 200, cursor: "pointer" }}
                  >
                  {campaignCombineDataTable[dataColumns.key] !== undefined
                      ? campaignCombineDataTable[dataColumns.key]
                      : null}
                  </td>
                ))}
              </tr>
            </tbody>
          </Table>
        )}
        {allTrafficSourceData && Object.keys(allTrafficSourceData).length > 0 && (
          <>
            <Card radius="sm" withBorder style={{ position: 'relative', marginTop: '10px' }}>
              <div style={{ display: 'flex', alignItems: 'center', position: 'absolute', top: 0, left: 5, cursor: 'pointer', width: '100%' }} onClick={handleToggleTrafficSource}>
                <Title order={6} weight={500} color={colorTheme === "light" ? "#262323" : "white" }>Traffic Source</Title>
                {showTrafficTables && <IconCaretDownFilled />}
                {!showTrafficTables && <IconCaretRightFilled />}
              </div>
              {showTrafficTables && (
                  <div style={{ marginLeft: '-10px', marginTop: '20px' }}>
                    <Accordion variant="contained" value={openedAccordion} onChange={(e) => handleaccordianChange(e)}>
                      {Object.entries(allTrafficSourceData).map(([trafficName, trafficData], trafficSourceName) => {
                        const trafficConfig = trafficSourceConfig[trafficName];
                        // Guard: a network present in the data but missing from trafficSourceConfig (e.g. taboola) would crash on trafficConfig.icon.
                        if (!trafficConfig) { return null; }

                        return (
                          <>
                            <Accordion.Item value={trafficName}>
                              <Accordion.Control>
                                <Group spacing="xs" align="center">
                                  {trafficConfig.icon}
                                  <Text fw={500} size="md" c={trafficConfig.color}>
                                    {trafficConfig.label}
                                  </Text>
                                </Group>
                              </Accordion.Control>
                              <Accordion.Panel>
                                {trafficName === 'chatgpt' ? (
                                  chatgptTrafficSourceTable(trafficData)
                                ) : (
                                <>
                                {funnelBlocksRow(trafficName)}
                                {/*Facebook Button*/}
                                {showBacktoCampButton.length > 0 && showBacktoCampButton.map((data, index) => data.trafficName === trafficName ? (
                                    <Button size="xs" compact mr={10} onClick={() => handleRemoveCampaignBackButton(trafficName)}>
                                        Back to {trafficName} campaign
                                      </Button>
                                  ) : null
                                )}
                                {showBacktoAdsetButton.length > 0 && showBacktoAdsetButton.map((data, index) => data.trafficName === trafficName ? (
                                    <Button size="xs" compact mr={10} onClick={() => handleRemoveAdsetBackButton(trafficName)}>
                                        Back to {trafficName} Adset
                                      </Button>
                                  ) : null
                                )}
                                {/*TRAFFIC SOURCE CAMPAIGN TABLE*/}
                                {showTrafficSourceTable && showTrafficSourceTable.map((traffic) => 
                                  traffic.show === true && traffic.trafficName === trafficName ? (
                                    trafficSourceTable(trafficName, trafficName)
                                  ) : null
                                )}
                                {/*TRAFFIC SOURCE ADSET TABLE*/}
                                {showAdsetTable && showAdsetTable.map((adset) => 
                                  adset.show === true && adset.trafficName === trafficName ? (
                                    trafficSourceAdsetTable(trafficName, `${trafficName}Adset`)
                                  ) : null
                                )}
                                {/*TRAFFIC SOURCE ADS TABLE*/}
                                {showAdsTable && showAdsTable.map((ads) => 
                                  ads.show === true && ads.trafficName === trafficName ? (
                                    trafficSourceAdsTable(trafficName, `${trafficName}Ads`)
                                  ) : null
                                )}
                                </>
                                )}
                              </Accordion.Panel>
                            </Accordion.Item>
                          </>
                        );
                      })}
                    </Accordion>
                  </div>
              )}
            </Card>
          </>
        )}
        {/*Organic Traffic Table*/}
        {organicTrafficDataTable && Object.keys(organicTrafficDataTable).length > 0 &&
          <Card radius="sm" withBorder style={{ position: 'relative', marginTop: '10px' }}> 
            <div style={{ display: 'flex', alignItems: 'center', position: 'absolute', top: 0, left: 5, cursor: 'pointer', width: '100%' }} onClick={() => handleOrganicOpen() }>
              <Title order={6} weight={500} color={colorTheme === "light" ? '#262323' : 'white'}>Organic + Direct Traffic</Title>
              {showOrganicTrafficTable && <IconCaretDownFilled />}
              {!showOrganicTrafficTable && <IconCaretRightFilled />}
            </div>
            {showOrganicTrafficTable && (
              <div style={{ marginLeft: '-10px', marginTop: '20px' }}>
                {Object.entries(organicTrafficDataTable).map(([campaign_name, tableData], index) => {
                  const organicColumns = organicTrafficColumns[campaign_name]?.filter(col => col.show && tableData?.organic_traffic?.td?.hasOwnProperty(col.key));
                  return(
                    <>
                      <Title order={6} weight={500} color={colorTheme === "light" ? '#262323' : 'white'} key={campaign_name} ml={5} style={{ fontSize: '15px'}}>{campaign_name}</Title>
                      <SimpleBar forceVisible="x" autoHide={false} style={{paddingBottom : '12px'}}> 
                        <Table striped highlightOnHover withBorder my={5} fontSize="xs" withColumnBorders>
                          <thead>
                            <tr>
                              {organicColumns?.map((column, columnIndex) => {
                                const fullIndex = organicTrafficColumns[campaign_name]?.findIndex(col => col.key === column.key);
                                return(
                                  <th 
                                    key={columnIndex}
                                    draggable
                                    onDragStart={(e) => handleDragStart(e, fullIndex, 'organicTraffic', campaign_name)}
                                    onDrop={(e) => handleDrop(e, fullIndex)}
                                    onDragOver={(e) => e.preventDefault()}
                                    style={{ cursor:'pointer', backgroundColor: 'inherit', whiteSpace: 'nowrap' }}
                                  >
                                    <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                                      {column.value}
                                    </span>
                                  </th>
                                );
                              })}
                            </tr>
                          </thead>
                          <tbody>
                            {/* Organic (a known referring site) and Direct (no referring site) rows */}
                            {['organic_traffic', 'direct_traffic'].filter((rowKey) => tableData?.[rowKey]?.td).map((rowKey) => (
                              <tr key={rowKey}>
                                {organicColumns?.map((column, columnIndex) => (
                                  <td
                                    key={columnIndex}
                                    onClick={() => {
                                      if (column.key.includes('visiopt_conversions') && tableData[rowKey].td['goalname'] !== 'Total') {
                                         handleCustomerJourneyOpenModal(tableData[rowKey].td['campaign_id'], tableData[rowKey].td, tableData[rowKey].td[column.key], rowKey, column.key);
                                      }
                                    }}
                                    style={{ cursor:'pointer', backgroundColor: 'inherit' }}
                                  >{tableData[rowKey].td[column.key]}</td>
                                ))}
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </SimpleBar>
                    </>
                  );
                })}
              </div>
            )}
          </Card>
        }
        <Space h="xl"/>
        <div>
          {showUpdateButton && <Button onClick={() => handleUpdateReport('update')}>Update Report</Button> }          
          <Button color="teal" ml={showUpdateButton ? 10 : 0} onClick={handleSaveReport}>
            Save Report
          </Button>
          <Button color="red" ml={10} onClick={handleCancelReport}>
           Cancel
          </Button>
        </div>
      </Card>
    </Container>
  </>
  );
}
